import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-white dark:bg-[#0c1427]/95 font-sans min-h-screen" }
const _hoisted_2 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center bg-white dark:bg-[#0c1427] backdrop-blur-sm modal"
}
const _hoisted_3 = { class: "flex flex-col items-center justify-center text-center" }
const _hoisted_4 = { class: "text-lg font-semibold text-gray-900 dark:text-white mb-2" }
const _hoisted_5 = { class: "text-sm text-gray-500 dark:text-gray-400 max-w-xs mx-auto" }
const _hoisted_6 = { class: "mt-6 space-y-2 text-xs text-gray-400" }
const _hoisted_7 = { class: "flex items-center justify-center space-x-2" }
const _hoisted_8 = { class: "flex items-center justify-center space-x-2" }
const _hoisted_9 = { class: "flex items-center justify-center space-x-2" }
const _hoisted_10 = {
  key: 1,
  class: "mobile-toggle-fixed"
}
const _hoisted_11 = { class: "view-toggle-slider" }
const _hoisted_12 = { class: "slider-track" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "slider-labels" }
const _hoisted_15 = { class: "label-left" }
const _hoisted_16 = { class: "label-right" }
const _hoisted_17 = {
  key: 2,
  class: "max-w-7xl mx-auto p-6"
}
const _hoisted_18 = { class: "grid grid-cols-1 lg:grid-cols-4 gap-6 calendar-container-height" }
const _hoisted_19 = { class: "p-4 border-b border-gray-100 dark:border-gray-700" }
const _hoisted_20 = { class: "flex items-center justify-between" }
const _hoisted_21 = { class: "flex items-center gap-3" }
const _hoisted_22 = { class: "relative" }
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = {
  class: "font-medium text-gray-900 dark:text-white",
  style: {"margin-bottom":"0px !important"}
}
const _hoisted_25 = { class: "p-4 border-b border-gray-100 dark:border-gray-700" }
const _hoisted_26 = { class: "text-center mb-3" }
const _hoisted_27 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_28 = {
  class: "flex justify-between items-center mt-2",
  style: {"margin-top":"-33px !important"}
}
const _hoisted_29 = { class: "grid grid-cols-7 gap-1 text-xs" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "p-4 border-b border-gray-100 dark:border-gray-700" }
const _hoisted_32 = { class: "flex items-center justify-between mb-3" }
const _hoisted_33 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_34 = { class: "space-y-2" }
const _hoisted_35 = { class: "flex items-center gap-3" }
const _hoisted_36 = ["checked"]
const _hoisted_37 = { class: "text-sm text-gray-700 dark:text-gray-300" }
const _hoisted_38 = { class: "text-xs bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 px-2 py-1 rounded-full" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "flex items-center gap-3" }
const _hoisted_41 = ["checked", "onChange"]
const _hoisted_42 = { class: "text-sm text-gray-700 dark:text-gray-300" }
const _hoisted_43 = { class: "text-xs bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 px-2 py-1 rounded-full" }
const _hoisted_44 = { class: "p-4" }
const _hoisted_45 = { class: "flex items-center justify-between mb-3" }
const _hoisted_46 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_47 = { class: "space-y-2" }
const _hoisted_48 = {
  key: 0,
  class: "loading-state text-center py-4"
}
const _hoisted_49 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_50 = { class: "text-sm text-gray-700 dark:text-gray-300" }
const _hoisted_51 = { class: "text-xs bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 px-2 py-1 rounded-full" }
const _hoisted_52 = {
  key: 2,
  class: "empty-state text-center py-4"
}
const _hoisted_53 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_54 = { class: "mobile-modal-header" }
const _hoisted_55 = { class: "header-content" }
const _hoisted_56 = { class: "mobile-settings-nav" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { class: "mobile-modal-body" }
const _hoisted_59 = {
  key: 0,
  class: "mobile-settings-tab"
}
const _hoisted_60 = { class: "mobile-setting-group" }
const _hoisted_61 = { class: "mobile-group-header" }
const _hoisted_62 = {
  key: 0,
  class: "mobile-loading-state"
}
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { class: "mobile-setting-row" }
const _hoisted_65 = { class: "mobile-setting-info" }
const _hoisted_66 = { class: "mobile-setting-desc" }
const _hoisted_67 = { class: "mobile-switch" }
const _hoisted_68 = {
  key: 0,
  class: "mobile-working-hours"
}
const _hoisted_69 = { class: "mobile-day-info" }
const _hoisted_70 = { class: "mobile-day-checkbox" }
const _hoisted_71 = ["onUpdate:modelValue"]
const _hoisted_72 = { class: "mobile-day-name" }
const _hoisted_73 = {
  key: 0,
  class: "mobile-time-controls"
}
const _hoisted_74 = ["onUpdate:modelValue"]
const _hoisted_75 = ["onUpdate:modelValue"]
const _hoisted_76 = { class: "mobile-actions" }
const _hoisted_77 = ["disabled"]
const _hoisted_78 = {
  key: 0,
  class: "ri-loader-5-line animate-spin"
}
const _hoisted_79 = {
  key: 1,
  class: "ri-save-line"
}
const _hoisted_80 = {
  key: 1,
  class: "mobile-settings-tab"
}
const _hoisted_81 = { class: "mobile-setting-group" }
const _hoisted_82 = { class: "mobile-group-header" }
const _hoisted_83 = {
  key: 0,
  class: "mobile-loading-state"
}
const _hoisted_84 = {
  key: 1,
  class: "mobile-breaks-list"
}
const _hoisted_85 = { class: "mobile-break-header" }
const _hoisted_86 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_87 = {
  key: 1,
  class: "mobile-break-name"
}
const _hoisted_88 = { class: "mobile-break-actions" }
const _hoisted_89 = ["onClick", "onTouchend", "title"]
const _hoisted_90 = ["onClick", "onTouchend", "title", "disabled"]
const _hoisted_91 = {
  key: 0,
  class: "mobile-break-edit-form"
}
const _hoisted_92 = { class: "mobile-break-time" }
const _hoisted_93 = ["onUpdate:modelValue"]
const _hoisted_94 = { class: "mobile-break-time" }
const _hoisted_95 = ["onUpdate:modelValue"]
const _hoisted_96 = { class: "mobile-break-days" }
const _hoisted_97 = { class: "mobile-form-label" }
const _hoisted_98 = { class: "mobile-days-grid" }
const _hoisted_99 = ["onUpdate:modelValue", "value"]
const _hoisted_100 = { class: "mobile-break-buttons" }
const _hoisted_101 = ["onClick", "onTouchend", "disabled"]
const _hoisted_102 = {
  key: 0,
  class: "ri-loader-5-line animate-spin"
}
const _hoisted_103 = {
  key: 1,
  class: "ri-save-line"
}
const _hoisted_104 = ["onClick", "onTouchend"]
const _hoisted_105 = {
  key: 2,
  class: "mobile-settings-tab"
}
const _hoisted_106 = { class: "mobile-setting-group" }
const _hoisted_107 = { class: "mobile-group-header" }
const _hoisted_108 = {
  key: 0,
  class: "mobile-loading-state"
}
const _hoisted_109 = {
  key: 1,
  class: "mobile-types-list"
}
const _hoisted_110 = { class: "mobile-type-header" }
const _hoisted_111 = { class: "mobile-type-info" }
const _hoisted_112 = {
  key: 0,
  class: "mobile-type-name"
}
const _hoisted_113 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_114 = {
  key: 2,
  class: "mobile-type-duration"
}
const _hoisted_115 = { class: "mobile-type-actions" }
const _hoisted_116 = ["onClick", "onTouchend", "title"]
const _hoisted_117 = ["onClick", "onTouchend", "title"]
const _hoisted_118 = {
  key: 0,
  class: "mobile-type-edit-form"
}
const _hoisted_119 = { class: "mobile-form-group" }
const _hoisted_120 = { class: "mobile-form-label" }
const _hoisted_121 = { class: "mobile-duration-control" }
const _hoisted_122 = ["onClick", "onTouchend"]
const _hoisted_123 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_124 = ["onClick", "onTouchend"]
const _hoisted_125 = { class: "mobile-form-group" }
const _hoisted_126 = { class: "mobile-form-label" }
const _hoisted_127 = { class: "mobile-color-grid" }
const _hoisted_128 = ["onClick", "onTouchend", "title"]
const _hoisted_129 = { class: "mobile-form-actions" }
const _hoisted_130 = ["onClick", "onTouchend", "disabled"]
const _hoisted_131 = ["onClick", "onTouchend", "disabled"]
const _hoisted_132 = {
  key: 0,
  class: "ri-loader-5-line animate-spin"
}
const _hoisted_133 = {
  key: 1,
  class: "ri-save-line"
}
const _hoisted_134 = { class: "p-4 border-b border-gray-100 dark:border-gray-700 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4" }
const _hoisted_135 = { class: "flex items-center gap-4" }
const _hoisted_136 = {
  class: "text-xl font-semibold text-gray-900 dark:text-white",
  style: {"margin-bottom":"0px !important"}
}
const _hoisted_137 = { class: "flex gap-2" }
const _hoisted_138 = { class: "flex flex-wrap items-center gap-2 lg:gap-3" }
const _hoisted_139 = { class: "hidden sm:inline" }
const _hoisted_140 = { class: "sm:hidden" }
const _hoisted_141 = {
  key: 0,
  class: "p-4"
}
const _hoisted_142 = { class: "grid grid-cols-7 gap-1 mb-4" }
const _hoisted_143 = { class: "hidden lg:inline" }
const _hoisted_144 = { class: "lg:hidden" }
const _hoisted_145 = {
  class: "grid grid-cols-7 gap-1",
  style: {"grid-template-rows":"repeat(6, minmax(80px, 1fr))"}
}
const _hoisted_146 = ["onClick"]
const _hoisted_147 = { class: "mt-1 space-y-1" }
const _hoisted_148 = ["onClick"]
const _hoisted_149 = { class: "font-medium text-xs flex items-center gap-1" }
const _hoisted_150 = ["title"]
const _hoisted_151 = {
  key: 0,
  class: "text-xs hidden lg:block"
}
const _hoisted_152 = {
  key: 1,
  class: "p-2 lg:p-4 space-y-4"
}
const _hoisted_153 = ["onClick"]
const _hoisted_154 = { class: "text-xs font-medium mb-1 opacity-80" }
const _hoisted_155 = { class: "text-sm lg:text-lg font-bold" }
const _hoisted_156 = { class: "border-r border-gray-200 dark:border-gray-600" }
const _hoisted_157 = ["onClick", "onDragover", "onDrop"]
const _hoisted_158 = ["onDragstart", "onClick"]
const _hoisted_159 = { class: "font-medium text-xs mb-1" }
const _hoisted_160 = { class: "font-semibold text-xs flex items-center gap-1" }
const _hoisted_161 = ["title"]
const _hoisted_162 = {
  key: 0,
  class: "flex items-center gap-1 text-xs opacity-80 mt-1"
}
const _hoisted_163 = { class: "truncate" }
const _hoisted_164 = ["title"]
const _hoisted_165 = { class: "modal-header-clean" }
const _hoisted_166 = { class: "header-content" }
const _hoisted_167 = { class: "header-text-clean" }
const _hoisted_168 = { class: "modal-body-clean dark:bg-gray-700" }
const _hoisted_169 = { class: "event-detail-content dark:bg-gray-700" }
const _hoisted_170 = { class: "detail-section dark:bg-gray-700" }
const _hoisted_171 = { class: "detail-row-clean dark:bg-gray-700" }
const _hoisted_172 = { class: "detail-info" }
const _hoisted_173 = { class: "detail-label" }
const _hoisted_174 = { class: "detail-value" }
const _hoisted_175 = { class: "detail-row-clean" }
const _hoisted_176 = { class: "detail-info" }
const _hoisted_177 = { class: "detail-label" }
const _hoisted_178 = { class: "detail-value" }
const _hoisted_179 = {
  key: 0,
  class: "detail-row-clean"
}
const _hoisted_180 = { class: "detail-info" }
const _hoisted_181 = { class: "detail-label" }
const _hoisted_182 = { class: "detail-value" }
const _hoisted_183 = {
  key: 1,
  class: "detail-row-clean"
}
const _hoisted_184 = { class: "detail-info" }
const _hoisted_185 = { class: "detail-label" }
const _hoisted_186 = { class: "detail-value" }
const _hoisted_187 = {
  key: 2,
  class: "detail-row-clean"
}
const _hoisted_188 = { class: "detail-info" }
const _hoisted_189 = { class: "detail-label" }
const _hoisted_190 = { class: "detail-value" }
const _hoisted_191 = {
  key: 0,
  class: "participants-section"
}
const _hoisted_192 = { class: "section-title" }
const _hoisted_193 = { class: "participants-grid" }
const _hoisted_194 = { class: "participant-details" }
const _hoisted_195 = { class: "participant-name" }
const _hoisted_196 = {
  key: 0,
  class: "participant-email"
}
const _hoisted_197 = {
  key: 1,
  class: "participant-phone"
}
const _hoisted_198 = { class: "modal-footer-clean" }
const _hoisted_199 = { class: "modal-header-clean" }
const _hoisted_200 = { class: "header-content" }
const _hoisted_201 = { class: "header-text-clean" }
const _hoisted_202 = { class: "modal-body-clean" }
const _hoisted_203 = { class: "form-row" }
const _hoisted_204 = { class: "form-group" }
const _hoisted_205 = { class: "form-label" }
const _hoisted_206 = { class: "input-group" }
const _hoisted_207 = ["placeholder"]
const _hoisted_208 = { class: "form-group" }
const _hoisted_209 = { class: "form-label" }
const _hoisted_210 = { class: "input-group" }
const _hoisted_211 = { value: "" }
const _hoisted_212 = ["value"]
const _hoisted_213 = { class: "form-row" }
const _hoisted_214 = { class: "form-group" }
const _hoisted_215 = { class: "form-label" }
const _hoisted_216 = { class: "input-group" }
const _hoisted_217 = { class: "form-group" }
const _hoisted_218 = { class: "form-label" }
const _hoisted_219 = { class: "input-group" }
const _hoisted_220 = { class: "form-group" }
const _hoisted_221 = { class: "form-label" }
const _hoisted_222 = { class: "input-group" }
const _hoisted_223 = { class: "form-group" }
const _hoisted_224 = { class: "form-label" }
const _hoisted_225 = { class: "input-group" }
const _hoisted_226 = ["placeholder"]
const _hoisted_227 = { class: "form-group" }
const _hoisted_228 = { class: "form-label" }
const _hoisted_229 = { class: "input-group" }
const _hoisted_230 = ["placeholder"]
const _hoisted_231 = { class: "form-group" }
const _hoisted_232 = { class: "participants-header-clean" }
const _hoisted_233 = { class: "form-label" }
const _hoisted_234 = { class: "participants-actions" }
const _hoisted_235 = { class: "contact-search-buttons" }
const _hoisted_236 = { class: "participants-list-clean" }
const _hoisted_237 = { class: "participant-fields" }
const _hoisted_238 = { class: "input-group" }
const _hoisted_239 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_240 = { class: "input-group" }
const _hoisted_241 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_242 = { class: "input-group" }
const _hoisted_243 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_244 = ["onClick"]
const _hoisted_245 = { class: "modal-footer-clean" }
const _hoisted_246 = { class: "modal-header-clean" }
const _hoisted_247 = { class: "header-content" }
const _hoisted_248 = { class: "header-text-clean" }
const _hoisted_249 = { class: "modal-body-clean" }
const _hoisted_250 = { class: "form-row" }
const _hoisted_251 = { class: "form-group" }
const _hoisted_252 = { class: "form-label" }
const _hoisted_253 = { class: "input-group" }
const _hoisted_254 = ["placeholder"]
const _hoisted_255 = { class: "form-group" }
const _hoisted_256 = { class: "form-label" }
const _hoisted_257 = { class: "input-group" }
const _hoisted_258 = { value: "" }
const _hoisted_259 = ["value"]
const _hoisted_260 = { class: "form-row" }
const _hoisted_261 = { class: "form-group" }
const _hoisted_262 = { class: "form-label" }
const _hoisted_263 = { class: "input-group" }
const _hoisted_264 = { class: "form-group" }
const _hoisted_265 = { class: "form-label" }
const _hoisted_266 = { class: "input-group" }
const _hoisted_267 = { class: "form-group" }
const _hoisted_268 = { class: "form-label" }
const _hoisted_269 = { class: "input-group" }
const _hoisted_270 = { class: "form-group" }
const _hoisted_271 = { class: "form-label" }
const _hoisted_272 = { class: "input-group" }
const _hoisted_273 = ["placeholder"]
const _hoisted_274 = { class: "form-group" }
const _hoisted_275 = { class: "form-label" }
const _hoisted_276 = { class: "input-group" }
const _hoisted_277 = ["placeholder"]
const _hoisted_278 = { class: "form-group" }
const _hoisted_279 = { class: "participants-header-clean" }
const _hoisted_280 = { class: "form-label" }
const _hoisted_281 = { class: "participants-actions" }
const _hoisted_282 = { class: "contact-search-buttons" }
const _hoisted_283 = { class: "participants-list-clean" }
const _hoisted_284 = { class: "participant-fields" }
const _hoisted_285 = { class: "input-group" }
const _hoisted_286 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_287 = { class: "input-group" }
const _hoisted_288 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_289 = { class: "input-group" }
const _hoisted_290 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_291 = ["onClick"]
const _hoisted_292 = { class: "modal-footer-clean" }
const _hoisted_293 = { class: "ghost-content" }
const _hoisted_294 = { class: "ghost-title" }
const _hoisted_295 = { class: "ghost-time" }
const _hoisted_296 = { class: "contact-search-body" }
const _hoisted_297 = { class: "search-input-group" }
const _hoisted_298 = { class: "contact-results" }
const _hoisted_299 = {
  key: 0,
  class: "search-loading"
}
const _hoisted_300 = {
  key: 1,
  class: "no-results"
}
const _hoisted_301 = {
  key: 2,
  class: "search-placeholder"
}
const _hoisted_302 = {
  key: 3,
  class: "contacts-list"
}
const _hoisted_303 = ["onClick"]
const _hoisted_304 = { class: "contact-avatar" }
const _hoisted_305 = ["src", "alt"]
const _hoisted_306 = {
  key: 1,
  class: "avatar-placeholder"
}
const _hoisted_307 = { class: "contact-info" }
const _hoisted_308 = { class: "contact-name" }
const _hoisted_309 = { class: "contact-email" }
const _hoisted_310 = {
  key: 0,
  class: "contact-phone"
}
const _hoisted_311 = { class: "modal-header-clean" }
const _hoisted_312 = { class: "header-content" }
const _hoisted_313 = { class: "header-text-clean" }
const _hoisted_314 = { class: "contact-search-body" }
const _hoisted_315 = { class: "search-input-group" }
const _hoisted_316 = ["placeholder"]
const _hoisted_317 = { class: "contact-results" }
const _hoisted_318 = {
  key: 0,
  class: "search-loading"
}
const _hoisted_319 = {
  key: 1,
  class: "search-loading"
}
const _hoisted_320 = {
  key: 2,
  class: "no-results"
}
const _hoisted_321 = {
  key: 3,
  class: "search-placeholder"
}
const _hoisted_322 = {
  key: 4,
  class: "contacts-list"
}
const _hoisted_323 = ["onClick"]
const _hoisted_324 = { class: "contact-avatar" }
const _hoisted_325 = ["src", "alt"]
const _hoisted_326 = {
  key: 1,
  class: "avatar-placeholder"
}
const _hoisted_327 = { class: "contact-info" }
const _hoisted_328 = { class: "contact-name" }
const _hoisted_329 = { class: "contact-email" }
const _hoisted_330 = {
  key: 0,
  class: "contact-phone"
}
const _hoisted_331 = { class: "contact-status" }
const _hoisted_332 = { class: "modal-header-clean" }
const _hoisted_333 = { class: "header-content" }
const _hoisted_334 = { class: "header-text-clean" }
const _hoisted_335 = { class: "contact-search-body" }
const _hoisted_336 = { class: "search-input-group" }
const _hoisted_337 = ["placeholder"]
const _hoisted_338 = { class: "contact-results" }
const _hoisted_339 = {
  key: 0,
  class: "search-loading"
}
const _hoisted_340 = {
  key: 1,
  class: "search-loading"
}
const _hoisted_341 = {
  key: 2,
  class: "no-results"
}
const _hoisted_342 = {
  key: 3,
  class: "search-placeholder"
}
const _hoisted_343 = {
  key: 4,
  class: "contacts-list"
}
const _hoisted_344 = ["onClick"]
const _hoisted_345 = { class: "contact-avatar" }
const _hoisted_346 = { class: "avatar-placeholder" }
const _hoisted_347 = { class: "contact-info" }
const _hoisted_348 = { class: "contact-name" }
const _hoisted_349 = { class: "contact-email" }
const _hoisted_350 = {
  key: 0,
  class: "contact-phone"
}
const _hoisted_351 = { class: "contact-status" }
const _hoisted_352 = { class: "settings-header apple-header" }
const _hoisted_353 = { class: "header-content" }
const _hoisted_354 = { class: "header-text" }
const _hoisted_355 = { class: "settings-nav" }
const _hoisted_356 = ["onClick"]
const _hoisted_357 = { class: "settings-body apple-body" }
const _hoisted_358 = {
  key: 0,
  class: "settings-tab"
}
const _hoisted_359 = { class: "setting-group" }
const _hoisted_360 = { class: "group-header" }
const _hoisted_361 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_362 = { key: 1 }
const _hoisted_363 = { class: "setting-row" }
const _hoisted_364 = { class: "setting-info" }
const _hoisted_365 = { class: "setting-desc" }
const _hoisted_366 = { class: "apple-switch" }
const _hoisted_367 = {
  key: 0,
  class: "working-hours-compact"
}
const _hoisted_368 = { class: "days-header" }
const _hoisted_369 = { class: "day-label" }
const _hoisted_370 = { class: "hours-label" }
const _hoisted_371 = { class: "status-label" }
const _hoisted_372 = { class: "day-info" }
const _hoisted_373 = { class: "day-checkbox" }
const _hoisted_374 = ["onUpdate:modelValue"]
const _hoisted_375 = { class: "day-name" }
const _hoisted_376 = { class: "full-name" }
const _hoisted_377 = { class: "short-name" }
const _hoisted_378 = {
  key: 0,
  class: "time-controls"
}
const _hoisted_379 = ["onUpdate:modelValue"]
const _hoisted_380 = ["onUpdate:modelValue"]
const _hoisted_381 = { class: "day-status" }
const _hoisted_382 = {
  key: 0,
  class: "status-badge active"
}
const _hoisted_383 = {
  key: 1,
  class: "status-badge inactive"
}
const _hoisted_384 = { class: "availability-actions" }
const _hoisted_385 = ["disabled"]
const _hoisted_386 = {
  key: 0,
  class: "ri-loader-5-line animate-spin"
}
const _hoisted_387 = {
  key: 1,
  class: "ri-save-line"
}
const _hoisted_388 = {
  key: 1,
  class: "settings-tab"
}
const _hoisted_389 = { class: "setting-group" }
const _hoisted_390 = { class: "group-header" }
const _hoisted_391 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_392 = {
  key: 1,
  class: "breaks-list"
}
const _hoisted_393 = { class: "break-header" }
const _hoisted_394 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_395 = {
  key: 1,
  class: "break-name"
}
const _hoisted_396 = { class: "break-actions" }
const _hoisted_397 = ["onClick", "title"]
const _hoisted_398 = ["onClick", "title", "disabled"]
const _hoisted_399 = {
  key: 0,
  class: "break-edit-form"
}
const _hoisted_400 = { class: "break-time" }
const _hoisted_401 = ["onUpdate:modelValue"]
const _hoisted_402 = ["onUpdate:modelValue"]
const _hoisted_403 = { class: "break-days" }
const _hoisted_404 = { class: "days-label" }
const _hoisted_405 = { class: "days-pills" }
const _hoisted_406 = ["onUpdate:modelValue", "value"]
const _hoisted_407 = ["onClick", "disabled"]
const _hoisted_408 = ["onClick", "disabled"]
const _hoisted_409 = {
  key: 0,
  class: "ri-loader-5-line animate-spin"
}
const _hoisted_410 = {
  key: 1,
  class: "ri-save-line"
}
const _hoisted_411 = {
  key: 1,
  class: "break-summary"
}
const _hoisted_412 = { class: "time-display" }
const _hoisted_413 = {
  key: 0,
  class: "days-display"
}
const _hoisted_414 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_415 = {
  key: 2,
  class: "settings-tab"
}
const _hoisted_416 = { class: "setting-group" }
const _hoisted_417 = { class: "group-header" }
const _hoisted_418 = { class: "types-list" }
const _hoisted_419 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_420 = { class: "type-header" }
const _hoisted_421 = { class: "type-details" }
const _hoisted_422 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_423 = {
  key: 1,
  class: "type-name"
}
const _hoisted_424 = { class: "type-meta" }
const _hoisted_425 = { class: "duration" }
const _hoisted_426 = { class: "type-actions" }
const _hoisted_427 = ["onClick", "title"]
const _hoisted_428 = ["onClick", "title", "disabled"]
const _hoisted_429 = {
  key: 0,
  class: "type-edit-form"
}
const _hoisted_430 = { class: "form-row" }
const _hoisted_431 = { class: "form-group" }
const _hoisted_432 = { class: "duration-label" }
const _hoisted_433 = { class: "minutes-text" }
const _hoisted_434 = { class: "duration-input" }
const _hoisted_435 = ["onClick"]
const _hoisted_436 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_437 = ["onClick"]
const _hoisted_438 = { class: "form-group" }
const _hoisted_439 = { class: "color-grid" }
const _hoisted_440 = ["onClick", "title"]
const _hoisted_441 = { class: "form-row" }
const _hoisted_442 = { class: "form-group" }
const _hoisted_443 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_444 = { class: "form-group" }
const _hoisted_445 = { class: "color-grid" }
const _hoisted_446 = ["onClick", "title"]
const _hoisted_447 = { class: "form-row" }
const _hoisted_448 = { class: "form-group full-width" }
const _hoisted_449 = { class: "checkbox-label" }
const _hoisted_450 = ["onUpdate:modelValue"]
const _hoisted_451 = {
  key: 0,
  class: "form-row"
}
const _hoisted_452 = { class: "form-group full-width" }
const _hoisted_453 = {
  key: 0,
  class: "users-grid"
}
const _hoisted_454 = ["value", "onUpdate:modelValue"]
const _hoisted_455 = {
  key: 1,
  class: "loading-users"
}
const _hoisted_456 = { class: "form-row" }
const _hoisted_457 = { class: "form-group full-width" }
const _hoisted_458 = {
  key: 0,
  class: "product-search-container"
}
const _hoisted_459 = ["placeholder"]
const _hoisted_460 = ["onClick"]
const _hoisted_461 = {
  key: 1,
  class: "product-dropdown"
}
const _hoisted_462 = {
  key: 0,
  class: "no-results"
}
const _hoisted_463 = ["onClick"]
const _hoisted_464 = { class: "product-info" }
const _hoisted_465 = { class: "product-name" }
const _hoisted_466 = {
  key: 0,
  class: "product-price"
}
const _hoisted_467 = {
  key: 0,
  class: "ri-check-line selected-icon"
}
const _hoisted_468 = {
  key: 1,
  class: "loading-products"
}
const _hoisted_469 = {
  key: 2,
  class: "no-products"
}
const _hoisted_470 = ["onClick", "disabled"]
const _hoisted_471 = ["onClick", "disabled"]
const _hoisted_472 = {
  key: 0,
  class: "ri-loader-5-line animate-spin"
}
const _hoisted_473 = {
  key: 1,
  class: "ri-save-line"
}
const _hoisted_474 = { class: "footer-info" }
const _hoisted_475 = { class: "toast-container" }
const _hoisted_476 = ["onClick"]
const _hoisted_477 = { class: "toast-icon" }
const _hoisted_478 = {
  key: 0,
  class: "ri-check-circle-line"
}
const _hoisted_479 = {
  key: 1,
  class: "ri-error-warning-line"
}
const _hoisted_480 = {
  key: 2,
  class: "ri-alert-line"
}
const _hoisted_481 = {
  key: 3,
  class: "ri-information-line"
}
const _hoisted_482 = { class: "toast-content" }
const _hoisted_483 = ["onClick"]
const _hoisted_484 = { class: "popup-header" }
const _hoisted_485 = { class: "popup-icon" }
const _hoisted_486 = {
  key: 0,
  class: "ri-check-circle-line"
}
const _hoisted_487 = {
  key: 1,
  class: "ri-error-warning-line"
}
const _hoisted_488 = {
  key: 2,
  class: "ri-alert-line"
}
const _hoisted_489 = {
  key: 3,
  class: "ri-information-line"
}
const _hoisted_490 = { class: "popup-body" }
const _hoisted_491 = { class: "popup-footer" }
const _hoisted_492 = { class: "popup-header" }
const _hoisted_493 = { class: "popup-body" }
const _hoisted_494 = { class: "popup-footer" }

import { ref, computed, onMounted, onUnmounted, nextTick, watch } from "vue";
import { useI18n } from "vue-i18n";
import { supabase } from "@/lib/supabaseClient";
import defaultProfileImage from "@/assets/images/admin.png";

// Internationalization

export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarPage',
  setup(__props) {

const { t, locale } = useI18n();

// Check if current locale is RTL
const isRTL = computed(() => ["he", "ar"].includes(locale.value));

// Dark mode detection with reactive updates
const isDarkMode = ref(document.body.classList.contains("dark"));
// Loading state for initial data fetch
const isLoading = ref(true);

// Watch for theme changes
const updateDarkMode = () => {
  isDarkMode.value = document.body.classList.contains("dark");
};

// Create a MutationObserver to watch for class changes on body
let themeObserver: MutationObserver | null = null;

// User Profile data
const userDisplayName = ref("Calendar Manager");
const userRole = ref("Meeting Coordinator");
const userProfilePicture = ref(defaultProfileImage);
const currentUserId = ref<string>("");

// User permissions for calendar access
const userPermissions = ref({
  view_all_calendars: false,
  is_owner: false,
  edit_all_leads: false,
  view_all_leads: false,
  can_invite_users: false,
});

// Calendar users management
const allUsers = ref<any[]>([]);
const selectedUserCalendars = ref<string[]>([]);
const allUsersEventsForCounting = ref<any[]>([]);

// Helper function to get current user's organization ID
const getCurrentUserOrgId = async () => {
  // Get current user from Supabase Auth
  const { data: userData, error: userError } = await supabase.auth.getUser();
  if (userError) throw userError;

  if (!userData.user) {
    throw new Error("User is not authenticated");
  }

  // Get organization ID from user profile
  const { data: profileData, error: profileError } = await supabase
    .from("user_profiles")
    .select("org_id")
    .eq("user_id", userData.user.id)
    .single();

  if (profileError) {
    console.error("Error fetching user profile:", profileError);
    throw new Error("Error fetching user profile");
  }

  if (!profileData || !profileData.org_id) {
    throw new Error("User is not associated with an organization");
  }

  return {
    userId: userData.user.id,
    organizationId: profileData.org_id,
  };
};

// State
const currentView = ref("month");
const currentDate = ref(new Date()); // תאריך נוכחי
const miniCalendarDate = ref(new Date()); // תאריך נוכחי למיני קלנדר
const selectedDay = ref<Date | null>(null);
const selectedEvent = ref<any>(null);

// Add Event Modal state
const showAddEventModal = ref(false);
const showEditEventModal = ref(false);
const showSettingsModal = ref(false);
const editingEvent = ref<any>(null);
const newEvent = ref({
  title: "",
  type: "",
  date: "",
  startTime: "",
  endTime: "",
  location: "",
  description: "",
  participants: [{ name: "", email: "", phone: "" }],
});

// Contact Search state (deprecated)
const showContactSearch = ref(false);
const contactSearchQuery = ref("");
const isSearching = ref(false);
const filteredContacts = ref<any[]>([]);

// Leads Search state
const showLeadsSearch = ref(false);
const leadsSearchQuery = ref("");
const isSearchingLeads = ref(false);
const filteredLeads = ref<any[]>([]);
const leads = ref<any[]>([]);
const loadingLeads = ref(false);
const isEditMode = ref(false); // Track if search is for edit modal

// Clients Search state
const showClientsSearch = ref(false);
const clientsSearchQuery = ref("");
const isSearchingClients = ref(false);
const filteredClients = ref<any[]>([]);
const clients = ref<any[]>([]);
const loadingClients = ref(false);

// Toast and Popup state
const toasts = ref<any[]>([]);
const showConfirmPopup = ref(false);
const confirmPopup = ref({
  title: "",
  message: "",
  confirmText: "",
  cancelText: "",
  confirmAction: null as (() => void) | null,
  type: "warning", // 'warning', 'danger', 'info', 'success'
});

// Additional popup for simple confirmations
const showSimpleConfirm = ref(false);
const simpleConfirmMessage = ref("");
const simpleConfirmCallback = ref<(() => void) | null>(null);

// Calendar Settings state
const showSettings = ref(false);
const activeTab = ref("hours");

const settingsTabs = ref([
  { id: "hours", nameKey: "calendar.settings.hours", icon: "ri-time-line" },
  { id: "breaks", nameKey: "calendar.settings.breaks", icon: "ri-pause-circle-line" },
  { id: "types", nameKey: "calendar.settings.types", icon: "ri-bookmark-line" },
]);

const workingHoursEnabled = ref(true);

const miniCalendarDays = computed(() => [
  t("calendar.dayAbbreviations.sunday"),
  t("calendar.dayAbbreviations.monday"),
  t("calendar.dayAbbreviations.tuesday"),
  t("calendar.dayAbbreviations.wednesday"),
  t("calendar.dayAbbreviations.thursday"),
  t("calendar.dayAbbreviations.friday"),
  t("calendar.dayAbbreviations.saturday"),
]);

// Month view computed properties
const monthViewDayHeaders = computed(() => [
  t("calendar.days.sunday") || "Sunday",
  t("calendar.days.monday") || "Monday", 
  t("calendar.days.tuesday") || "Tuesday",
  t("calendar.days.wednesday") || "Wednesday",
  t("calendar.days.thursday") || "Thursday",
  t("calendar.days.friday") || "Friday",
  t("calendar.days.saturday") || "Saturday",
]);

// Mobile version with 2 letters only
const monthViewDayHeadersMobile = computed(() => [
  (t("calendar.days.sunday") || "Sunday").substring(0, 2),
  (t("calendar.days.monday") || "Monday").substring(0, 2), 
  (t("calendar.days.tuesday") || "Tuesday").substring(0, 2),
  (t("calendar.days.wednesday") || "Wednesday").substring(0, 2),
  (t("calendar.days.thursday") || "Thursday").substring(0, 2),
  (t("calendar.days.friday") || "Friday").substring(0, 2),
  (t("calendar.days.saturday") || "Saturday").substring(0, 2),
]);

const getCurrentMonthYear = computed(() => {
  const months = [
    t("calendar.months.january") || "January",
    t("calendar.months.february") || "February",
    t("calendar.months.march") || "March",
    t("calendar.months.april") || "April",
    t("calendar.months.may") || "May",
    t("calendar.months.june") || "June",
    t("calendar.months.july") || "July",
    t("calendar.months.august") || "August",
    t("calendar.months.september") || "September",
    t("calendar.months.october") || "October",
    t("calendar.months.november") || "November",
    t("calendar.months.december") || "December",
  ];
  return `${months[currentDate.value.getMonth()]} ${currentDate.value.getFullYear()}`;
});

const getMonthViewDays = computed(() => {
  const days = [];
  const firstDay = new Date(currentDate.value.getFullYear(), currentDate.value.getMonth(), 1);
  const lastDay = new Date(currentDate.value.getFullYear(), currentDate.value.getMonth() + 1, 0);
  const startOfWeek = new Date(firstDay);
  const endOfWeek = new Date(lastDay);
  
  // Start from Sunday of the first week
  startOfWeek.setDate(firstDay.getDate() - firstDay.getDay());
  
  // End on Saturday of the last week
  endOfWeek.setDate(lastDay.getDate() + (6 - lastDay.getDay()));
  
  const current = new Date(startOfWeek);
  while (current <= endOfWeek) {
    const today = new Date();
    const isToday = current.toDateString() === today.toDateString();
    const isOtherMonth = current.getMonth() !== currentDate.value.getMonth();
    
    days.push({
      date: current.getFullYear() + '-' + 
            String(current.getMonth() + 1).padStart(2, '0') + '-' + 
            String(current.getDate()).padStart(2, '0'),
      dayNumber: current.getDate(),
      isToday,
      isOtherMonth,
    });
    
    current.setDate(current.getDate() + 1);
  }
  
  return days;
});

const showNotificationBadge = computed(() => true);

const workingDays = ref([
  {
    key: "Mon",
    name: "Monday",
    short: "Mon",
    enabled: true,
    startTime: "09:00",
    endTime: "17:00",
  },
  {
    key: "Tue",
    name: "Tuesday",
    short: "Tue",
    enabled: true,
    startTime: "09:00",
    endTime: "17:00",
  },
  {
    key: "Wed",
    name: "Wednesday",
    short: "Wed",
    enabled: true,
    startTime: "09:00",
    endTime: "17:00",
  },
  {
    key: "Thu",
    name: "Thursday",
    short: "Thu",
    enabled: true,
    startTime: "09:00",
    endTime: "17:00",
  },
  {
    key: "Fri",
    name: "Friday",
    short: "Fri",
    enabled: true,
    startTime: "09:00",
    endTime: "17:00",
  },
  {
    key: "Sat",
    name: "Saturday",
    short: "Sat",
    enabled: false,
    startTime: "10:00",
    endTime: "14:00",
  },
  {
    key: "Sun",
    name: "Sunday",
    short: "Sun",
    enabled: false,
    startTime: "10:00",
    endTime: "14:00",
  },
]);

const blockedTimes = ref<any[]>([]);

// Appointment Types - loaded from database
const appointmentTypes = ref<any[]>([]);
const loadingAppointmentTypes = ref(true);
const savingAppointmentType = ref(false);

// Breaks - loaded from database
const loadingBreaks = ref(true);
const savingBreak = ref(false);

// Employee Availability - loaded from database
const loadingAvailability = ref(true);
const savingAvailability = ref(false);
const products = ref<any[]>([]);
const users = ref<any[]>([]);
const loadingProducts = ref(false);
const loadingUsers = ref(false);
const productSearchQuery = ref("");
const showProductDropdown = ref(false);

const colorOptions = ref([
  { value: "personal", bg: "#fbbf24" },
  { value: "work", bg: "#3b82f6" },
  { value: "health", bg: "#ec4899" },
  { value: "meeting", bg: "#22c55e" },
  { value: "call", bg: "#8b5cf6" },
  { value: "task", bg: "#6b7280" },
]);

// Days of week for breaks selection
const daysOfWeek = computed(() => [
  { value: "Mon", label: t("calendar.days.monday") },
  { value: "Tue", label: t("calendar.days.tuesday") },
  { value: "Wed", label: t("calendar.days.wednesday") },
  { value: "Thu", label: t("calendar.days.thursday") },
  { value: "Fri", label: t("calendar.days.friday") },
  { value: "Sat", label: t("calendar.days.saturday") },
  { value: "Sun", label: t("calendar.days.sunday") },
]);

// Function to translate day abbreviations
const getTranslatedDays = (dayValues: string[]) => {
  return dayValues.map((dayValue) => {
    const dayInfo = daysOfWeek.value.find((day) => day.value === dayValue);
    return dayInfo ? dayInfo.label : dayValue;
  });
};

// Sample contacts data
const contacts = ref([
  {
    id: 1,
    name: "John Smith",
    email: "john.smith@example.com",
    phone: "+1-555-0123",
    avatar: "/api/placeholder/40/40",
  },
  {
    id: 2,
    name: "Sarah Johnson",
    email: "sarah.j@company.com",
    phone: "+1-555-0124",
    avatar: "/api/placeholder/40/40",
  },
  {
    id: 3,
    name: "Michael Brown",
    email: "michael.brown@email.com",
    phone: "+1-555-0125",
    avatar: null,
  },
  {
    id: 4,
    name: "Emily Davis",
    email: "emily.davis@work.com",
    phone: "+1-555-0126",
    avatar: "/api/placeholder/40/40",
  },
  {
    id: 5,
    name: "David Wilson",
    email: "david.w@business.com",
    phone: "+1-555-0127",
    avatar: null,
  },
  {
    id: 6,
    name: "Lisa Anderson",
    email: "lisa.anderson@corp.com",
    phone: "+1-555-0128",
    avatar: "/api/placeholder/40/40",
  },
]);

// Drag and Drop state
const isDragging = ref(false);
const draggingEvent = ref<string | null>(null);
const dragOverSlot = ref<string | null>(null);
const dragGhostStyle = ref({});
const dragGhostClass = ref("");
const dragGhostContent = ref({ title: "", time: "" });

// Events data - will be loaded from database
const events = ref<any[]>([]);

// Computed properties
const weekDays = computed(() => {
  console.log(
    "📆 Computing week days for current date:",
    currentDate.value.toISOString()
  );

  const days = [];
  const startOfWeek = new Date(currentDate.value);
  startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay()); // Start from Sunday

  console.log("📅 Week starts at:", startOfWeek.toISOString());

  for (let i = 0; i < 7; i++) {
    const day = new Date(startOfWeek);
    day.setDate(startOfWeek.getDate() + i);

    days.push({
      date: day.toISOString().split("T")[0],
      dayName: day.toLocaleDateString("en-US", { weekday: "long" }),
      dayNumber: day.getDate(),
      isToday: isToday(day),
      isSelected: selectedDay.value && isSameDay(day, selectedDay.value),
    });
  }

  return days;
});

// Add computed property for current view days
const currentViewDays = computed(() => {
  if (currentView.value === "day") {
    // Single day view
    const day = new Date(currentDate.value);
    const dayOfWeek = day.getDay();
    const dayNames = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];
    return [
      {
        date: day.toISOString().split("T")[0],
        dayName: t(`calendar.days.${dayNames[dayOfWeek]}`),
        dayNumber: day.getDate(),
        isToday: isToday(day),
        isSelected: true,
        isCurrentMonth: true,
      },
    ];
  } else {
    // Week view (default)
    const dayNames = [
      t("calendar.days.sunday"),
      t("calendar.days.monday"),
      t("calendar.days.tuesday"),
      t("calendar.days.wednesday"),
      t("calendar.days.thursday"),
      t("calendar.days.friday"),
      t("calendar.days.saturday"),
    ];

    return weekDays.value.map((day) => {
      const dayDate = new Date(day.date);
      const dayOfWeek = dayDate.getDay();
      return {
        ...day,
        dayName: dayNames[dayOfWeek],
        isCurrentMonth: true,
      };
    });
  }
});

const hours = computed(() => {
  const hoursList = [];
  for (let i = 6; i <= 21; i++) {
    // 6 AM to 10 PM (22:00) - טווח מורחב
    hoursList.push(i);
  }
  return hoursList;
});

const getMiniCalendarTitle = computed(() => {
  const monthNames = [
    t("calendar.months.january"),
    t("calendar.months.february"),
    t("calendar.months.march"),
    t("calendar.months.april"),
    t("calendar.months.may"),
    t("calendar.months.june"),
    t("calendar.months.july"),
    t("calendar.months.august"),
    t("calendar.months.september"),
    t("calendar.months.october"),
    t("calendar.months.november"),
    t("calendar.months.december"),
  ];

  const month = miniCalendarDate.value.getMonth();
  const year = miniCalendarDate.value.getFullYear();

  return `${monthNames[month]} ${year}`;
});

const getMiniCalendarDays = computed(() => {
  const days = [];
  const year = miniCalendarDate.value.getFullYear();
  const month = miniCalendarDate.value.getMonth();

  const firstDay = new Date(year, month, 1);
  const startDate = new Date(firstDay);
  const dayOfWeek = firstDay.getDay();
  const mondayOffset =  - dayOfWeek;
  startDate.setDate(firstDay.getDate() + mondayOffset);

  for (let i = 0; i < 42; i++) {
    const day = new Date(startDate);
    day.setDate(startDate.getDate() + i);

    days.push({
      date: day,
      dayNumber: day.getDate(),
      isToday: isToday(day),
      isOtherMonth: day.getMonth() !== month,
      isSelected: selectedDay.value && isSameDay(day, selectedDay.value),
    });
  }

  return days;
});

// Helper functions
const isToday = (date: Date) => {
  const today = new Date();
  return date.toDateString() === today.toDateString();
};

const isSameDay = (date1: Date, date2: Date) => {
  return date1.toDateString() === date2.toDateString();
};

const formatHour = (hour: number) => {
  const period = hour < 12 ? t("calendar.am") : t("calendar.pm");
  let displayHour = hour;

  if (hour === 0) displayHour = 12;
  else if (hour > 12) displayHour = hour - 12;

  return `${displayHour} ${period}`;
};

const getDayEvents = (dateStr: string) => {
  const dayEvents = events.value.filter((event) => {
    // בדיקה שהאירוע הוא תקין ויש לו תאריך התחלה
    if (!event || !event.start) {
      console.warn("⚠️ Event missing start date:", event);
      return false;
    }
    
    const eventDate = new Date(event.start);
    console.log("eventDate", eventDate);
    
    // בדיקה שהתאריך תקין
    if (isNaN(eventDate.getTime())) {
      console.warn("⚠️ Invalid event date:", event.start, "for event:", event);
      return false;
    }
    
    const eventDateStr = eventDate.toISOString().split("T")[0];
    console.log("eventDateStr", eventDateStr);
    return eventDateStr === dateStr;
  });

  // Log only if there are events for this day
  if (dayEvents.length > 0) {
    console.log(`Found ${dayEvents.length} events for ${dateStr}:`, dayEvents);
  }

  // מיון האירועים לפי זמן התחלה עם הגנה
  return dayEvents.sort((a, b) => {
    if (!a || !a.start || !b || !b.start) {
      console.warn("⚠️ Invalid events in sort:", a, b);
      return 0;
    }
    
    const timeA = new Date(a.start).getTime();
    const timeB = new Date(b.start).getTime();
    
    if (isNaN(timeA) || isNaN(timeB)) {
      console.warn("⚠️ Invalid dates in sort:", a.start, b.start);
      return 0;
    }
    
    return timeA - timeB;
  });
};

// Navigation functions
const changeView = (view: string) => {
  currentView.value = view;

  // Update navigation logic based on view
  if (view === "day") {
    // For day view, focus on a single day
    console.log("Switched to Day view");
  } else {
    // Week view (default)
    console.log("Switched to Week view");
  }
};

const navigateCalendar = (direction: "prev" | "next") => {
  const newDate = new Date(currentDate.value);

  if (currentView.value === "day") {
    // Navigate by day
    newDate.setDate(newDate.getDate() + (direction === "next" ? 1 : -1));
  } else {
    // Navigate by week (default)
    newDate.setDate(newDate.getDate() + (direction === "next" ? 7 : -7));
  }

  currentDate.value = newDate;
};

const goToToday = () => {
  currentDate.value = new Date();
};

const navigateMiniCalendar = (direction: "prev" | "next") => {
  const newDate = new Date(miniCalendarDate.value);
  newDate.setMonth(newDate.getMonth() + (direction === "next" ? 1 : -1));
  miniCalendarDate.value = newDate;
};

const selectMiniDay = (day: any) => {
  console.log("selectMiniDay", day);
  
  // בדיקה שהתאריך תקין
  if (!day || !day.date) {
    console.warn("⚠️ Invalid day object:", day);
    return;
  }
  
  const newDate = new Date(day.date);
  if (isNaN(newDate.getTime())) {
    console.warn("⚠️ Invalid date:", day.date);
    return;
  }
  
  selectedDay.value = newDate;
  currentDate.value = newDate;
};

const selectDay = (day: any) => {
  // בדיקה שהתאריך תקין
  if (!day || !day.date) {
    console.warn("⚠️ Invalid day object:", day);
    return;
  }
  
  const newDate = new Date(day.date);
  if (isNaN(newDate.getTime())) {
    console.warn("⚠️ Invalid date:", day.date);
    return;
  }
  
  selectedDay.value = newDate;
  currentDate.value = newDate;
  // Switch to day view when clicking a day
  currentView.value = "day";
};

// Month view helper methods
const getDayEventsForMonth = (dateStr: string) => {
  return getDayEvents(dateStr).slice(0, 3); // Show only first 3 events in month view
};

const getEventColorClasses = (event: any) => {
  // אם יש colorClass שנטען מהמסד נתונים, השתמש בו
  if (event.colorClass) {
    console.log(`🎨 Event "${event.title}" has colorClass: ${event.colorClass}`);
    const colorClassMap = {
      'event-blue': 'bg-blue-100 text-blue-700 hover:bg-blue-200 border-blue-200 dark:bg-blue-900 dark:text-blue-300 dark:hover:bg-blue-800 dark:border-blue-700',
      'event-yellow': 'bg-yellow-100 text-yellow-700 hover:bg-yellow-200 border-yellow-200 dark:bg-yellow-900 dark:text-yellow-300 dark:hover:bg-yellow-800 dark:border-yellow-700',
      'event-pink': 'bg-pink-100 text-pink-700 hover:bg-pink-200 border-pink-200 dark:bg-pink-900 dark:text-pink-300 dark:hover:bg-pink-800 dark:border-pink-700',
      'event-green': 'bg-green-100 text-green-700 hover:bg-green-200 border-green-200 dark:bg-green-900 dark:text-green-300 dark:hover:bg-green-800 dark:border-green-700',
      'event-purple': 'bg-purple-100 text-purple-700 hover:bg-purple-200 border-purple-200 dark:bg-purple-900 dark:text-purple-300 dark:hover:bg-purple-800 dark:border-purple-700',
      'event-gray': 'bg-gray-100 text-gray-700 hover:bg-gray-200 border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700 dark:border-gray-600',
    };
    const resultClass = colorClassMap[event.colorClass] || 'bg-blue-100 text-blue-700 hover:bg-blue-200 border-blue-200 dark:bg-blue-900 dark:text-blue-300 dark:hover:bg-blue-800 dark:border-blue-700';
    console.log(`🎨 Applied classes for "${event.title}": ${resultClass}`);
    return resultClass;
  }
  
  // fallback למפת צבעים ישנה אם אין colorClass
  console.log(`⚠️ Event "${event.title}" has no colorClass, using fallback. Event type: ${event.type}, Event title: ${event.title}`);
  const colorMap = {
    'Personal': 'bg-primary-100 text-primary-700 hover:bg-primary-200 border-primary-200 dark:bg-primary-900 dark:text-primary-300 dark:hover:bg-primary-800 dark:border-primary-700',
    'Work': 'bg-green-100 text-green-700 hover:bg-green-200 border-green-200 dark:bg-green-900 dark:text-green-300 dark:hover:bg-green-800 dark:border-green-700',
    'Team Meeting': 'bg-primary-100 text-primary-700 hover:bg-primary-200 border-primary-200 dark:bg-primary-900 dark:text-primary-300 dark:hover:bg-primary-800 dark:border-primary-700',
    'Meeting': 'bg-yellow-100 text-yellow-700 hover:bg-yellow-200 border-yellow-200 dark:bg-yellow-900 dark:text-yellow-300 dark:hover:bg-yellow-800 dark:border-yellow-700',
    'Follow-up': 'bg-green-100 text-green-700 hover:bg-green-200 border-green-200 dark:bg-green-900 dark:text-green-300 dark:hover:bg-green-800 dark:border-green-700',
    'Demo': 'bg-yellow-100 text-yellow-700 hover:bg-yellow-200 border-yellow-200 dark:bg-yellow-900 dark:text-yellow-300 dark:hover:bg-yellow-800 dark:border-yellow-700',
    'Consultation': 'bg-primary-100 text-primary-700 hover:bg-primary-200 border-primary-200 dark:bg-primary-900 dark:text-primary-300 dark:hover:bg-primary-800 dark:border-primary-700',
    'Client Call': 'bg-green-100 text-green-700 hover:bg-green-200 border-green-200 dark:bg-green-900 dark:text-green-300 dark:hover:bg-green-800 dark:border-green-700',
  };
  
  const finalClass = colorMap[event.type] || colorMap[event.title] || 'bg-gray-100 text-gray-700 hover:bg-gray-200 border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700 dark:border-gray-600';
  console.log(`🎨 Applied fallback classes for "${event.title}": ${finalClass}`);
  return finalClass;
};

const createEventAt = (dateStr: string, hour: number, event?: MouseEvent) => {
  console.log("📅 Creating event at:", dateStr, "hour:", hour);

  // חישוב הדקות אם יש אירוע עכבר
  let minutes = 0;
  if (event) {
    const hourSlot = event.currentTarget as HTMLElement;
    const rect = hourSlot.getBoundingClientRect();
    const relativeY = event.clientY - rect.top;
    const percentY = relativeY / rect.height;

    // חישוב הדקות - כל רבע שעה (0, 15, 30, 45)
    if (percentY >= 0.75) {
      minutes = 45;
    } else if (percentY >= 0.5) {
      minutes = 30;
    } else if (percentY >= 0.25) {
      minutes = 15;
    }
  }

  // בדיקה אם כבר יש אירוע בשעה הזו
  const existingEvents = getDayEvents(dateStr).filter((event) => {
    if (!event || !event.start || !event.end) {
      console.warn("⚠️ Event missing start/end times:", event);
      return false;
    }
    
    const eventStart = new Date(event.start);
    const eventEnd = new Date(event.end);
    
    if (isNaN(eventStart.getTime()) || isNaN(eventEnd.getTime())) {
      console.warn("⚠️ Invalid event times:", event.start, event.end);
      return false;
    }
    
    const eventStartHour = eventStart.getHours();
    const eventEndHour = eventEnd.getHours();

    // בדיקה אם האירוע חופף עם השעה הנבחרת
    return eventStartHour <= hour && eventEndHour >= hour;
  });

  console.log("📋 Found existing events:", existingEvents);

  if (existingEvents.length > 0) {
    showToast("calendar.alreadyScheduled", "warning");
    return;
  }

  // פתיחת מודל הוספת אירוע עם הזמן המוגדר מראש
  openAddEventModal(dateStr, hour, minutes);
};

const openAddEventModal = (dateStr?: string, hour?: number, minutes = 0) => {
  // Close event details modal if open
  if (selectedEvent.value) {
    closeEventDetail();
  }

  // איפוס הטופס
  const startMinutesStr = minutes.toString().padStart(2, "0");
  const endHour = minutes === 45 ? hour! + 1 : hour!;
  const endMinutes = minutes === 45 ? 0 : minutes + 15;
  const endMinutesStr = endMinutes.toString().padStart(2, "0");

  newEvent.value = {
    title: "",
    type: "",
    date: dateStr || new Date().toISOString().split("T")[0],
    startTime: hour ? `${hour.toString().padStart(2, "0")}:${startMinutesStr}` : "09:00",
    endTime: hour ? `${endHour.toString().padStart(2, "0")}:${endMinutesStr}` : "10:00",
    location: "",
    description: "",
    participants: [{ name: "", email: "", phone: "" }], // משתתפים עם שם ואמצעי יצירת קשר
  };

  showAddEventModal.value = true;
};

const closeAddEventModal = () => {
  showAddEventModal.value = false;
  newEvent.value = {
    title: "",
    type: "",
    date: "",
    startTime: "",
    endTime: "",
    location: "",
    description: "",
    participants: [{ name: "", email: "", phone: "" }], // משתתפים עם שם ואמצעי יצירת קשר
  };
};

const saveNewEvent = async () => {
  if (
    !newEvent.value.title ||
    !newEvent.value.type ||
    !newEvent.value.date ||
    !newEvent.value.startTime ||
    !newEvent.value.endTime
  ) {
    showToast("calendar.fillAllFields", "warning");
    return;
  }

  // יצירת תאריכי התחלה וסיום
  const startDateTime = new Date(`${newEvent.value.date}T${newEvent.value.startTime}`);
  const endDateTime = new Date(`${newEvent.value.date}T${newEvent.value.endTime}`);

  // בדיקה שזמן הסיום אחרי זמן ההתחלה
  if (endDateTime <= startDateTime) {
    showToast("calendar.endTimeAfterStart", "warning");
    return;
  }

  // בדיקה שהשעה לא תפוסה
  const hour = startDateTime.getHours();
  const dateStr = newEvent.value.date;

  console.log("🔍 Checking time slot:", dateStr, "at hour:", hour);

  // בדיקה האם יש אירועים חופפים
  const existingEvents = getDayEvents(dateStr).filter((event) => {
    if (!event || !event.start || !event.end) {
      console.warn("⚠️ Event missing start/end times:", event);
      return false;
    }
    
    const eventStart = new Date(event.start);
    const eventEnd = new Date(event.end);
    
    if (isNaN(eventStart.getTime()) || isNaN(eventEnd.getTime())) {
      console.warn("⚠️ Invalid event times:", event.start, event.end);
      return false;
    }
    
    return (
      (startDateTime >= eventStart && startDateTime < eventEnd) ||
      (endDateTime > eventStart && endDateTime <= eventEnd) ||
      (startDateTime <= eventStart && endDateTime >= eventEnd)
    );
  });

  console.log("📋 Existing events at this time:", existingEvents);

  if (existingEvents.length > 0) {
    showToast("calendar.timeSlotOccupied", "warning");
    return;
  }

  if (isHourOccupied(dateStr, hour)) {
    showToast("calendar.timeSlotBlocked", "warning");
    return;
  }

  try {
    // קבלת userId ו-organizationId
    const { userId, organizationId } = await getCurrentUserOrgId();

    // סינון משתתפים שיש להם שם
    const validParticipants = newEvent.value.participants.filter(
      (p) => p.name.trim() !== ""
    );

    // מציאת סוג האירוע מהטבלה אם זה סוג מותאם אישית
    const appointmentType = appointmentTypes.value.find(
      (type) => type.name === newEvent.value.type
    );
    const eventTypeId = appointmentType?.id || null;

    // שמירת האירוע במסד נתונים
    console.log("🕐 Original startDateTime:", startDateTime.toString());
    console.log("🕐 Original endDateTime:", endDateTime.toString());
    console.log("🕐 Saving startTime as:", createLocalISOString(startDateTime));
    console.log("🕐 Saving endTime as:", createLocalISOString(endDateTime));
    
    const { data: eventData, error: eventError } = await supabase
      .from("calendar_events")
      .insert({
        user_id: userId,
        title: newEvent.value.title,
        start_time: createLocalISOString(startDateTime),
        end_time: createLocalISOString(endDateTime),
        event_type: eventTypeId,
        location: newEvent.value.location || null,
        description: newEvent.value.description || null,
        org_id: organizationId,
      })
      .select()
      .single();

    if (eventError) {
      console.error("Error creating event:", eventError);
      showToast("calendar.eventCreationError", "error");
      return;
    }

    console.log("Event created in database:", eventData);

    // שמירת המשתתפים
    if (validParticipants.length > 0 && eventData) {
      const participantsToInsert = validParticipants.map((participant) => ({
        event_id: eventData.id,
        lead_id: (participant as any).leadId || null,
        customer_id: (participant as any).clientId || null,
        name: participant.name,
        phone: participant.phone || null,
        email: participant.email || null,
      }));

      const { error: participantsError } = await supabase
        .from("calendar_events_participants")
        .insert(participantsToInsert);

      if (participantsError) {
        console.error("Error creating participants:", participantsError);
        // המשך גם אם יש שגיאה במשתתפים
      }
    }

    // קביעת צבע האירוע לפי הסוג
    const getEventColor = (type: string) => {
      // אם זה סוג מותאם אישית, השתמש בצבע שלו
      if (appointmentType && appointmentType.colorCode) {
        console.log(`🎨 Found appointment type with color: ${appointmentType.colorCode}`);
        const colorMap: { [key: string]: string } = {
          "#fbbf24": "event-yellow",
          "#3b82f6": "event-blue",
          "#ec4899": "event-pink",
          "#22c55e": "event-green",
          "#8b5cf6": "event-purple",
          "#6b7280": "event-gray",
        };
        return colorMap[appointmentType.colorCode] || "event-blue";
      }

      console.log(`⚠️ No appointment type found for "${type}", using fallback colors`);
      switch (type) {
        case "personal":
          return "event-yellow";
        case "work":
          return "event-blue";
        case "health":
          return "event-pink";
        case "meeting":
          return "event-green";
        case "call":
          return "event-purple";
        case "task":
          return "event-gray";
        default:
          return "event-blue";
      }
    };

    // יצירת אירוע חדש להצגה
    const newEventDisplay: any = {
      id: eventData.id,
      title: newEvent.value.title,
      type: newEvent.value.type,
      start: startDateTime,
      end: endDateTime,
      colorClass: getEventColor(newEvent.value.type),
      timeDisplay: `${newEvent.value.startTime} - ${newEvent.value.endTime}`,
      location: newEvent.value.location,
      description: newEvent.value.description,
      dateDisplay: startDateTime.toLocaleDateString("he-IL", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      }),
    };

    // הוספת משתתפים אם יש
    if (validParticipants.length > 0) {
      newEventDisplay.participants = validParticipants.map((p, index) => ({
        id: index + 1,
        name: p.name,
        email: p.email,
        phone: p.phone,
        avatar: "/api/placeholder/24/24",
      }));
    }

    // הוספת האירוע לרשימה
    events.value.push(newEventDisplay);

    // סגירת המודל
    closeAddEventModal();

    console.log("New event created successfully!");

    // טען מחדש את האירועים מהמסד נתונים
    await fetchCalendarEvents();
  } catch (error) {
    console.error("Error saving event:", error);
    showToast("calendar.eventSaveError", "error");
  }
};

// פונקציות לניהול משתתפים
const addParticipant = () => {
  newEvent.value.participants.push({ name: "", email: "", phone: "" });
};

const removeParticipant = (index: number) => {
  if (newEvent.value.participants.length > 1) {
    newEvent.value.participants.splice(index, 1);
  }
};

// פונקציות לניהול משתתפים בעריכה
const addParticipantToEdit = () => {
  if (!editingEvent.value.participants) {
    editingEvent.value.participants = [];
  }
  editingEvent.value.participants.push({ name: "", email: "", phone: "" });
};

const removeParticipantFromEdit = (index: number) => {
  if (editingEvent.value.participants && editingEvent.value.participants.length > 1) {
    editingEvent.value.participants.splice(index, 1);
  }
};

const openEvent = (event: any) => {
  selectedEvent.value = {
    ...event,
    timeRange: event.timeDisplay,
    dateDisplay: event.dateDisplay || "Today",
  };
};

const closeEventDetail = () => {
  selectedEvent.value = null;
};

// Drag and Drop handlers
const handleEventDragStart = (event: DragEvent, eventData: any) => {
  isDragging.value = true;
  draggingEvent.value = eventData.id;
  dragGhostContent.value = {
    title: eventData.title,
    time: eventData.timeDisplay,
  };
  dragGhostClass.value = eventData.colorClass;

  if (event.dataTransfer) {
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData(
      "text/plain",
      JSON.stringify({
        type: "event",
        event: eventData,
      })
    );
  }
};

const handleEventDragEnd = () => {
  isDragging.value = false;
  draggingEvent.value = null;
  dragOverSlot.value = null;
};

const handleTimeSlotDragOver = (event: DragEvent, dayDate: string, hour: number) => {
  event.preventDefault();
  dragOverSlot.value = `${dayDate}-${hour}`;

  // חישוב הדקות לפי מיקום העכבר
  const hourSlot = event.currentTarget as HTMLElement;
  const rect = hourSlot.getBoundingClientRect();
  const relativeY = event.clientY - rect.top;
  const percentY = relativeY / rect.height;

  // חישוב הדקות - כל רבע שעה (0, 15, 30, 45)
  let minutes = 0;
  if (percentY >= 0.75) {
    minutes = 45;
  } else if (percentY >= 0.5) {
    minutes = 30;
  } else if (percentY >= 0.25) {
    minutes = 15;
  }

  // Update drag ghost with new time preview
  if (isDragging.value && draggingEvent.value) {
    const originalEvent = events.value.find((e) => e.id === draggingEvent.value);
    if (originalEvent) {
      const originalStart = new Date(originalEvent.start);
      const originalEnd = new Date(originalEvent.end);
      const duration = originalEnd.getTime() - originalStart.getTime();

      const newStartDate = new Date(dayDate);
      newStartDate.setHours(hour, minutes, 0, 0);
      const newEndDate = new Date(newStartDate.getTime() + duration);

      const newTimeDisplay = `${formatTimeInLocalTimezone(newStartDate)} - ${formatTimeInLocalTimezone(newEndDate)}`;

      dragGhostContent.value = {
        title: originalEvent.title,
        time: newTimeDisplay,
      };
    }
  }

  updateDragGhostPosition(event);
};

const handleDragLeave = () => {
  dragOverSlot.value = null;
};

const handleTimeSlotDrop = async (event: DragEvent, dayDate: string, hour: number) => {
  event.preventDefault();

  try {
    const data = JSON.parse(event.dataTransfer?.getData("text/plain") || "{}");

    if (data.type === "event") {
      // חישוב הדקות לפי מיקום העכבר בתוך ה-slot
      const hourSlot = event.target as HTMLElement;
      const rect = hourSlot.getBoundingClientRect();
      const relativeY = event.clientY - rect.top;
      const percentY = relativeY / rect.height;

      // חישוב הדקות - כל רבע שעה (0, 15, 30, 45)
      let minutes = 0;
      if (percentY >= 0.75) {
        minutes = 45;
      } else if (percentY >= 0.5) {
        minutes = 30;
      } else if (percentY >= 0.25) {
        minutes = 15;
      }

      // בדיקה אם השעה החדשה תפוסה (למעט האירוע הנוכחי)
      const existingEvents = getDayEvents(dayDate).filter((existingEvent) => {
        if (existingEvent.id === data.event.id) return false; // לא לספור את האירוע שאנחנו מעבירים

        const eventStart = new Date(existingEvent.start);
        const eventEnd = new Date(existingEvent.end);
        const eventStartHour = eventStart.getHours();
        const eventEndHour = eventEnd.getHours();

        return eventStartHour <= hour && eventEndHour >= hour;
      });

      if (existingEvents.length > 0) {
        showToast("calendar.cannotMoveEvent", "warning");
        handleEventDragEnd();
        return;
      }

      await moveEventToTimeSlot(data.event, dayDate, hour, minutes);
    }
  } catch (error) {
    console.error("Error handling time slot drop:", error);
  }

  handleEventDragEnd();
};

const updateDragGhostPosition = (event: DragEvent) => {
  dragGhostStyle.value = {
    left: `${event.clientX + 10}px`,
    top: `${event.clientY - 10}px`,
    transform: "translate(0, 0)",
    pointerEvents: "none",
    zIndex: 9999,
  };
};

const moveEventToTimeSlot = async (
  eventData: any,
  dayDate: string,
  hour: number,
  minutes = 0
) => {
  // Find the event in our events array and update it
  const eventIndex = events.value.findIndex((e) => e.id === eventData.id);
  if (eventIndex !== -1) {
    const newDate = new Date(dayDate);
    newDate.setHours(hour, minutes, 0, 0);

    const originalStart = new Date(eventData.start);
    const originalEnd = new Date(eventData.end);
    const duration = originalEnd.getTime() - originalStart.getTime();

    const newEndDate = new Date(newDate.getTime() + duration);

    try {
      // עדכון במסד נתונים
      console.log("🕐 Drag&Drop - Moving event to:", createLocalISOString(newDate));
      console.log("🕐 Drag&Drop - New end time:", createLocalISOString(newEndDate));
      
      const { error: updateError } = await supabase
        .from("calendar_events")
        .update({
          start_time: createLocalISOString(newDate),
          end_time: createLocalISOString(newEndDate),
          updated_at: createLocalISOString(new Date()),
        })
        .eq("id", eventData.id);

      if (updateError) {
        console.error("Error updating event position:", updateError);
        showToast("calendar.eventMoveError", "error");
        return;
      }

      // Format the new time display
      const newTimeDisplay = `${formatTimeInLocalTimezone(newDate)} - ${formatTimeInLocalTimezone(newEndDate)}`;

      events.value[eventIndex] = {
        ...events.value[eventIndex],
        start: newDate,
        end: newEndDate,
        timeDisplay: newTimeDisplay,
      };

      console.log("Event moved successfully! New time:", newTimeDisplay);
    } catch (error) {
      console.error("Error moving event:", error);
      showToast("calendar.eventMoveError", "error");
    }
  }
};

const getAbsoluteEventStyle = (event: any, dayDate: string) => {
  const start = new Date(event.start);
  const end = new Date(event.end);

  // בדיקה אם התאריך של האירוע תואם את היום המבוקש
  const eventDateStr = start.toISOString().split("T")[0];
  if (eventDateStr !== dayDate) {
    console.log(
      `⚠️ Event ${event.title} date ${eventDateStr} doesn't match day ${dayDate}`
    );
    return {
      display: "none",
    };
  }

  // התאמה לעיצוב החדש - כל תא שעה הוא 60px
  const heightPerHour = 60; // עדכון לעיצוב החדש
  const minHeight = 30; // גובה מינימלי מופחת

  // חישוב המיקום מתחילת היום (6 AM)
  const startHour = 6; // השעה הראשונה ביומן
  const eventStartHour = start.getHours();
  const eventStartMinutes = start.getMinutes();

  // וידוא שהאירוע בטווח השעות המוצג
  if (eventStartHour < startHour || eventStartHour > 21) {
    console.log(
      `⏰ Event ${event.title} at hour ${eventStartHour} is outside display range (${startHour}-21)`
    );
    return {
      display: "none",
    };
  }

  // חישוב המיקום מלמעלה
  const hoursFromStart = eventStartHour - startHour;
  const minutesOffset = (eventStartMinutes / 60) * heightPerHour;
  const top = hoursFromStart * heightPerHour + minutesOffset;

  console.log(`📍 Event "${event.title}" positioning:`, {
    eventStartHour,
    eventStartMinutes,
    startHour,
    hoursFromStart,
    minutesOffset,
    heightPerHour,
    calculatedTop: top,
  });

  // חישוב גובה האירוע
  const duration = (end.getTime() - start.getTime()) / (1000 * 60); // דקות
  const height = Math.max(minHeight, (duration / 60) * heightPerHour);

  // כל אירוע תופס את כל הרוחב - ללא חפיפות
  return {
    position: "absolute" as const,
    height: `${height}px`,
    top: `${top}px`,
    width: "calc(100% - 8px)", // רוחב מלא פחות ריווח
    left: "4px", // ריווח קטן מהצד
    zIndex: 10,
  };
};

// פונקציה לבדיקה אם שעה תפוסה (רק הפסקות ושעות לא פעילות, לא אירועים)
const isHourOccupied = (dateStr: string, hour: number) => {
  // Check if time is blocked by settings (breaks or non-working hours)
  return isTimeBlocked(dateStr, hour);
};

// Contact Search functionality (deprecated)
const openContactSearch = () => {
  showContactSearch.value = true;
  contactSearchQuery.value = "";
  filteredContacts.value = [];
};

const searchContacts = async () => {
  if (!contactSearchQuery.value.trim()) {
    filteredContacts.value = [];
    return;
  }

  isSearching.value = true;

  // Simulate API delay
  setTimeout(() => {
    const query = contactSearchQuery.value.toLowerCase();
    filteredContacts.value = contacts.value.filter(
      (contact) =>
        contact.name.toLowerCase().includes(query) ||
        contact.email.toLowerCase().includes(query) ||
        (contact.phone && contact.phone.includes(query))
    );
    isSearching.value = false;
  }, 300);
};

const selectContact = (contact: any) => {
  // Check if contact is already added
  const isAlreadyAdded = newEvent.value.participants.some(
    (p) => p.email === contact.email || p.name === contact.name
  );

  if (isAlreadyAdded) {
    showToast("calendar.contactAlreadyAdded", "warning");
    return;
  }

  // Find first empty participant slot
  const emptyIndex = newEvent.value.participants.findIndex(p => !p.name || p.name.trim() === "");
  
  const participantData = {
    name: contact.name,
    email: contact.email,
    phone: contact.phone || "",
  };

  if (emptyIndex !== -1) {
    // Fill empty slot
    newEvent.value.participants[emptyIndex] = participantData;
  } else {
    // Add new participant if no empty slots
    newEvent.value.participants.push(participantData);
  }

  closeContactSearch();
};

const closeContactSearch = () => {
  showContactSearch.value = false;
  contactSearchQuery.value = "";
  filteredContacts.value = [];
};

// Leads Search functionality
const openLeadsSearch = () => {
  isEditMode.value = false;
  showLeadsSearch.value = true;
  leadsSearchQuery.value = "";
  filteredLeads.value = [];
  fetchLeads();
};

const openLeadsSearchForEdit = () => {
  isEditMode.value = true;
  showLeadsSearch.value = true;
  leadsSearchQuery.value = "";
  filteredLeads.value = [];
  fetchLeads();
};

const fetchLeads = async () => {
  try {
    loadingLeads.value = true;

    const { organizationId } = await getCurrentUserOrgId();

    const { data, error } = await supabase
      .from("leads")
      .select("id, name, email, phone, status, profileImageLink")
      .eq("org_id", organizationId)
      .order("name");

    if (error) throw error;

    leads.value = data || [];
    console.log("Loaded leads:", leads.value);
  } catch (error) {
    console.error("Error fetching leads:", error);
    leads.value = [];
  } finally {
    loadingLeads.value = false;
  }
};

const searchLeads = async () => {
  if (!leadsSearchQuery.value.trim()) {
    filteredLeads.value = [];
    return;
  }

  isSearchingLeads.value = true;

  const query = leadsSearchQuery.value.toLowerCase();
  filteredLeads.value = leads.value.filter(
    (lead) =>
      (lead.name && lead.name.toLowerCase().includes(query)) ||
      (lead.email && lead.email.toLowerCase().includes(query)) ||
      (lead.phone && lead.phone.includes(query))
  );

  isSearchingLeads.value = false;
};

const selectLead = (lead: any) => {
  // Check if lead is already added
  const isAlreadyAdded = newEvent.value.participants.some(
    (p) => p.email === lead.email || p.name === lead.name
  );

  if (isAlreadyAdded) {
    showToast("calendar.leadAlreadyAdded", "warning");
    return;
  }

  // Find first empty participant slot
  const emptyIndex = newEvent.value.participants.findIndex(p => !p.name || p.name.trim() === "");
  
  const participantData = {
    name: lead.name || "ללא שם",
    email: lead.email || "",
    phone: lead.phone || "",
    type: "lead",
    leadId: lead.id,
  };

  if (emptyIndex !== -1) {
    // Fill empty slot
    newEvent.value.participants[emptyIndex] = participantData;
  } else {
    // Add new participant if no empty slots
    newEvent.value.participants.push(participantData);
  }

  closeLeadsSearch();
};

// Select lead for edit modal
const selectLeadForEdit = (lead: any) => {
  if (!editingEvent.value.participants) {
    editingEvent.value.participants = [];
  }

  // Check if lead is already added
  const isAlreadyAdded = editingEvent.value.participants.some(
    (p) => p.email === lead.email || p.name === lead.name
  );

  if (isAlreadyAdded) {
    showToast("calendar.leadAlreadyAdded", "warning");
    return;
  }

  // Find first empty participant slot
  const emptyIndex = editingEvent.value.participants.findIndex(p => !p.name || p.name.trim() === "");
  
  const participantData = {
    name: lead.name || "ללא שם",
    email: lead.email || "",
    phone: lead.phone || "",
    type: "lead",
    leadId: lead.id,
  };

  if (emptyIndex !== -1) {
    // Fill empty slot
    editingEvent.value.participants[emptyIndex] = participantData;
  } else {
    // Add new participant if no empty slots
    editingEvent.value.participants.push(participantData);
  }

  closeLeadsSearch();
};

const closeLeadsSearch = () => {
  showLeadsSearch.value = false;
  leadsSearchQuery.value = "";
  filteredLeads.value = [];
};

// Clients Search functionality
const openClientsSearch = () => {
  isEditMode.value = false;
  showClientsSearch.value = true;
  clientsSearchQuery.value = "";
  filteredClients.value = [];
  fetchClients();
};

const openClientsSearchForEdit = () => {
  isEditMode.value = true;
  showClientsSearch.value = true;
  clientsSearchQuery.value = "";
  filteredClients.value = [];
  fetchClients();
};

const fetchClients = async () => {
  try {
    loadingClients.value = true;

    const { organizationId } = await getCurrentUserOrgId();

    const { data, error } = await supabase
      .from("clients")
      .select("id, first_name, last_name, email, phone, status")
      .eq("organization_id", organizationId)
      .order("first_name");

    if (error) throw error;

    clients.value =
      data?.map((client) => ({
        ...client,
        name: `${client.first_name || ""} ${client.last_name || ""}`.trim() || "ללא שם",
      })) || [];

    console.log("Loaded clients:", clients.value);
  } catch (error) {
    console.error("Error fetching clients:", error);
    clients.value = [];
  } finally {
    loadingClients.value = false;
  }
};

const searchClients = async () => {
  if (!clientsSearchQuery.value.trim()) {
    filteredClients.value = [];
    return;
  }

  isSearchingClients.value = true;

  const query = clientsSearchQuery.value.toLowerCase();
  filteredClients.value = clients.value.filter(
    (client) =>
      (client.name && client.name.toLowerCase().includes(query)) ||
      (client.first_name && client.first_name.toLowerCase().includes(query)) ||
      (client.last_name && client.last_name.toLowerCase().includes(query)) ||
      (client.email && client.email.toLowerCase().includes(query)) ||
      (client.phone && client.phone.includes(query))
  );

  isSearchingClients.value = false;
};

const selectClient = (client: any) => {
  // Check if client is already added
  const isAlreadyAdded = newEvent.value.participants.some(
    (p) => p.email === client.email || p.name === client.name
  );

  if (isAlreadyAdded) {
    showToast("calendar.clientAlreadyAdded", "warning");
    return;
  }

  // Find first empty participant slot
  const emptyIndex = newEvent.value.participants.findIndex(p => !p.name || p.name.trim() === "");
  
  const participantData = {
    name: client.name,
    email: client.email || "",
    phone: client.phone || "",
    type: "client",
    clientId: client.id,
  };

  if (emptyIndex !== -1) {
    // Fill empty slot
    newEvent.value.participants[emptyIndex] = participantData;
  } else {
    // Add new participant if no empty slots
    newEvent.value.participants.push(participantData);
  }

  closeClientsSearch();
};

// Select client for edit modal
const selectClientForEdit = (client: any) => {
  if (!editingEvent.value.participants) {
    editingEvent.value.participants = [];
  }

  // Check if client is already added
  const isAlreadyAdded = editingEvent.value.participants.some(
    (p) => p.email === client.email || p.name === client.name
  );

  if (isAlreadyAdded) {
    showToast("calendar.clientAlreadyAdded", "warning");
    return;
  }

  // Find first empty participant slot
  const emptyIndex = editingEvent.value.participants.findIndex(p => !p.name || p.name.trim() === "");
  
  const participantData = {
    name: client.name,
    email: client.email || "",
    phone: client.phone || "",
    type: "client",
    clientId: client.id,
  };

  if (emptyIndex !== -1) {
    // Fill empty slot
    editingEvent.value.participants[emptyIndex] = participantData;
  } else {
    // Add new participant if no empty slots
    editingEvent.value.participants.push(participantData);
  }

  closeClientsSearch();
};

const closeClientsSearch = () => {
  showClientsSearch.value = false;
  clientsSearchQuery.value = "";
  filteredClients.value = [];
};

// Toast and Popup functions
const showToast = (
  messageKey: string,
  type: "success" | "error" | "warning" | "info" = "info",
  params: any = {}
) => {
  const id = Date.now() + Math.random();
  const toast = {
    id,
    messageKey,
    type,
    params,
    message: t(messageKey, params),
  };

  toasts.value.push(toast);

  // Auto remove after 5 seconds
  setTimeout(() => {
    removeToast(id);
  }, 5000);
};

const removeToast = (id: number) => {
  const index = toasts.value.findIndex((toast) => toast.id === id);
  if (index > -1) {
    toasts.value.splice(index, 1);
  }
};

const showConfirm = (
  titleKey: string,
  messageKey: string,
  confirmAction: () => void,
  confirmTextKey = "common.confirm",
  cancelTextKey = "common.cancel",
  type: "warning" | "danger" | "info" | "success" = "warning",
  params: any = {}
) => {
  confirmPopup.value = {
    title: t(titleKey, params),
    message: t(messageKey, params),
    confirmText: t(confirmTextKey),
    cancelText: t(cancelTextKey),
    confirmAction,
    type,
  };
  showConfirmPopup.value = true;
};

const closeConfirmPopup = () => {
  showConfirmPopup.value = false;
  confirmPopup.value.confirmAction = null;
};

const confirmAction = () => {
  if (confirmPopup.value.confirmAction) {
    confirmPopup.value.confirmAction();
  }
  closeConfirmPopup();
};

// Simple confirm function for basic yes/no questions
const showSimpleConfirmDialog = (
  messageKey: string,
  callback: () => void,
  params: any = {}
) => {
  simpleConfirmMessage.value = t(messageKey, params);
  simpleConfirmCallback.value = callback;
  showSimpleConfirm.value = true;
};

const closeSimpleConfirm = () => {
  showSimpleConfirm.value = false;
  simpleConfirmCallback.value = null;
};

const confirmSimpleAction = () => {
  if (simpleConfirmCallback.value) {
    simpleConfirmCallback.value();
  }
  closeSimpleConfirm();
};

// Update calendar title based on view
const calendarTitle = computed(() => {
  const date = currentDate.value;

  if (currentView.value === "day") {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } else {
    // Week view
    const startOfWeek = new Date(date);
    startOfWeek.setDate(date.getDate() - date.getDay());
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);

    if (startOfWeek.getMonth() === endOfWeek.getMonth()) {
      return `${startOfWeek.toLocaleDateString("en-US", {
        month: "long",
        year: "numeric",
      })}`;
    } else {
      return `${startOfWeek.toLocaleDateString("en-US", {
        month: "short",
      })} - ${endOfWeek.toLocaleDateString("en-US", {
        month: "short",
        year: "numeric",
      })}`;
    }
  }
});

// Filtered products for search
const filteredProducts = computed(() => {
  if (!productSearchQuery.value.trim()) {
    return products.value;
  }

  const query = productSearchQuery.value.toLowerCase().trim();
  return products.value.filter(
    (product) =>
      product.title.toLowerCase().includes(query) ||
      (product.description && product.description.toLowerCase().includes(query))
  );
});

// Calendar Settings functions
const toggleSettings = () => {
  showSettings.value = !showSettings.value;
};

// Fetch breaks from database
const fetchBreaks = async () => {
  try {
    loadingBreaks.value = true;

    // Get current user ID
    const { data: userData, error: userError } = await supabase.auth.getUser();
    if (userError) throw userError;

    if (!userData.user) {
      throw new Error("User is not authenticated");
    }

    const { data, error } = await supabase
      .from("customer_appointment_break")
      .select("*")
      .eq("user_id", userData.user.id)
      .order("created_at");

    if (error) throw error;

    // Transform data to match existing structure
    blockedTimes.value =
      data?.map((breakItem) => ({
        id: breakItem.id,
        name: breakItem.title || "Break",
        startTime: breakItem.start_time || "09:00",
        endTime: breakItem.end_time || "10:00",
        days: breakItem.days || [],
        isNew: false,
        isEditing: false,
      })) || [];

    console.log("Loaded breaks:", blockedTimes.value);
  } catch (error) {
    console.error("Failed to fetch breaks:", error);
    blockedTimes.value = [];
  } finally {
    loadingBreaks.value = false;
  }
};

const addBlockedTime = () => {
  blockedTimes.value.push({
    id: null,
    name: "New Break",
    startTime: "09:00",
    endTime: "10:00",
    days: [],
    isNew: true,
    isEditing: true,
  });
};

const removeBlockedTime = async (index: number) => {
  const breakItem = blockedTimes.value[index];

  if (!breakItem.id) {
    // If it's a new item (no ID), just remove from array
    blockedTimes.value.splice(index, 1);
    return;
  }

  const deleteBreak = () => {
    performDeleteBreak(index);
  };

  showConfirm(
    "calendar.confirmDeleteBreak",
    "calendar.confirmDeleteBreakMessage",
    deleteBreak,
    "common.delete",
    "common.cancel",
    "danger"
  );

  return; // Exit early, actual deletion will happen in the confirm callback

  async function performDeleteBreak(index: number) {
    try {
      savingBreak.value = true;

      // Delete from database
      const { error } = await supabase
        .from("customer_appointment_break")
        .delete()
        .eq("id", breakItem.id);

      if (error) throw error;

      // Remove from array
      blockedTimes.value.splice(index, 1);

      console.log("Break deleted successfully");
    } catch (error) {
      console.error("Error deleting break:", error);
      showToast("calendar.breakDeleteError", "error");
    } finally {
      savingBreak.value = false;
    }
  }
};

const saveBreak = async (breakItem: any, index: number) => {
  if (!breakItem.name?.trim()) {
    showToast("calendar.breakNameRequired", "warning");
    return;
  }

  if (!breakItem.startTime || !breakItem.endTime) {
    showToast("calendar.breakTimesRequired", "warning");
    return;
  }

  try {
    savingBreak.value = true;

    // Get current user ID
    const { data: userData, error: userError } = await supabase.auth.getUser();
    if (userError) throw userError;

    if (!userData.user) {
      throw new Error("User is not authenticated");
    }

    const breakData = {
      title: breakItem.name.trim(),
      start_time: breakItem.startTime,
      end_time: breakItem.endTime,
      days: breakItem.days || [],
      user_id: userData.user.id,
    };

    if (breakItem.isNew) {
      // Create new break
      const { data, error } = await supabase
        .from("customer_appointment_break")
        .insert(breakData)
        .select("id")
        .single();

      if (error) throw error;

      // Update the break with the new ID
      blockedTimes.value[index] = {
        ...breakItem,
        id: data.id,
        isNew: false,
        isEditing: false,
      };
    } else {
      // Update existing break
      const { error } = await supabase
        .from("customer_appointment_break")
        .update(breakData)
        .eq("id", breakItem.id);

      if (error) throw error;

      // Update the break
      blockedTimes.value[index] = {
        ...breakItem,
        isEditing: false,
      };
    }

    console.log("Break saved successfully");
  } catch (error) {
    console.error("Error saving break:", error);
    showToast("calendar.breakSaveError", "error");
  } finally {
    savingBreak.value = false;
  }
};

const editBreak = (index: number) => {
  blockedTimes.value[index].isEditing = true;
};

const cancelEditBreak = (index: number) => {
  const breakItem = blockedTimes.value[index];
  if (breakItem.isNew) {
    blockedTimes.value.splice(index, 1);
  } else {
    breakItem.isEditing = false;
  }
};

// Employee Availability functions
const fetchEmployeeAvailability = async () => {
  try {
    loadingAvailability.value = true;

    // Get current user info
    const { userId, organizationId } = await getCurrentUserOrgId();

    const { data, error } = await supabase
      .from("employee_availability")
      .select("*")
      .eq("user_id", userId)
      .eq("org_id", organizationId)
      .eq("is_active", true)
      .single();

    if (error && error.code !== "PGRST116") {
      // PGRST116 = no rows returned
      throw error;
    }

    if (data) {
      // Transform database data to workingDays format
      workingDays.value = [
        {
          key: "Mon",
          name: "Monday",
          short: "Mon",
          enabled: data.monday_available || false,
          startTime: data.monday_start_time || "09:00",
          endTime: data.monday_end_time || "17:00",
        },
        {
          key: "Tue",
          name: "Tuesday",
          short: "Tue",
          enabled: data.tuesday_available || false,
          startTime: data.tuesday_start_time || "09:00",
          endTime: data.tuesday_end_time || "17:00",
        },
        {
          key: "Wed",
          name: "Wednesday",
          short: "Wed",
          enabled: data.wednesday_available || false,
          startTime: data.wednesday_start_time || "09:00",
          endTime: data.wednesday_end_time || "17:00",
        },
        {
          key: "Thu",
          name: "Thursday",
          short: "Thu",
          enabled: data.thursday_available || false,
          startTime: data.thursday_start_time || "09:00",
          endTime: data.thursday_end_time || "17:00",
        },
        {
          key: "Fri",
          name: "Friday",
          short: "Fri",
          enabled: data.friday_available || false,
          startTime: data.friday_start_time || "09:00",
          endTime: data.friday_end_time || "17:00",
        },
        {
          key: "Sat",
          name: "Saturday",
          short: "Sat",
          enabled: data.saturday_available || false,
          startTime: data.saturday_start_time || "10:00",
          endTime: data.saturday_end_time || "14:00",
        },
        {
          key: "Sun",
          name: "Sunday",
          short: "Sun",
          enabled: data.sunday_available || false,
          startTime: data.sunday_start_time || "10:00",
          endTime: data.sunday_end_time || "14:00",
        },
      ];

      workingHoursEnabled.value = workingDays.value.some((day) => day.enabled);
    } else {
      // Set default values if no data found
      workingDays.value = [
        {
          key: "Mon",
          name: "Monday",
          short: "Mon",
          enabled: true,
          startTime: "09:00",
          endTime: "17:00",
        },
        {
          key: "Tue",
          name: "Tuesday",
          short: "Tue",
          enabled: true,
          startTime: "09:00",
          endTime: "17:00",
        },
        {
          key: "Wed",
          name: "Wednesday",
          short: "Wed",
          enabled: true,
          startTime: "09:00",
          endTime: "17:00",
        },
        {
          key: "Thu",
          name: "Thursday",
          short: "Thu",
          enabled: true,
          startTime: "09:00",
          endTime: "17:00",
        },
        {
          key: "Fri",
          name: "Friday",
          short: "Fri",
          enabled: true,
          startTime: "09:00",
          endTime: "17:00",
        },
        {
          key: "Sat",
          name: "Saturday",
          short: "Sat",
          enabled: false,
          startTime: "10:00",
          endTime: "14:00",
        },
        {
          key: "Sun",
          name: "Sunday",
          short: "Sun",
          enabled: false,
          startTime: "10:00",
          endTime: "14:00",
        },
      ];
      workingHoursEnabled.value = true;
    }

    console.log("Loaded employee availability:", workingDays.value);
  } catch (error) {
    console.error("Failed to fetch employee availability:", error);
    // Set defaults on error
    workingDays.value = [
      {
        key: "Mon",
        name: "Monday",
        short: "Mon",
        enabled: true,
        startTime: "09:00",
        endTime: "17:00",
      },
      {
        key: "Tue",
        name: "Tuesday",
        short: "Tue",
        enabled: true,
        startTime: "09:00",
        endTime: "17:00",
      },
      {
        key: "Wed",
        name: "Wednesday",
        short: "Wed",
        enabled: true,
        startTime: "09:00",
        endTime: "17:00",
      },
      {
        key: "Thu",
        name: "Thursday",
        short: "Thu",
        enabled: true,
        startTime: "09:00",
        endTime: "17:00",
      },
      {
        key: "Fri",
        name: "Friday",
        short: "Fri",
        enabled: true,
        startTime: "09:00",
        endTime: "17:00",
      },
      {
        key: "Sat",
        name: "Saturday",
        short: "Sat",
        enabled: false,
        startTime: "10:00",
        endTime: "14:00",
      },
      {
        key: "Sun",
        name: "Sunday",
        short: "Sun",
        enabled: false,
        startTime: "10:00",
        endTime: "14:00",
      },
    ];
    workingHoursEnabled.value = true;
  } finally {
    loadingAvailability.value = false;
  }
};

const saveEmployeeAvailability = async () => {
  try {
    savingAvailability.value = true;

    // Get current user info
    const { userId, organizationId } = await getCurrentUserOrgId();

    // Prepare availability data
    const availabilityData = {
      user_id: userId,
      org_id: organizationId,
      sunday_available: workingDays.value.find((d) => d.key === "Sun")?.enabled || false,
      sunday_start_time:
        workingDays.value.find((d) => d.key === "Sun")?.startTime || null,
      sunday_end_time: workingDays.value.find((d) => d.key === "Sun")?.endTime || null,
      monday_available: workingDays.value.find((d) => d.key === "Mon")?.enabled || false,
      monday_start_time:
        workingDays.value.find((d) => d.key === "Mon")?.startTime || null,
      monday_end_time: workingDays.value.find((d) => d.key === "Mon")?.endTime || null,
      tuesday_available: workingDays.value.find((d) => d.key === "Tue")?.enabled || false,
      tuesday_start_time:
        workingDays.value.find((d) => d.key === "Tue")?.startTime || null,
      tuesday_end_time: workingDays.value.find((d) => d.key === "Tue")?.endTime || null,
      wednesday_available:
        workingDays.value.find((d) => d.key === "Wed")?.enabled || false,
      wednesday_start_time:
        workingDays.value.find((d) => d.key === "Wed")?.startTime || null,
      wednesday_end_time: workingDays.value.find((d) => d.key === "Wed")?.endTime || null,
      thursday_available:
        workingDays.value.find((d) => d.key === "Thu")?.enabled || false,
      thursday_start_time:
        workingDays.value.find((d) => d.key === "Thu")?.startTime || null,
      thursday_end_time: workingDays.value.find((d) => d.key === "Thu")?.endTime || null,
      friday_available: workingDays.value.find((d) => d.key === "Fri")?.enabled || false,
      friday_start_time:
        workingDays.value.find((d) => d.key === "Fri")?.startTime || null,
      friday_end_time: workingDays.value.find((d) => d.key === "Fri")?.endTime || null,
      saturday_available:
        workingDays.value.find((d) => d.key === "Sat")?.enabled || false,
      saturday_start_time:
        workingDays.value.find((d) => d.key === "Sat")?.startTime || null,
      saturday_end_time: workingDays.value.find((d) => d.key === "Sat")?.endTime || null,
      is_active: true,
    };

    // Check if record exists
    const { data: existingData, error: checkError } = await supabase
      .from("employee_availability")
      .select("id")
      .eq("user_id", userId)
      .eq("org_id", organizationId)
      .eq("is_active", true)
      .single();

    if (checkError && checkError.code !== "PGRST116") {
      throw checkError;
    }

    if (existingData) {
      // Update existing record
      const { error } = await supabase
        .from("employee_availability")
        .update(availabilityData)
        .eq("id", existingData.id);

      if (error) throw error;
    } else {
      // Create new record
      const { error } = await supabase
        .from("employee_availability")
        .insert(availabilityData);

      if (error) throw error;
    }

    console.log("Employee availability saved successfully");
    showToast("calendar.workingHoursSaved", "success");
  } catch (error) {
    console.error("Error saving employee availability:", error);
    showToast("calendar.workingHoursSaveError", "error");
  } finally {
    savingAvailability.value = false;
  }
};

const addAppointmentType = () => {
  appointmentTypes.value.push({
    id: null, // null for new items
    name: "סוג פגישה חדש",
    duration: 30,
    color: "work",
    colorCode: "#3b82f6",
    tag: "",
    tagColorCode: "#3b82f6",
    canAllUsersSee: true,
    productId: null,
    selectedUsers: [],
    isNew: true,
    isEditing: true,
  });
};

const removeAppointmentType = async (index: number) => {
  const type = appointmentTypes.value[index];

  if (!type.id) {
    // If it's a new item (no ID), just remove from array
    appointmentTypes.value.splice(index, 1);
    return;
  }

  const deleteType = () => {
    performDeleteAppointmentType(index);
  };

  showConfirm(
    "calendar.confirmDeleteAppointmentType",
    "calendar.confirmDeleteAppointmentTypeMessage",
    deleteType,
    "common.delete",
    "common.cancel",
    "danger"
  );

  return; // Exit early, actual deletion will happen in the confirm callback

  async function performDeleteAppointmentType(index: number) {
    try {
      savingAppointmentType.value = true;

      // Delete from database
      const { error } = await supabase
        .from("customer_appointment_types")
        .delete()
        .eq("id", type.id);

      if (error) throw error;

      // Delete access records
      await supabase
        .from("customer_appointment_access")
        .delete()
        .eq("appointment_id", type.id);

      // Remove from array
      appointmentTypes.value.splice(index, 1);

      console.log("Appointment type deleted successfully");
    } catch (error) {
      console.error("Error deleting appointment type:", error);
      showToast("calendar.appointmentTypeDeleteError", "error");
    } finally {
      savingAppointmentType.value = false;
    }
  }
};

const saveAppointmentType = async (type: any, index: number) => {
  if (!type.name?.trim()) {
    showToast("calendar.appointmentTypeNameRequired", "warning");
    return;
  }

  try {
    savingAppointmentType.value = true;

    const { organizationId } = await getCurrentUserOrgId();

    const appointmentData = {
      organization_id: organizationId,
      name: type.name.trim(),
      color_code: type.colorCode,
      duration: type.duration,
      tag: type.tag?.trim() || null,
      tag_color_code: type.tagColorCode,
      can_all_users_see: type.canAllUsersSee,
      product_id: type.productId || null,
    };

    let appointmentId = type.id;

    if (type.isNew) {
      // Create new appointment type
      const { data, error } = await supabase
        .from("customer_appointment_types")
        .insert(appointmentData)
        .select("id")
        .single();

      if (error) throw error;
      appointmentId = data.id;

      // Update the type with the new ID
      appointmentTypes.value[index] = {
        ...type,
        id: appointmentId,
        isNew: false,
        isEditing: false,
      };
    } else {
      // Update existing appointment type
      const { error } = await supabase
        .from("customer_appointment_types")
        .update(appointmentData)
        .eq("id", type.id);

      if (error) throw error;

      // Update the type
      appointmentTypes.value[index] = {
        ...type,
        isEditing: false,
      };
    }

    // Handle access control
    if (!type.canAllUsersSee && type.selectedUsers?.length > 0) {
      // Delete existing access records
      await supabase
        .from("customer_appointment_access")
        .delete()
        .eq("appointment_id", appointmentId);

      // Insert new access records
      const accessRecords = type.selectedUsers.map((userId: string) => ({
        appointment_id: appointmentId,
        access_user: userId,
      }));

      const { error: accessError } = await supabase
        .from("customer_appointment_access")
        .insert(accessRecords);

      if (accessError) throw accessError;
    } else if (type.canAllUsersSee) {
      // If switching to "all users can see", delete specific access records
      await supabase
        .from("customer_appointment_access")
        .delete()
        .eq("appointment_id", appointmentId);
    }

    console.log("Appointment type saved successfully");
  } catch (error) {
    console.error("Error saving appointment type:", error);
    showToast("calendar.appointmentTypeSaveError", "error");
  } finally {
    savingAppointmentType.value = false;
  }
};

const editAppointmentType = (index: number) => {
  appointmentTypes.value[index].isEditing = true;
};

const cancelEditAppointmentType = (index: number) => {
  const type = appointmentTypes.value[index];
  if (type.isNew) {
    appointmentTypes.value.splice(index, 1);
  } else {
    type.isEditing = false;
    // No need to reload - just reset the editing state
    // The original data is preserved in the database
  }
};

const adjustDuration = (type: any, change: number) => {
  const newDuration = type.duration + change;
  if (newDuration >= 15 && newDuration <= 480) {
    type.duration = newDuration;
  }
};

const validateDuration = (type: any) => {
  if (type.duration < 15) type.duration = 15;
  if (type.duration > 480) type.duration = 480;
  // Round to nearest 15 minutes
  type.duration = Math.round(type.duration / 15) * 15;
};

const getColorValue = (colorKey: string) => {
  const color = colorOptions.value.find((c) => c.value === colorKey);
  return color ? color.bg : "#3b82f6";
};

const resetSettings = () => {
  const performReset = () => {
    // Reset working days
    workingDays.value = [
      {
        key: "Mon",
        name: "Monday",
        short: "Mon",
        enabled: true,
        startTime: "09:00",
        endTime: "17:00",
      },
      {
        key: "Tue",
        name: "Tuesday",
        short: "Tue",
        enabled: true,
        startTime: "09:00",
        endTime: "17:00",
      },
      {
        key: "Wed",
        name: "Wednesday",
        short: "Wed",
        enabled: true,
        startTime: "09:00",
        endTime: "17:00",
      },
      {
        key: "Thu",
        name: "Thursday",
        short: "Thu",
        enabled: true,
        startTime: "09:00",
        endTime: "17:00",
      },
      {
        key: "Fri",
        name: "Friday",
        short: "Fri",
        enabled: true,
        startTime: "09:00",
        endTime: "17:00",
      },
      {
        key: "Sat",
        name: "Saturday",
        short: "Sat",
        enabled: false,
        startTime: "10:00",
        endTime: "14:00",
      },
      {
        key: "Sun",
        name: "Sunday",
        short: "Sun",
        enabled: false,
        startTime: "10:00",
        endTime: "14:00",
      },
    ];

    // Reset blocked times
    blockedTimes.value = [
      {
        name: "Lunch Break",
        startTime: "12:00",
        endTime: "13:00",
        days: ["Mon", "Tue", "Wed", "Thu", "Fri"],
      },
    ];

    // Reset appointment types
    appointmentTypes.value = [
      { name: "Face Treatment", duration: 40, color: "personal" },
      { name: "Pedicure", duration: 90, color: "health" },
      { name: "Manicure", duration: 60, color: "work" },
    ];

    workingHoursEnabled.value = true;

    showToast("calendar.settingsReset", "success");
  };

  showConfirm(
    "calendar.confirmResetSettings",
    "calendar.confirmResetSettingsMessage",
    performReset,
    "common.reset",
    "common.cancel",
    "warning"
  );
};

const isTimeBlocked = (dateStr: string, hour: number) => {
  const date = new Date(dateStr);
  const dayName = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][date.getDay()];
  const dayKey = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][date.getDay()];

  // Check if time is blocked by breaks
  const isBreakTime = blockedTimes.value.some((block) => {
    if (!block.days.includes(dayName)) return false;

    const blockStart = parseInt(block.startTime.split(":")[0]);
    const blockEnd = parseInt(block.endTime.split(":")[0]);

    return hour >= blockStart && hour < blockEnd;
  });

  if (isBreakTime) return true;

  // Check if time is outside working hours
  const workingDay = workingDays.value.find((wd) => wd.key === dayKey);
  if (!workingDay || !workingDay.enabled) {
    return true; // Block entire day if not a working day
  }

  const workStart = parseInt(workingDay.startTime.split(":")[0]);
  const workEnd = parseInt(workingDay.endTime.split(":")[0]);

  // Block if outside working hours
  return hour < workStart || hour >= workEnd;
};

// Check if a day of the week is blocked (for month view)
const isDayOfWeekBlocked = (dateStr: string) => {
  const date = new Date(dateStr);
  const dayOfWeek = date.getDay(); // 0=Sunday, 1=Monday, etc.
  // Map JavaScript getDay() to our workingDays keys
  const dayMapping = {
    6: "Sun", // Sunday
    0: "Mon", // Monday 
    1: "Tue", // Tuesday
    2: "Wed", // Wednesday
    3: "Thu", // Thursday
    4: "Fri", // Friday
    5: "Sat"  // Saturday
  };
  const dayKey = dayMapping[dayOfWeek];
  
  const workingDay = workingDays.value.find(wd => wd.key === dayKey);
  return !workingDay?.enabled; // Return true if day is not available
};

// Helper function to format time correctly in local timezone
const formatTimeInLocalTimezone = (date: Date) => {
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
};

// Helper function to create date from database timestamp (treat as local time)
const createLocalDateFromDB = (dbTimestamp: string) => {
  // בדיקה שהtimestamp תקין
  if (!dbTimestamp || typeof dbTimestamp !== 'string') {
    console.warn("⚠️ Invalid database timestamp:", dbTimestamp);
    return new Date(); // חזור לתאריך נוכחי כdefault
  }

  // Remove timezone indicators to treat as local time
  // Handles formats like: '2025-06-29 06:15:00+00', '2025-06-29T06:15:00Z', etc.
  const cleanTimestamp = dbTimestamp
    .replace('Z', '')           // Remove Z
    .replace('+00', '')         // Remove +00
    .replace('+00:00', '')      // Remove +00:00
    .replace('-00:00', '')      // Remove -00:00
    .replace('T', ' ');         // Replace T with space for consistent format
  
  const date = new Date(cleanTimestamp);
  
  // בדיקה שהתוצאה תקינה
  if (isNaN(date.getTime())) {
    console.warn("⚠️ Invalid date created from timestamp:", dbTimestamp, "cleaned:", cleanTimestamp);
    return new Date(); // חזור לתאריך נוכחי כdefault
  }
  
  return date;
};

const updateEventDuration = () => {
  // Find the selected appointment type
  const selectedType = appointmentTypes.value.find(
    (type) => type.name === newEvent.value.type
  );

  if (selectedType && newEvent.value.startTime) {
    // Calculate end time based on duration
    const startTime = new Date(`2000-01-01T${newEvent.value.startTime}`);
    const endTime = new Date(startTime.getTime() + selectedType.duration * 60000); // Add duration in milliseconds

    // Format end time as HH:MM
    const hours = endTime.getHours().toString().padStart(2, "0");
    const minutes = endTime.getMinutes().toString().padStart(2, "0");
    newEvent.value.endTime = `${hours}:${minutes}`;
  }

  console.log("Event type changed:", newEvent.value.type, "Duration set automatically");
};

const handleImageError = () => {
  userProfilePicture.value = defaultProfileImage;
};

// Fetch appointment types from database
const fetchAppointmentTypes = async () => {
  try {
    loadingAppointmentTypes.value = true;

    const { userId, organizationId } = await getCurrentUserOrgId();

    // Query to get appointment types with access logic
    const { data, error } = await supabase
      .from("customer_appointment_types")
      .select(
        `
        id,
        name,
        color_code,
        duration,
        tag,
        tag_color_code,
        can_all_users_see,
        product_id,
        customer_appointment_access (
          access_user
        )
      `
      )
      .eq("organization_id", organizationId);

    if (error) {
      console.error("Error fetching appointment types:", error);
      throw error;
    }

    // Filter based on access logic
    const filteredTypes =
      data?.filter((type) => {
        // If can_all_users_see is true, always include
        if (type.can_all_users_see) {
          return true;
        }

        // If can_all_users_see is false, check if user has specific access
        const accessArray = Array.isArray(type.customer_appointment_access)
          ? type.customer_appointment_access
          : [];

        return accessArray.some((access: any) => access.access_user === userId);
      }) || [];

    // Transform to match existing structure
    appointmentTypes.value = filteredTypes.map((type) => {
      const accessArray = Array.isArray(type.customer_appointment_access)
        ? type.customer_appointment_access
        : [];

      return {
        id: type.id,
        name: type.name || "Unnamed Type",
        duration: type.duration || 30,
        color: mapColorCodeToColorKey(type.color_code),
        colorCode: type.color_code || "#3b82f6",
        tag: type.tag || "",
        tagColorCode: type.tag_color_code || "#3b82f6",
        canAllUsersSee: type.can_all_users_see,
        productId: type.product_id,
        selectedUsers: accessArray.map((access: any) => access.access_user),
        isNew: false,
        isEditing: false,
      };
    });

    console.log("Loaded appointment types:", appointmentTypes.value);
  } catch (error) {
    console.error("Failed to fetch appointment types:", error);
    // Fallback to default types on error
    appointmentTypes.value = [
      {
        name: "General Appointment",
        duration: 30,
        color: "work",
      },
    ];
  } finally {
    loadingAppointmentTypes.value = false;
  }
};

// Helper function to map color codes to color keys
const mapColorCodeToColorKey = (colorCode: string) => {
  const colorMap: { [key: string]: string } = {
    "#fbbf24": "personal",
    "#3b82f6": "work",
    "#ec4899": "health",
    "#22c55e": "meeting",
    "#8b5cf6": "call",
    "#6b7280": "task",
  };

  return colorMap[colorCode] || "work"; // Default to 'work' if not found
};

// Fetch products for linking
const fetchProducts = async () => {
  try {
    loadingProducts.value = true;

    const { organizationId } = await getCurrentUserOrgId();

    const { data, error } = await supabase
      .from("products")
      .select("id, title, description, price")
      .eq("org_id", organizationId)
      .order("title");

    if (error) throw error;

    // Transform data to match expected format
    products.value =
      data?.map((product) => ({
        id: product.id,
        name: product.title, // Map title to name for compatibility
        title: product.title,
        description: product.description,
        price: product.price,
        displayName: `${product.title}${product.price ? ` - ₪${product.price}` : ""}`,
      })) || [];
  } catch (error) {
    console.error("Error fetching products:", error);
    products.value = [];
  } finally {
    loadingProducts.value = false;
  }
};

// Fetch users for access control
const fetchUsers = async () => {
  try {
    loadingUsers.value = true;

    const { organizationId } = await getCurrentUserOrgId();

    const { data, error } = await supabase
      .from("user_profiles")
      .select("user_id, display_name, email")
      .eq("org_id", organizationId)
      .order("display_name");

    if (error) throw error;

    users.value =
      data?.map((u) => ({
        id: u.user_id,
        full_name: u.display_name || u.email,
      })) || [];
  } catch (error) {
    console.error("Error fetching users:", error);
    users.value = [];
  } finally {
    loadingUsers.value = false;
  }
};

// Product search functions
const selectProduct = (product: any, type: any) => {
  type.productId = product.id;
  productSearchQuery.value = product.title;
  showProductDropdown.value = false;
};

const clearProductSelection = (type: any) => {
  type.productId = null;
  productSearchQuery.value = "";
  showProductDropdown.value = false;
};

const getSelectedProductName = (productId: string | null) => {
  if (!productId) return "";
  const product = products.value.find((p) => p.id === productId);
  return product ? product.title : "";
};

const openEditEventModal = () => {
  if (!selectedEvent.value) return;

  // Convert the event data to editable format before closing the modal
  const event = selectedEvent.value;
  const startDate = new Date(event.start);
  const endDate = new Date(event.end);

  editingEvent.value = {
    id: event.id,
    title: event.title || "",
    type: event.type || "",
    date: startDate.toISOString().split("T")[0], // YYYY-MM-DD format
            startTime: formatTimeInLocalTimezone(startDate), // HH:MM format
        endTime: formatTimeInLocalTimezone(endDate), // HH:MM format
    location: event.location || "",
    description: event.description || "",
    colorClass: event.colorClass,
    participants: event.participants
      ? [...event.participants]
      : [{ name: "", email: "", phone: "" }],
  };

  // Close the event details modal after saving the data
  closeEventDetail();

  showEditEventModal.value = true;
};

const closeEditEventModal = () => {
  showEditEventModal.value = false;
  editingEvent.value = null;
};

const updateEvent = async () => {
  if (!editingEvent.value) return;

  // Validation
  if (
    !editingEvent.value.title ||
    !editingEvent.value.date ||
    !editingEvent.value.startTime ||
    !editingEvent.value.endTime
  ) {
    showToast("calendar.fillAllFields", "warning");
    return;
  }

  // Create new date objects
  const startDateTime = new Date(
    `${editingEvent.value.date}T${editingEvent.value.startTime}`
  );
  const endDateTime = new Date(
    `${editingEvent.value.date}T${editingEvent.value.endTime}`
  );

  // Validate end time is after start time
  if (endDateTime <= startDateTime) {
    showToast("calendar.endTimeAfterStart", "warning");
    return;
  }

  try {
    // מציאת סוג האירוע אם זה סוג מותאם אישית
    const appointmentType = appointmentTypes.value.find(
      (type) => type.name === editingEvent.value.type
    );
    const eventTypeId = appointmentType?.id || null;

    // עדכון במסד נתונים
    console.log("🕐 Editing - Original startDateTime:", startDateTime.toString());
    console.log("🕐 Editing - Original endDateTime:", endDateTime.toString());
    console.log("🕐 Editing - Saving startTime as:", createLocalISOString(startDateTime));
    console.log("🕐 Editing - Saving endTime as:", createLocalISOString(endDateTime));
    
    const { error: updateError } = await supabase
      .from("calendar_events")
      .update({
        title: editingEvent.value.title,
        start_time: createLocalISOString(startDateTime),
        end_time: createLocalISOString(endDateTime),
        event_type: eventTypeId,
        location: editingEvent.value.location || null,
        description: editingEvent.value.description || null,
        updated_at: createLocalISOString(new Date()),
      })
      .eq("id", editingEvent.value.id);

    if (updateError) {
      console.error("Error updating event:", updateError);
      showToast("calendar.eventUpdateError", "error");
      return;
    }

    // עדכון משתתפים
    if (editingEvent.value.participants) {
      // מחיקת משתתפים קיימים
      await supabase
        .from("calendar_events_participants")
        .delete()
        .eq("event_id", editingEvent.value.id);

      // הוספת משתתפים חדשים
      const validParticipants = editingEvent.value.participants.filter(
        (p) => p.name.trim() !== ""
      );
      if (validParticipants.length > 0) {
        const participantsToInsert = validParticipants.map((participant) => ({
          event_id: editingEvent.value.id,
          lead_id: (participant as any).leadId || null,
          customer_id: (participant as any).clientId || null,
          name: participant.name,
          phone: participant.phone || null,
          email: participant.email || null,
        }));

        const { error: participantsError } = await supabase
          .from("calendar_events_participants")
          .insert(participantsToInsert);

        if (participantsError) {
          console.error("Error updating participants:", participantsError);
        }
      }
    }

    // Find and update the event in the events array
    const eventIndex = events.value.findIndex((e) => e.id === editingEvent.value.id);
    if (eventIndex !== -1) {
      // Update the event
      const existingEvent = events.value[eventIndex];

      // Process participants for display
      const processedParticipants =
        editingEvent.value.participants
          ?.filter((p) => p.name.trim() !== "")
          .map((p, index) => ({
            id: index + 1,
            name: p.name,
            email: p.email,
            phone: p.phone,
            avatar: "/api/placeholder/24/24",
            leadId: (p as any).leadId,
            clientId: (p as any).clientId,
          })) || [];

      events.value[eventIndex] = {
        ...existingEvent,
        title: editingEvent.value.title,
        type: editingEvent.value.type,
        start: startDateTime,
        end: endDateTime,
        timeDisplay: `${formatTimeInLocalTimezone(startDateTime)} - ${formatTimeInLocalTimezone(endDateTime)}`,
        dateDisplay: startDateTime.toLocaleDateString("he-IL", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        }),
        participants: processedParticipants,
        ...(editingEvent.value.location && { location: editingEvent.value.location }),
        ...(editingEvent.value.description && {
          description: editingEvent.value.description,
        }),
      };

      console.log("Event updated successfully");
      showToast("calendar.eventUpdated", "success");

      // Update selectedEvent if it's the same event
      if (selectedEvent.value && selectedEvent.value.id === editingEvent.value.id) {
        selectedEvent.value = {
          ...events.value[eventIndex],
        };
      }
    }

    // Close both modals
    closeEditEventModal();
    closeEventDetail();
  } catch (error) {
    console.error("Error updating event:", error);
    showToast("calendar.eventUpdateError", "error");
  }
};

const deleteEventFromView = async () => {
  if (!selectedEvent.value) return;

  const performDelete = async () => {
    try {
      // קודם מחיקת המשתתפים
      const { error: participantsError } = await supabase
        .from("calendar_events_participants")
        .delete()
        .eq("event_id", selectedEvent.value.id);

      if (participantsError) {
        console.error("Error deleting participants:", participantsError);
        showToast("calendar.deleteParticipantsError", "error");
        return;
      }

      // לאחר מכן מחיקת האירוע
      const { error: deleteError } = await supabase
        .from("calendar_events")
        .delete()
        .eq("id", selectedEvent.value.id);

      if (deleteError) {
        console.error("Error deleting event:", deleteError);
        showToast("calendar.deleteEventError", "error");
        return;
      }

      // Find and remove the event from the events array
      const eventIndex = events.value.findIndex((e) => e.id === selectedEvent.value.id);
      if (eventIndex !== -1) {
        events.value.splice(eventIndex, 1);
        console.log("Event deleted successfully");
        showToast("calendar.eventDeleted", "success");
      }

      // Close modal
      closeEventDetail();
    } catch (error) {
      console.error("Error deleting event:", error);
      showToast("calendar.deleteEventError", "error");
    }
  };

  // Show confirmation dialog
  showSimpleConfirmDialog("calendar.confirmDelete", performDelete);
};

const toggleEventCompletion = async () => {
  if (!selectedEvent.value) return;

  try {
    const newStatus = !selectedEvent.value.is_over;
    
    // עדכון המסד נתונים - החלפת סטטוס הפגישה
    const { error } = await supabase
      .from("calendar_events")
      .update({ is_over: newStatus })
      .eq("id", selectedEvent.value.id);

    if (error) {
      console.error("Error updating event completion status:", error);
      showToast("calendar.eventUpdateError", "error");
      return;
    }

    // עדכון האירוע המקומי במערך
    const eventIndex = events.value.findIndex((e) => e.id === selectedEvent.value.id);
    if (eventIndex !== -1) {
      events.value[eventIndex].is_over = newStatus;
    }

    // עדכון האירוע הנבחר
    selectedEvent.value.is_over = newStatus;

    console.log(`Event status updated to: ${newStatus ? 'completed' : 'not completed'}`);
    showToast(newStatus ? "calendar.eventMarkedCompleted" : "calendar.eventMarkedNotCompleted", "success");

    // סגירת המודל
    closeEventDetail();
  } catch (error) {
    console.error("Error updating event completion status:", error);
    showToast("calendar.eventUpdateError", "error");
  }
};

const deleteEvent = async () => {
  if (!editingEvent.value) return;

  const performDelete = async () => {
    try {
      // קודם מחיקת המשתתפים
      const { error: participantsError } = await supabase
        .from("calendar_events_participants")
        .delete()
        .eq("event_id", editingEvent.value.id);

      if (participantsError) {
        console.error("Error deleting participants:", participantsError);
        showToast("calendar.deleteParticipantsError", "error");
        return;
      }

      // לאחר מכן מחיקת האירוע
      const { error: deleteError } = await supabase
        .from("calendar_events")
        .delete()
        .eq("id", editingEvent.value.id);

      if (deleteError) {
        console.error("Error deleting event:", deleteError);
        showToast("calendar.deleteEventError", "error");
        return;
      }

      // Find and remove the event from the events array
      const eventIndex = events.value.findIndex((e) => e.id === editingEvent.value.id);
      if (eventIndex !== -1) {
        events.value.splice(eventIndex, 1);
        console.log("Event deleted successfully");
        showToast("calendar.eventDeleted", "success");
      }

      // Close both modals
      closeEditEventModal();
      closeEventDetail();
    } catch (error) {
      console.error("Error deleting event:", error);
      showToast("calendar.deleteEventError", "error");
    }
  };

  // Show confirmation dialog
  showSimpleConfirmDialog("calendar.confirmDelete", performDelete);
};

const openSettingsModal = () => {
  showSettingsModal.value = true;
};

const openAppointmentTypesSettings = () => {
  activeTab.value = "types";
  showSettingsModal.value = true;
  // Only fetch products and users if not already loaded
  if (products.value.length === 0) {
    fetchProducts();
  }
  if (users.value.length === 0) {
    fetchUsers();
  }
  // Don't re-fetch appointment types as they're already loaded and up-to-date
};

const closeSettingsModal = () => {
  showSettingsModal.value = false;
};

const saveSettings = () => {
  // Implement save settings logic
  console.log("Settings saved:", blockedTimes.value, appointmentTypes.value);
  closeSettingsModal();
};

// Count appointments by type
const getAppointmentTypeCount = (typeName: string) => {
  return events.value.filter((event) => (event as any).type === typeName).length;
};

const myCalendarsExpanded = ref(true);

// Mobile responsive state
const mobileView = ref('sidebar'); // 'sidebar' or 'calendar'

const toggleMyCalendars = () => {
  myCalendarsExpanded.value = !myCalendarsExpanded.value;
};

// Mobile view toggle function
const toggleMobileView = () => {
  mobileView.value = mobileView.value === 'sidebar' ? 'calendar' : 'sidebar';
};

// Watch for mobileView changes and update thumb position
watch(mobileView, (newView) => {
  nextTick(() => {
    const targetValue = newView === 'sidebar' ? 0 : 1;
    const sliders = document.querySelectorAll('.slider-input');
    sliders.forEach(slider => {
      // עדכן רק אם הערך שונה כדי למנוע לולאות
      if (Math.abs(parseFloat(slider.value) - targetValue) > 0.1) {
        slider.value = targetValue;
      }
    });
    updateThumbPosition(targetValue);
  });
}, { immediate: true });

const handleSliderChange = (event) => {
  const value = parseFloat(event.target.value);
  const newView = value < 0.5 ? 'sidebar' : 'calendar';
  
  // עדכן את מיקום העיגול והתצוגות מיידית
  updateThumbPosition(value);
  
  // עדכן את התצוגה הנוכחית רק אם השתנתה
  if (newView !== mobileView.value) {
    mobileView.value = newView;
  }
};

const updateThumbPosition = (value) => {
  const thumbs = document.querySelectorAll('.slider-thumb');
  thumbs.forEach(thumb => {
    const track = thumb.parentElement;
    const trackWidth = track.offsetWidth;
    const thumbWidth = 40; // רוחב העיגול
    const maxMove = trackWidth - thumbWidth - 10; // מקום לתנועה (מינוס הpadding)
    const position = (value * maxMove) + 5; // 5px הוא המיקום התחילי
    
    thumb.style.left = `${position}px`;
    
    // האייקון נשאר קבוע - לא צריך לשנות אותו
    
    // עדכן את התוויות
    updateLabels(value);
  });
  
  // עדכן את מיקום התצוגות בזמן אמת
  updateViewPositions(value);
};

const updateViewPositions = (value) => {
  const sidebarCard = document.querySelector('.sidebar-card');
  const calendarCard = document.querySelector('.main-calendar-card');
  
  if (sidebarCard && calendarCard) {
    // חישוב אחוזי התזוזה (0 = סיידבר מלא, 1 = קלנדר מלא)
    const sidebarTranslateX = -100 * value; // סיידבר זז שמאלה
    const calendarTranslateX = 100 * (1 - value); // קלנדר זז מימינה
    
    // החל את הטרנספורמציה
    sidebarCard.style.transform = `translateX(${sidebarTranslateX}%)`;
    calendarCard.style.transform = `translateX(${calendarTranslateX}%)`;
    
    // עדכן שקיפות
    sidebarCard.style.opacity = 1 - value + 0.3; // מינימום 0.3
    calendarCard.style.opacity = value + 0.3; // מינימום 0.3
    
    // הצג/הסתר תצוגות בהתאם לערך
    if (value < 0.1) {
      sidebarCard.style.display = 'flex';
      calendarCard.style.display = 'none';
    } else if (value > 0.9) {
      sidebarCard.style.display = 'none';
      calendarCard.style.display = 'block';
    } else {
      sidebarCard.style.display = 'flex';
      calendarCard.style.display = 'block';
    }
  }
};

const updateLabels = (value) => {
  const labels = document.querySelectorAll('.slider-labels');
  labels.forEach(labelContainer => {
    const leftLabel = labelContainer.querySelector('.label-left');
    const rightLabel = labelContainer.querySelector('.label-right');
    
    if (leftLabel && rightLabel) {
      if (value < 0.5) {
        leftLabel.style.color = '#667eea';
        leftLabel.style.fontWeight = '600';
        rightLabel.style.color = '#64748b';
        rightLabel.style.fontWeight = '500';
      } else {
        leftLabel.style.color = '#64748b';
        leftLabel.style.fontWeight = '500';
        rightLabel.style.color = '#667eea';
        rightLabel.style.fontWeight = '600';
      }
    }
  });
};

// Touch events for thumb
let isDraggingSlider = false;
let startX = 0;

const handleThumbTouchStart = (e) => {
  e.preventDefault();
  e.stopPropagation();
  isDraggingSlider = true;
  startX = e.touches[0].clientX;
  
  // Add dragging class for enhanced animations
  const thumb = e.target.closest('.slider-thumb');
  if (thumb) {
    thumb.classList.add('dragging');
  }
  
  // הוסף event listeners לטאץ' גלובליים
  document.addEventListener('touchmove', handleThumbTouchMove, { passive: false });
  document.addEventListener('touchend', handleThumbTouchEnd, { passive: false });
};

const handleThumbTouchMove = (e) => {
  if (!isDraggingSlider) return;
  e.preventDefault();
  
  const slider = document.querySelector('.slider-input');
  if (!slider) return;
  
  const rect = slider.getBoundingClientRect();
  const x = e.touches[0].clientX - rect.left;
  const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
  const value = percentage / 100;
  
  slider.value = value;
  updateThumbPosition(value);
  
  // עדכן את התצוגה בזמן אמת בהתאם לערך
  const newView = value < 0.5 ? 'sidebar' : 'calendar';
  if (newView !== mobileView.value) {
    mobileView.value = newView;
  }
};

const handleThumbTouchEnd = (e) => {
  if (!isDraggingSlider) return;
  e.preventDefault();
  isDraggingSlider = false;
  
  // Remove dragging class for enhanced animations
  const thumbs = document.querySelectorAll('.slider-thumb');
  thumbs.forEach(thumb => {
    thumb.classList.remove('dragging');
  });
  
  // הסר event listeners
  document.removeEventListener('touchmove', handleThumbTouchMove);
  document.removeEventListener('touchend', handleThumbTouchEnd);
  
  const slider = document.querySelector('.slider-input');
  if (!slider) return;
  
  const value = parseFloat(slider.value);
  if (value < 0.5) {
    mobileView.value = 'sidebar';
  } else {
    mobileView.value = 'calendar';
  }
};

const handleThumbMouseDown = (e) => {
  e.preventDefault();
  e.stopPropagation();
  isDraggingSlider = true;
  startX = e.clientX;
  
  // Add dragging class for enhanced animations
  const thumb = e.target.closest('.slider-thumb');
  if (thumb) {
    thumb.classList.add('dragging');
  }
  
  const slider = e.target.closest('.view-toggle-slider').querySelector('.slider-input');
  if (!slider) return;
  
  const handleMouseMove = (e) => {
    if (!isDraggingSlider) return;
    
    const rect = slider.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
    const value = percentage / 100;
    
    slider.value = value;
    updateThumbPosition(value);
    
    // עדכן את התצוגה בזמן אמת בהתאם לערך
    const newView = value < 0.5 ? 'sidebar' : 'calendar';
    if (newView !== mobileView.value) {
      mobileView.value = newView;
    }
  };
  
  const handleMouseUp = () => {
    if (!isDraggingSlider) return;
    isDraggingSlider = false;
    
    // Remove dragging class for enhanced animations
    const thumbs = document.querySelectorAll('.slider-thumb');
    thumbs.forEach(thumb => {
      thumb.classList.remove('dragging');
    });
    
    const value = parseFloat(slider.value);
    if (value < 0.5) {
      mobileView.value = 'sidebar';
    } else {
      mobileView.value = 'calendar';
    }
    
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  };
  
  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseup', handleMouseUp);
};

// Simple click handler for thumb
const handleThumbClick = (e) => {
  // רק אם לא בתהליך גרירה
  if (!isDraggingSlider) {
    e.preventDefault();
    e.stopPropagation();
    
    // החלף בין התצוגות
    if (mobileView.value === 'sidebar') {
      mobileView.value = 'calendar';
    } else {
      mobileView.value = 'sidebar';
    }
  }
};



// Computed properties for calendar users
const otherUsers = computed(() => {
  return allUsers.value.filter((user) => user.user_id !== currentUserId.value);
});

// Toggle user calendar visibility
const toggleUserCalendar = (userId: string) => {
  const index = selectedUserCalendars.value.indexOf(userId);
  if (index > -1) {
    selectedUserCalendars.value.splice(index, 1);
  } else {
    selectedUserCalendars.value.push(userId);
  }
  // Re-fetch events to show/hide this user's events
  fetchCalendarEvents();
};

// Get event count for a specific user (only future events)
const getUserEventCount = (userId: string) => {
  if (!userId) return 0;
  const now = new Date();

  // If we have loaded all users events for counting, use that (more accurate)
  if (allUsersEventsForCounting.value.length > 0) {
    return allUsersEventsForCounting.value.filter(
      (event) => event.userId === userId && event.start > now
    ).length;
  }

  // Otherwise, fall back to main events array (for current user's events only)
  return events.value.filter((event) => event.userId === userId && event.start > now)
    .length;
};

// Fetch all users from organization for calendar view
const fetchAllUsers = async (orgId: string) => {
  try {
    const { data, error } = await supabase
      .from("user_profiles")
      .select("user_id, display_name, email")
      .eq("org_id", orgId)
      .order("display_name");

    if (error) throw error;

    allUsers.value = data || [];
  } catch (error) {
    console.error("Error fetching users for calendar view:", error);
  }
};

// Fetch all users' events for counting purposes (only when user has permissions)
const fetchAllUsersEvents = async (orgId: string) => {
  try {
    console.log("🔄 Fetching all users events for counting...");

    const { data: eventsData, error: eventsError } = await supabase
      .from("calendar_events")
      .select("id, user_id, title, start_time, end_time")
      .eq("org_id", orgId)
      .gte("start_time", new Date().toISOString()) // Only future events
      .order("start_time", { ascending: true });

    if (eventsError) {
      console.error("❌ Error fetching all users events:", eventsError);
      return;
    }

    // Store all events for counting but don't replace the main events array
    allUsersEventsForCounting.value = eventsData.map((event) => ({
      id: event.id,
      userId: event.user_id,
      title: event.title,
      start: new Date(event.start_time),
      end: new Date(event.end_time),
    }));

    console.log(
      "✅ Loaded all users events for counting:",
      allUsersEventsForCounting.value.length
    );
  } catch (error) {
    console.error("❌ Error in fetchAllUsersEvents:", error);
  }
};

// Get user display name by ID
const getUserDisplayName = (userId: string) => {
  if (userId === currentUserId.value) {
    return userDisplayName.value;
  }

  const user = allUsers.value.find((u) => u.user_id === userId);
  return user ? user.display_name || user.email : "Unknown User";
};

// Get user initials by ID
const getUserInitials = (userId: string) => {
  const displayName = getUserDisplayName(userId);
  const names = displayName.split(" ");

  if (names.length >= 2) {
    return (names[0][0] + names[1][0]).toUpperCase();
  } else if (names.length === 1) {
    return names[0].substring(0, 2).toUpperCase();
  }

  return "U";
};

// Get user calendar color by index
const getUserCalendarColor = (index: number) => {
  const colors = [
    '#10b981', // green-500
    '#f59e0b', // amber-500  
    '#ef4444', // red-500
    '#8b5cf6', // violet-500
    '#06b6d4', // cyan-500
    '#f97316', // orange-500
    '#84cc16', // lime-500
    '#ec4899', // pink-500
    '#6366f1', // indigo-500
    '#14b8a6'  // teal-500
  ];
  return colors[index % colors.length];
};

// Refresh data when needed
const refreshAppointmentData = () => {
  fetchAppointmentTypes();
};

// Load user profile data
const loadUserProfile = async () => {
  try {
    // Get current session
    const {
      data: { session },
    } = await supabase.auth.getSession();

    if (session && session.user) {
      currentUserId.value = session.user.id;
      selectedUserCalendars.value = [session.user.id]; // Initially show current user's calendar

      // Get user email from auth
      const email = session.user.email || "";

      // Get user profile data from user_profiles table
      const { data, error } = await supabase
        .from("user_profiles")
        .select(
          "user_id, display_name, role, email, profile_picture_link, org_id, permissions_json"
        )
        .eq("user_id", session.user.id)
        .single();

      if (error) {
        console.error("Error fetching user profile:", error);
        // Fallback to email
        userDisplayName.value = email.split("@")[0] || "User";
        userRole.value = "User";
        return;
      }

      if (data) {
        // Use display_name for userName
        userDisplayName.value = data.display_name || email.split("@")[0] || "User";
        userRole.value = data.role || "User";

        // Set profile picture if available
        if (data.profile_picture_link && data.profile_picture_link.trim() !== "") {
          userProfilePicture.value = data.profile_picture_link;
        } else {
          // Keep using the default image when no profile picture is set
          userProfilePicture.value = defaultProfileImage;
        }

        // Load user permissions
        const permissions = data.permissions_json || {};
        userPermissions.value = {
          view_all_calendars: permissions.view_all_calendars === true,
          is_owner: permissions.is_owner === true,
          edit_all_leads: permissions.edit_all_leads === true,
          view_all_leads: permissions.view_all_leads === true,
          can_invite_users: permissions.can_invite_users === true,
        };

        // If user has permission to view all calendars, fetch all users and their events
        if (userPermissions.value.view_all_calendars && data.org_id) {
          await fetchAllUsers(data.org_id);
          // Temporarily load all users' events for accurate counts
          await fetchAllUsersEvents(data.org_id);
        }
      } else {
        // Fallback to email
        userDisplayName.value = email.split("@")[0] || "User";
        userRole.value = "User";
      }
    }
  } catch (error) {
    console.error("Error fetching user data:", error);
    userDisplayName.value = "User";
    userRole.value = "User";
  }
};

// Close dropdown when clicking outside
const handleClickOutside = (event: Event) => {
  const target = event.target as HTMLElement;
  if (!target.closest(".product-search-container")) {
    showProductDropdown.value = false;
  }
};

// Fetch calendar events from database
const fetchCalendarEvents = async () => {
  try {
    console.log("🔄 Starting to fetch calendar events...");
    const { userId, organizationId } = await getCurrentUserOrgId();
    console.log("👤 User ID:", userId);
    console.log("🏢 Organization ID:", organizationId);

    // Build query for calendar events based on user permissions and selected users
    let query = supabase
      .from("calendar_events")
      .select(
        `
        *,
        calendar_events_participants (
          id,
          lead_id,
          customer_id,
          name,
          phone,
          email,
          leads (
            id,
            name,
            email,
            phone
          ),
          clients (
            id,
            first_name,
            last_name,
            email,
            phone
          )
        ),
        customer_appointment_types (
          name,
          duration,
          color_code
        )
      `
      )
      .eq("org_id", organizationId)
      .gte("start_time", new Date(new Date().getFullYear() - 1, 0, 1).toISOString()) // מתחילת השנה הקודמת
      .lte("start_time", new Date(new Date().getFullYear() + 1, 11, 31).toISOString()) // עד סוף השנה הבאה
      .order("start_time", { ascending: true });

    // Filter events based on selected user calendars
    if (selectedUserCalendars.value.length > 0) {
      query = query.in("user_id", selectedUserCalendars.value);
    }

    // טעינת אירועים מהמסד נתונים
    const { data: eventsData, error: eventsError } = await query;

    if (eventsError) {
      console.error("❌ Error fetching events:", eventsError);
      return;
    }

    console.log("📊 Raw events data from database:", eventsData);
    console.log("📊 Number of events found:", eventsData?.length || 0);

    // המרת האירועים לפורמט המתאים להצגה
    events.value = eventsData.map((event) => {
      console.log("🔍 Processing event:", event.id, event.title);
      console.log("⏰ Event times:", event.start_time, "->", event.end_time);
      const startDate = createLocalDateFromDB(event.start_time);
      const endDate = createLocalDateFromDB(event.end_time);

      // קביעת צבע האירוע
      let colorClass = "event-blue";
      if (event.customer_appointment_types) {
        const colorMap: { [key: string]: string } = {
          "#fbbf24": "event-yellow",
          "#3b82f6": "event-blue",
          "#ec4899": "event-pink",
          "#22c55e": "event-green",
          "#8b5cf6": "event-purple",
          "#6b7280": "event-gray",
        };
        colorClass =
          colorMap[event.customer_appointment_types.color_code] || "event-blue";
      }

      // עיבוד משתתפים - עדיפות לנתונים מטבלאות הלידים/לקוחות
      const participants =
        event.calendar_events_participants?.map((p: any, index: number) => {
          let name, email, phone;
          
          if (p.leads) {
            // אם זה ליד - קח נתונים מטבלת הלידים
            name = p.leads.name;
            email = p.leads.email;
            phone = p.leads.phone;
          } else if (p.clients) {
            // אם זה לקוח - קח נתונים מטבלת הלקוחות
            name = `${p.clients.first_name || ""} ${p.clients.last_name || ""}`.trim();
            email = p.clients.email;
            phone = p.clients.phone;
          } else {
            // אם זה משתתף ידני - קח נתונים מטבלת המשתתפים
            name = p.name;
            email = p.email;
            phone = p.phone;
          }

          return {
            id: p.id,
            name: name || "ללא שם",
            email: email || "",
            phone: phone || "",
            avatar: "/api/placeholder/24/24",
            leadId: p.lead_id,
            clientId: p.customer_id,
          };
        }) || [];

      return {
        id: event.id,
        title: event.title,
        type: event.customer_appointment_types?.name || "אירוע",
        start: startDate,
        end: endDate,
        colorClass,
        timeDisplay: `${formatTimeInLocalTimezone(startDate)} - ${formatTimeInLocalTimezone(endDate)}`,
        location: event.location,
        description: event.description,
        dateDisplay: startDate.toLocaleDateString("he-IL", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        }),
        participants,
        userId: event.user_id, // Add user_id to track event owner
        is_over: event.is_over || false, // הוספת השדה is_over
      };
    });

    console.log("✅ Loaded events from database:", events.value.length);
    console.log("📅 Processed events:", events.value);

    // בדיקה נוספת עם הגנה
    events.value.forEach((event, index) => {
      if (!event || !event.start) {
        console.warn(`⚠️ Invalid event ${index + 1}:`, event);
        return;
      }
      
      console.log(`📌 Event ${index + 1}:`, {
        id: event.id,
        title: event.title,
        start: event.start,
        end: event.end,
        date: isNaN(event.start.getTime()) ? 'Invalid Date' : event.start.toLocaleDateString(),
        time: event.timeDisplay,
      });
    });
  } catch (error) {
    console.error("❌ Error in fetchCalendarEvents:", error);
  }
};

// Helper function to create ISO string without timezone conversion
const createLocalISOString = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

// Store original swipe handlers to restore them later
let originalTouchHandlers = null;

// Disable sidebar swipe gestures
const disableSidebarSwipe = () => {
  // Store original handlers and remove them
  originalTouchHandlers = [];
  
  // Override global touch event listeners that handle sidebar swipe
  const touchEvents = ['touchstart', 'touchmove', 'touchend'];
  touchEvents.forEach(eventType => {
    // Create a handler that prevents sidebar swipe but allows calendar interactions
    const preventSidebarHandler = (e) => {
      // Only prevent if it's a potential sidebar swipe gesture
      if (e.touches && e.touches.length === 1) {
        const touch = e.touches[0];
        const edgeThreshold = 30; // Same as LeftSidebar
        const isFromLeftEdge = touch.clientX < edgeThreshold;
        const isFromRightEdge = touch.clientX > window.innerWidth - edgeThreshold;
        
        // Prevent sidebar swipe from screen edges
        if (isFromLeftEdge || isFromRightEdge) {
          e.stopImmediatePropagation();
          e.preventDefault();
        }
      }
    };
    
    // Add our override handler with highest priority
    document.addEventListener(eventType, preventSidebarHandler, { 
      capture: true, 
      passive: false 
    });
    
    // Store for cleanup
    originalTouchHandlers.push({ eventType, handler: preventSidebarHandler });
  });
  
  // Also prevent sidebar from opening programmatically
  const originalStateStore = window.stateStore || {};
  if (originalStateStore.onChange) {
    originalStateStore._originalOnChange = originalStateStore.onChange;
    originalStateStore.onChange = () => {
      console.log("🚫 Sidebar state change blocked on calendar page");
      // Do nothing - prevent sidebar from opening
    };
  }
  
  console.log("🚫 Sidebar swipe gestures disabled for calendar page");
};

// Restore sidebar swipe gestures
const enableSidebarSwipe = () => {
  if (originalTouchHandlers) {
    originalTouchHandlers.forEach(({ eventType, handler }) => {
      document.removeEventListener(eventType, handler, { capture: true });
    });
    originalTouchHandlers = null;
  }
  
  // Restore original state store functionality
  const originalStateStore = window.stateStore || {};
  if (originalStateStore._originalOnChange) {
    originalStateStore.onChange = originalStateStore._originalOnChange;
    delete originalStateStore._originalOnChange;
  }
  
  console.log("✅ Sidebar swipe gestures restored");
};

// Load all data needed for the calendar
const loadAllData = async () => {
  try {
    isLoading.value = true;
    console.log("🚀 Loading calendar data...");

    // Load all data in parallel for better performance
    await Promise.all([
      loadUserProfile(),
      fetchAppointmentTypes(),
      fetchBreaks(),
      fetchEmployeeAvailability(),
      fetchProducts(),
      fetchUsers(),
      fetchCalendarEvents()
    ]);

    console.log("✅ All calendar data loaded successfully");
  } catch (error) {
    console.error("❌ Error loading calendar data:", error);
  } finally {
    isLoading.value = false;
  }
};

// Load data on component mount
onMounted(async () => {
  console.log("🚀 Calendar component mounted");
  console.log("📅 Current date:", new Date().toISOString());
  
  // בדיקה שהcurrentDate תקין לפני השימוש
  if (isNaN(currentDate.value.getTime())) {
    console.warn("⚠️ Invalid currentDate, resetting to now");
    currentDate.value = new Date();
  }
  console.log("📅 Calendar current date:", currentDate.value.toISOString());

  // Disable sidebar swipe gestures for this page
  disableSidebarSwipe();

  // Load all data
  await loadAllData();

  // Add event listener for clicking outside dropdown
  document.addEventListener("click", handleClickOutside);

  // Setup theme observer for real-time dark mode updates
  themeObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        updateDarkMode();
      }
    });
  });

  // Start observing changes to body class
  themeObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

  // אתחול מיקום התצוגות במובייל
  nextTick(() => {
    if (window.innerWidth <= 768) {
      const initialValue = mobileView.value === 'sidebar' ? 0 : 1;
      updateThumbPosition(initialValue);
    }
  });
});

// Cleanup event listener
onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
  
  // Restore sidebar swipe gestures when leaving the page
  enableSidebarSwipe();
  
  // Cleanup theme observer
  if (themeObserver) {
    themeObserver.disconnect();
    themeObserver = null;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[46] || (_cache[46] = _createStaticVNode("<div class=\"relative w-32 h-32 mb-8 flex items-center justify-center\" data-v-2954a1ac><div class=\"absolute inset-0 border-[6px] border-gray-200 dark:border-gray-700 rounded-full\" data-v-2954a1ac></div><div class=\"absolute inset-0 border-t-[6px] border-primary-500 rounded-full animate-spin\" data-v-2954a1ac></div><div class=\"w-20 h-20 bg-primary-100 dark:bg-primary-900 rounded-xl flex items-center justify-center z-10 shadow-md\" data-v-2954a1ac><i class=\"ri-calendar-line text-3xl text-primary-500 dark:text-primary-400\" data-v-2954a1ac></i></div></div>", 1)),
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("calendar.loadingTitle") || "Loading Calendar"), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("calendar.loadingDescription") || "Please wait while we load your data from the database..."), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[43] || (_cache[43] = _createElementVNode("div", { class: "w-2 h-2 bg-primary-500 rounded-full animate-pulse" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("calendar.loadingProfile") || "Loading user profile"), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[44] || (_cache[44] = _createElementVNode("div", { class: "w-2 h-2 bg-primary-500 rounded-full animate-pulse animation-delay-200" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("calendar.loadingEvents") || "Loading events"), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[45] || (_cache[45] = _createElementVNode("div", { class: "w-2 h-2 bg-primary-500 rounded-full animate-pulse animation-delay-400" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("calendar.loadingSettings") || "Loading settings"), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("input", {
                type: "range",
                min: "0",
                max: "1",
                step: "0.01",
                value: mobileView.value === 'sidebar' ? 0 : 1,
                onInput: handleSliderChange,
                onChange: handleSliderChange,
                class: "slider-input"
              }, null, 40, _hoisted_13),
              _createElementVNode("div", {
                class: _normalizeClass(["slider-thumb", { 'moved': mobileView.value === 'calendar' }]),
                onTouchstart: handleThumbTouchStart,
                onTouchmove: handleThumbTouchMove,
                onTouchend: handleThumbTouchEnd,
                onMousedown: handleThumbMouseDown,
                onClick: handleThumbClick
              }, _cache[47] || (_cache[47] = [
                _createElementVNode("i", { class: "ri-drag-move-2-line" }, null, -1)
              ]), 34)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('calendar.menu')), 1),
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('calendar.calendar')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("main", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", {
              class: _normalizeClass(["bg-white dark:bg-[#15203c] rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 overflow-hidden sidebar-responsive", { 'mobile-active': mobileView.value === 'sidebar', 'sidebar-hidden': mobileView.value !== 'sidebar' }])
            }, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("img", {
                        class: "h-10 w-10 rounded-full object-cover",
                        src: userProfilePicture.value,
                        alt: userDisplayName.value,
                        onError: handleImageError
                      }, null, 40, _hoisted_23)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("h3", _hoisted_24, _toDisplayString(userDisplayName.value), 1)
                    ])
                  ]),
                  _createElementVNode("button", {
                    onClick: openSettingsModal,
                    class: "text-gray-400 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-300"
                  }, _cache[48] || (_cache[48] = [
                    _createElementVNode("i", { class: "fa-solid fa-gear" }, null, -1)
                  ]))
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("h4", _hoisted_27, _toDisplayString(getMiniCalendarTitle.value), 1),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateMiniCalendar('prev'))),
                      class: "text-gray-400 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-300"
                    }, _cache[49] || (_cache[49] = [
                      _createElementVNode("i", { class: "fa-solid fa-chevron-left" }, null, -1)
                    ])),
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (navigateMiniCalendar('next'))),
                      class: "text-gray-400 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-300"
                    }, _cache[50] || (_cache[50] = [
                      _createElementVNode("i", { class: "fa-solid fa-chevron-right" }, null, -1)
                    ]))
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(miniCalendarDays.value, (day) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: day,
                      class: "text-center text-gray-500 dark:text-gray-400 p-1"
                    }, _toDisplayString(day), 1))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getMiniCalendarDays.value, (day) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: day.date,
                      class: _normalizeClass(["text-center p-1 cursor-pointer rounded", {
                  'text-gray-400 dark:text-gray-500': day.isOtherMonth,
                  'bg-primary-600 text-white': day.isToday,
                  'hover:bg-gray-100 dark:hover:bg-gray-700': !day.isToday && !day.isOtherMonth,
                  'bg-primary-100 text-primary-600 dark:bg-primary-900 dark:text-primary-400': day.isSelected && !day.isToday
                }]),
                      onClick: ($event: any) => (selectMiniDay(day))
                    }, _toDisplayString(day.dayNumber), 11, _hoisted_30))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("h4", _hoisted_33, _toDisplayString(_ctx.$t("calendar.myCalendars")), 1),
                  _createElementVNode("button", {
                    onClick: toggleMyCalendars,
                    class: "text-gray-400 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-300"
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["ri-arrow-down-s-line", { 'rotate-180': myCalendarsExpanded.value }])
                    }, null, 2)
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", {
                    class: "flex items-center justify-between cursor-pointer p-2 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleUserCalendar(currentUserId.value || '')))
                  }, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: selectedUserCalendars.value.includes(currentUserId.value || ''),
                        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (toggleUserCalendar(currentUserId.value || ''))),
                        class: "w-4 h-4 text-primary-600 bg-gray-100 border-gray-300 rounded focus:ring-primary-500 dark:focus:ring-primary-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      }, null, 40, _hoisted_36),
                      _cache[51] || (_cache[51] = _createElementVNode("div", { class: "w-3 h-3 bg-primary-500 rounded" }, null, -1)),
                      _createElementVNode("span", _hoisted_37, _toDisplayString(userDisplayName.value) + " (" + _toDisplayString(_ctx.$t("calendar.me")) + ")", 1)
                    ]),
                    _createElementVNode("span", _hoisted_38, _toDisplayString(getUserEventCount(currentUserId.value || "")), 1)
                  ]),
                  (userPermissions.value.view_all_calendars)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(otherUsers.value, (user, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: user.user_id,
                          class: "flex items-center justify-between cursor-pointer p-2 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700",
                          onClick: ($event: any) => (toggleUserCalendar(user.user_id))
                        }, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: selectedUserCalendars.value.includes(user.user_id),
                              onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                              onChange: ($event: any) => (toggleUserCalendar(user.user_id)),
                              class: "w-4 h-4 text-primary-600 bg-gray-100 border-gray-300 rounded focus:ring-primary-500 dark:focus:ring-primary-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                            }, null, 40, _hoisted_41),
                            _createElementVNode("div", {
                              class: "w-3 h-3 rounded",
                              style: _normalizeStyle({ backgroundColor: getUserCalendarColor(index) })
                            }, null, 4),
                            _createElementVNode("span", _hoisted_42, _toDisplayString(user.display_name || user.email), 1)
                          ]),
                          _createElementVNode("span", _hoisted_43, _toDisplayString(getUserEventCount(user.user_id)), 1)
                        ], 8, _hoisted_39))
                      }), 128))
                    : _createCommentVNode("", true)
                ], 512), [
                  [_vShow, myCalendarsExpanded.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("h4", _hoisted_46, _toDisplayString(_ctx.$t("calendar.appointmentTypes")), 1),
                  _createElementVNode("button", {
                    onClick: openAppointmentTypesSettings,
                    class: "text-gray-400 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-300"
                  }, _cache[52] || (_cache[52] = [
                    _createElementVNode("i", { class: "fa-solid fa-gear" }, null, -1)
                  ]))
                ]),
                _createElementVNode("div", _hoisted_47, [
                  (loadingAppointmentTypes.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _cache[53] || (_cache[53] = _createElementVNode("i", { class: "ri-loader-5-line animate-spin" }, null, -1)),
                        _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t("calendar.loadingAppointmentTypes") || "טוען סוגי פגישות..."), 1)
                      ]))
                    : (appointmentTypes.value.length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(appointmentTypes.value.slice(0, 4), (type) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: type.id || type.name,
                            class: "flex items-center justify-between"
                          }, [
                            _createElementVNode("span", _hoisted_50, _toDisplayString(type.name), 1),
                            _createElementVNode("span", _hoisted_51, _toDisplayString(getAppointmentTypeCount(type.name)), 1)
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                          _cache[54] || (_cache[54] = _createElementVNode("i", { class: "ri-calendar-line text-gray-400 text-2xl mb-2" }, null, -1)),
                          _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.$t("calendar.noAppointmentTypes") || "אין סוגי פגישות זמינים"), 1)
                        ]))
                ])
              ]),
              (showSettingsModal.value && mobileView.value === 'sidebar')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "modal",
                    onClick: closeSettingsModal
                  }, [
                    _createElementVNode("div", {
                      class: "mobile-modal-content",
                      onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          _cache[55] || (_cache[55] = _createElementVNode("div", { class: "header-icon" }, [
                            _createElementVNode("i", { class: "ri-settings-3-line" })
                          ], -1)),
                          _createElementVNode("h3", null, _toDisplayString(_unref(t)("calendar.settings.title")), 1)
                        ]),
                        _createElementVNode("button", {
                          onClick: closeSettingsModal,
                          class: "close-btn"
                        }, _cache[56] || (_cache[56] = [
                          _createElementVNode("i", { class: "ri-close-line" }, null, -1)
                        ]))
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(settingsTabs.value, (tab) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: tab.id,
                            onClick: ($event: any) => (activeTab.value = tab.id),
                            class: _normalizeClass([{ active: activeTab.value === tab.id }, "mobile-nav-tab"])
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(tab.icon)
                            }, null, 2),
                            _createElementVNode("span", null, _toDisplayString(_unref(t)(tab.nameKey)), 1)
                          ], 10, _hoisted_57))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        (activeTab.value === 'hours')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                              _createElementVNode("div", _hoisted_60, [
                                _createElementVNode("div", _hoisted_61, [
                                  _createElementVNode("h4", null, _toDisplayString(_unref(t)("calendar.settings.businessHours")), 1),
                                  _createElementVNode("p", null, _toDisplayString(_unref(t)("calendar.settings.businessHoursDescription")), 1)
                                ]),
                                (loadingAvailability.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                      _cache[57] || (_cache[57] = _createElementVNode("i", { class: "ri-loader-5-line animate-spin" }, null, -1)),
                                      _createElementVNode("span", null, _toDisplayString(_unref(t)("calendar.settings.loadingWorkingHours")), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                      _createElementVNode("div", _hoisted_64, [
                                        _createElementVNode("div", _hoisted_65, [
                                          _createElementVNode("label", null, _toDisplayString(_unref(t)("calendar.settings.enableWorkingHours")), 1),
                                          _createElementVNode("span", _hoisted_66, _toDisplayString(_unref(t)("calendar.settings.enableWorkingHoursDescription")), 1)
                                        ]),
                                        _createElementVNode("label", _hoisted_67, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((workingHoursEnabled).value = $event))
                                          }, null, 512), [
                                            [_vModelCheckbox, workingHoursEnabled.value]
                                          ]),
                                          _cache[58] || (_cache[58] = _createElementVNode("span", { class: "mobile-switch-slider" }, null, -1))
                                        ])
                                      ]),
                                      (workingHoursEnabled.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workingDays.value, (day) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: day.key,
                                                class: _normalizeClass(["mobile-day-row", { disabled: !day.enabled }])
                                              }, [
                                                _createElementVNode("div", _hoisted_69, [
                                                  _createElementVNode("label", _hoisted_70, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "checkbox",
                                                      "onUpdate:modelValue": ($event: any) => ((day.enabled) = $event)
                                                    }, null, 8, _hoisted_71), [
                                                      [_vModelCheckbox, day.enabled]
                                                    ]),
                                                    _cache[59] || (_cache[59] = _createElementVNode("span", { class: "mobile-checkmark" }, null, -1))
                                                  ]),
                                                  _createElementVNode("div", _hoisted_72, _toDisplayString(_unref(t)(`calendar.dayAbbreviations.${day.name.toLowerCase()}`)), 1)
                                                ]),
                                                (day.enabled)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": ($event: any) => ((day.startTime) = $event),
                                                        type: "time",
                                                        class: "mobile-time-input"
                                                      }, null, 8, _hoisted_74), [
                                                        [_vModelText, day.startTime]
                                                      ]),
                                                      _cache[60] || (_cache[60] = _createElementVNode("span", { class: "mobile-time-separator" }, "–", -1)),
                                                      _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": ($event: any) => ((day.endTime) = $event),
                                                        type: "time",
                                                        class: "mobile-time-input"
                                                      }, null, 8, _hoisted_75), [
                                                        [_vModelText, day.endTime]
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ], 2))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_76, [
                                        _createElementVNode("button", {
                                          onClick: saveEmployeeAvailability,
                                          class: "mobile-btn-primary",
                                          disabled: savingAvailability.value
                                        }, [
                                          (savingAvailability.value)
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_78))
                                            : (_openBlock(), _createElementBlock("i", _hoisted_79)),
                                          _createTextVNode(" " + _toDisplayString(_unref(t)("calendar.settings.saveWorkingHours")), 1)
                                        ], 8, _hoisted_77)
                                      ])
                                    ]))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (activeTab.value === 'breaks')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                              _createElementVNode("div", _hoisted_81, [
                                _createElementVNode("div", _hoisted_82, [
                                  _createElementVNode("h4", null, _toDisplayString(_unref(t)("calendar.settings.breakTimes")), 1),
                                  _createElementVNode("p", null, _toDisplayString(_unref(t)("calendar.settings.breakTimesDescription")), 1),
                                  _createElementVNode("button", {
                                    onClick: addBlockedTime,
                                    onTouchend: _withModifiers(addBlockedTime, ["prevent"]),
                                    class: "mobile-add-btn",
                                    style: {"touch-action":"manipulation","-webkit-touch-callout":"none","-webkit-user-select":"none","-khtml-user-select":"none","-moz-user-select":"none","-ms-user-select":"none","user-select":"none"}
                                  }, [
                                    _cache[61] || (_cache[61] = _createElementVNode("i", { class: "ri-add-line" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)("calendar.settings.addBreak")), 1)
                                  ], 32)
                                ]),
                                (loadingBreaks.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                      _cache[62] || (_cache[62] = _createElementVNode("i", { class: "ri-loader-5-line animate-spin" }, null, -1)),
                                      _createElementVNode("span", null, _toDisplayString(_unref(t)("calendar.settings.loadingBreaks")), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blockedTimes.value, (block, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: block.id || index,
                                          class: "mobile-break-item"
                                        }, [
                                          _createElementVNode("div", _hoisted_85, [
                                            (block.isEditing)
                                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                  key: 0,
                                                  "onUpdate:modelValue": ($event: any) => ((block.name) = $event),
                                                  type: "text",
                                                  class: "mobile-break-name editing",
                                                  placeholder: _unref(t)('calendar.settings.breakNamePlaceholder')
                                                }, null, 8, _hoisted_86)), [
                                                  [_vModelText, block.name]
                                                ])
                                              : (_openBlock(), _createElementBlock("span", _hoisted_87, _toDisplayString(block.name), 1)),
                                            _createElementVNode("div", _hoisted_88, [
                                              (!block.isEditing)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    onClick: ($event: any) => (editBreak(index)),
                                                    onTouchend: _withModifiers(($event: any) => (editBreak(index)), ["prevent"]),
                                                    class: "mobile-edit-btn",
                                                    title: _unref(t)('common.edit'),
                                                    style: {"touch-action":"manipulation","-webkit-touch-callout":"none","-webkit-user-select":"none","-khtml-user-select":"none","-moz-user-select":"none","-ms-user-select":"none","user-select":"none"}
                                                  }, _cache[63] || (_cache[63] = [
                                                    _createElementVNode("i", { class: "ri-edit-line" }, null, -1)
                                                  ]), 40, _hoisted_89))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("button", {
                                                onClick: ($event: any) => (removeBlockedTime(index)),
                                                onTouchend: _withModifiers(($event: any) => (removeBlockedTime(index)), ["prevent"]),
                                                class: "mobile-remove-btn",
                                                title: _unref(t)('common.delete'),
                                                disabled: savingBreak.value,
                                                style: {"touch-action":"manipulation","-webkit-touch-callout":"none","-webkit-user-select":"none","-khtml-user-select":"none","-moz-user-select":"none","-ms-user-select":"none","user-select":"none"}
                                              }, _cache[64] || (_cache[64] = [
                                                _createElementVNode("i", { class: "ri-delete-bin-line" }, null, -1)
                                              ]), 40, _hoisted_90)
                                            ])
                                          ]),
                                          (block.isEditing)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                                _createElementVNode("div", _hoisted_92, [
                                                  _createElementVNode("label", null, _toDisplayString(_unref(t)("calendar.settings.startTime")) + ":", 1),
                                                  _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": ($event: any) => ((block.startTime) = $event),
                                                    type: "time",
                                                    class: "mobile-time-input"
                                                  }, null, 8, _hoisted_93), [
                                                    [_vModelText, block.startTime]
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_94, [
                                                  _createElementVNode("label", null, _toDisplayString(_unref(t)("calendar.settings.endTime")) + ":", 1),
                                                  _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": ($event: any) => ((block.endTime) = $event),
                                                    type: "time",
                                                    class: "mobile-time-input"
                                                  }, null, 8, _hoisted_95), [
                                                    [_vModelText, block.endTime]
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_96, [
                                                  _createElementVNode("label", _hoisted_97, _toDisplayString(_unref(t)("calendar.settings.activeDays")) + ":", 1),
                                                  _createElementVNode("div", _hoisted_98, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(daysOfWeek.value, (day) => {
                                                      return (_openBlock(), _createElementBlock("label", {
                                                        key: day.value,
                                                        class: _normalizeClass(["mobile-day-pill", { active: block.days && block.days.includes(day.value) }])
                                                      }, [
                                                        _withDirectives(_createElementVNode("input", {
                                                          type: "checkbox",
                                                          "onUpdate:modelValue": ($event: any) => ((block.days) = $event),
                                                          value: day.value,
                                                          style: {"display":"none"}
                                                        }, null, 8, _hoisted_99), [
                                                          [_vModelCheckbox, block.days]
                                                        ]),
                                                        _createElementVNode("span", null, _toDisplayString(day.label), 1)
                                                      ], 2))
                                                    }), 128))
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_100, [
                                                  _createElementVNode("button", {
                                                    onClick: ($event: any) => (saveBreak(block, index)),
                                                    onTouchend: _withModifiers(($event: any) => (saveBreak(block, index)), ["prevent"]),
                                                    class: "mobile-save-btn",
                                                    disabled: savingBreak.value,
                                                    style: {"touch-action":"manipulation"}
                                                  }, [
                                                    (savingBreak.value)
                                                      ? (_openBlock(), _createElementBlock("i", _hoisted_102))
                                                      : (_openBlock(), _createElementBlock("i", _hoisted_103)),
                                                    _createTextVNode(" " + _toDisplayString(_unref(t)("common.save")), 1)
                                                  ], 40, _hoisted_101),
                                                  _createElementVNode("button", {
                                                    onClick: ($event: any) => (cancelEditBreak(index)),
                                                    onTouchend: _withModifiers(($event: any) => (cancelEditBreak(index)), ["prevent"]),
                                                    class: "mobile-cancel-btn",
                                                    style: {"touch-action":"manipulation"}
                                                  }, [
                                                    _cache[65] || (_cache[65] = _createElementVNode("i", { class: "ri-close-line" }, null, -1)),
                                                    _createTextVNode(" " + _toDisplayString(_unref(t)("common.cancel")), 1)
                                                  ], 40, _hoisted_104)
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ]))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (activeTab.value === 'types')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                              _createElementVNode("div", _hoisted_106, [
                                _createElementVNode("div", _hoisted_107, [
                                  _createElementVNode("h4", null, _toDisplayString(_unref(t)("calendar.settings.appointmentTypes")), 1),
                                  _createElementVNode("p", null, _toDisplayString(_unref(t)("calendar.settings.appointmentTypesDescription")), 1),
                                  _createElementVNode("button", {
                                    onClick: addAppointmentType,
                                    onTouchend: _withModifiers(addAppointmentType, ["prevent"]),
                                    class: "mobile-add-btn",
                                    style: {"touch-action":"manipulation","-webkit-touch-callout":"none","-webkit-user-select":"none","-khtml-user-select":"none","-moz-user-select":"none","-ms-user-select":"none","user-select":"none"}
                                  }, [
                                    _cache[66] || (_cache[66] = _createElementVNode("i", { class: "ri-add-line" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)("calendar.settings.addType")), 1)
                                  ], 32)
                                ]),
                                (loadingAppointmentTypes.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                      _cache[67] || (_cache[67] = _createElementVNode("i", { class: "ri-loader-5-line animate-spin" }, null, -1)),
                                      _createElementVNode("span", null, _toDisplayString(_unref(t)("calendar.settings.loadingTypes")), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appointmentTypes.value, (type, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: type.id || index,
                                          class: "mobile-type-item"
                                        }, [
                                          _createElementVNode("div", _hoisted_110, [
                                            _createElementVNode("div", _hoisted_111, [
                                              _createElementVNode("div", {
                                                class: "mobile-type-color",
                                                style: _normalizeStyle({ backgroundColor: type.colorCode || getColorValue(type.color) })
                                              }, null, 4),
                                              (!type.isEditing)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_112, _toDisplayString(type.name), 1))
                                                : _withDirectives((_openBlock(), _createElementBlock("input", {
                                                    key: 1,
                                                    "onUpdate:modelValue": ($event: any) => ((type.name) = $event),
                                                    type: "text",
                                                    class: "mobile-type-name-input",
                                                    placeholder: _unref(t)('calendar.settings.appointmentTypeNamePlaceholder')
                                                  }, null, 8, _hoisted_113)), [
                                                    [_vModelText, type.name]
                                                  ]),
                                              (!type.isEditing)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_114, _toDisplayString(type.duration) + _toDisplayString(_unref(t)("calendar.minutes")), 1))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_115, [
                                              (!type.isEditing)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    onClick: ($event: any) => (editAppointmentType(index)),
                                                    onTouchend: _withModifiers(($event: any) => (editAppointmentType(index)), ["prevent"]),
                                                    class: "mobile-edit-btn",
                                                    title: _unref(t)('common.edit'),
                                                    style: {"touch-action":"manipulation","-webkit-touch-callout":"none","-webkit-user-select":"none","-khtml-user-select":"none","-moz-user-select":"none","-ms-user-select":"none","user-select":"none"}
                                                  }, _cache[68] || (_cache[68] = [
                                                    _createElementVNode("i", { class: "ri-edit-line" }, null, -1)
                                                  ]), 40, _hoisted_116))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("button", {
                                                onClick: ($event: any) => (removeAppointmentType(index)),
                                                onTouchend: _withModifiers(($event: any) => (removeAppointmentType(index)), ["prevent"]),
                                                class: "mobile-remove-btn",
                                                title: _unref(t)('common.delete'),
                                                style: {"touch-action":"manipulation","-webkit-touch-callout":"none","-webkit-user-select":"none","-khtml-user-select":"none","-moz-user-select":"none","-ms-user-select":"none","user-select":"none"}
                                              }, _cache[69] || (_cache[69] = [
                                                _createElementVNode("i", { class: "ri-delete-bin-line" }, null, -1)
                                              ]), 40, _hoisted_117)
                                            ])
                                          ]),
                                          (type.isEditing)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                                _createElementVNode("div", _hoisted_119, [
                                                  _createElementVNode("label", _hoisted_120, _toDisplayString(_unref(t)("calendar.settings.duration")) + " (" + _toDisplayString(_unref(t)("calendar.settings.minutes")) + ")", 1),
                                                  _createElementVNode("div", _hoisted_121, [
                                                    _createElementVNode("button", {
                                                      onClick: ($event: any) => (adjustDuration(type, -15)),
                                                      onTouchend: _withModifiers(($event: any) => (adjustDuration(type, -15)), ["prevent"]),
                                                      class: "mobile-duration-btn",
                                                      style: {"touch-action":"manipulation"}
                                                    }, " - ", 40, _hoisted_122),
                                                    _withDirectives(_createElementVNode("input", {
                                                      "onUpdate:modelValue": ($event: any) => ((type.duration) = $event),
                                                      type: "number",
                                                      min: "15",
                                                      max: "480",
                                                      step: "15",
                                                      onBlur: ($event: any) => (validateDuration(type)),
                                                      class: "mobile-duration-input"
                                                    }, null, 40, _hoisted_123), [
                                                      [
                                                        _vModelText,
                                                        type.duration,
                                                        void 0,
                                                        { number: true }
                                                      ]
                                                    ]),
                                                    _createElementVNode("button", {
                                                      onClick: ($event: any) => (adjustDuration(type, 15)),
                                                      onTouchend: _withModifiers(($event: any) => (adjustDuration(type, 15)), ["prevent"]),
                                                      class: "mobile-duration-btn",
                                                      style: {"touch-action":"manipulation"}
                                                    }, " + ", 40, _hoisted_124)
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_125, [
                                                  _createElementVNode("label", _hoisted_126, _toDisplayString(_unref(t)("calendar.settings.backgroundColor")), 1),
                                                  _createElementVNode("div", _hoisted_127, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colorOptions.value, (color) => {
                                                      return (_openBlock(), _createElementBlock("div", {
                                                        key: color.value,
                                                        class: _normalizeClass(["mobile-color-dot", { active: type.color === color.value }]),
                                                        style: _normalizeStyle([{ backgroundColor: color.bg }, {"touch-action":"manipulation"}]),
                                                        onClick: ($event: any) => {
                                type.color = color.value;
                                type.colorCode = color.bg;
                              },
                                                        onTouchend: _withModifiers(($event: any) => {
                                type.color = color.value;
                                type.colorCode = color.bg;
                              }, ["prevent"]),
                                                        title: color.value
                                                      }, null, 46, _hoisted_128))
                                                    }), 128))
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_129, [
                                                  _createElementVNode("button", {
                                                    onClick: ($event: any) => (cancelEditAppointmentType(index)),
                                                    onTouchend: _withModifiers(($event: any) => (cancelEditAppointmentType(index)), ["prevent"]),
                                                    class: "mobile-btn-secondary",
                                                    disabled: savingAppointmentType.value,
                                                    style: {"touch-action":"manipulation"}
                                                  }, [
                                                    _cache[70] || (_cache[70] = _createElementVNode("i", { class: "ri-close-line" }, null, -1)),
                                                    _createTextVNode(" " + _toDisplayString(_unref(t)("common.cancel")), 1)
                                                  ], 40, _hoisted_130),
                                                  _createElementVNode("button", {
                                                    onClick: ($event: any) => (saveAppointmentType(type, index)),
                                                    onTouchend: _withModifiers(($event: any) => (saveAppointmentType(type, index)), ["prevent"]),
                                                    class: "mobile-btn-primary",
                                                    disabled: savingAppointmentType.value,
                                                    style: {"touch-action":"manipulation"}
                                                  }, [
                                                    (savingAppointmentType.value)
                                                      ? (_openBlock(), _createElementBlock("i", _hoisted_132))
                                                      : (_openBlock(), _createElementBlock("i", _hoisted_133)),
                                                    _createTextVNode(" " + _toDisplayString(_unref(t)("common.save")), 1)
                                                  ], 40, _hoisted_131)
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ]))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["col-span-1 lg:col-span-3 bg-white dark:bg-[#15203c] rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 calendar-responsive", { 'mobile-active': mobileView.value === 'calendar', 'calendar-hidden': mobileView.value !== 'calendar' }])
            }, [
              _createElementVNode("div", _hoisted_134, [
                _createElementVNode("div", _hoisted_135, [
                  _createElementVNode("h2", _hoisted_136, _toDisplayString(getCurrentMonthYear.value), 1),
                  _createElementVNode("div", _hoisted_137, [
                    _createElementVNode("button", {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (navigateCalendar('prev'))),
                      class: "text-gray-400 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-300"
                    }, _cache[71] || (_cache[71] = [
                      _createElementVNode("i", { class: "fa-solid fa-chevron-left" }, null, -1)
                    ])),
                    _createElementVNode("button", {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (navigateCalendar('next'))),
                      class: "text-gray-400 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-300"
                    }, _cache[72] || (_cache[72] = [
                      _createElementVNode("i", { class: "fa-solid fa-chevron-right" }, null, -1)
                    ]))
                  ])
                ]),
                _createElementVNode("div", _hoisted_138, [
                  _createElementVNode("button", {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (changeView('month'))),
                    class: _normalizeClass([{ 'bg-gray-100 dark:bg-gray-700': currentView.value === 'month' }, "px-2 lg:px-3 py-2 text-xs lg:text-sm border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300"])
                  }, _toDisplayString(_ctx.$t("calendar.month") || "Month"), 3),
                  _createElementVNode("button", {
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (changeView('week'))),
                    class: _normalizeClass([{ 'bg-gray-100 dark:bg-gray-700': currentView.value === 'week' }, "px-2 lg:px-3 py-2 text-xs lg:text-sm border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300"])
                  }, _toDisplayString(_ctx.$t("calendar.week") || "Week"), 3),
                  _createElementVNode("button", {
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (changeView('day'))),
                    class: _normalizeClass([{ 'bg-gray-100 dark:bg-gray-700': currentView.value === 'day' }, "px-2 lg:px-3 py-2 text-xs lg:text-sm border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300"])
                  }, _toDisplayString(_ctx.$t("calendar.day") || "Day"), 3),
                  _createElementVNode("button", {
                    onClick: openAddEventModal,
                    class: "bg-primary-600 hover:bg-primary-700 text-white px-3 lg:px-4 py-2 rounded-lg text-xs lg:text-sm font-medium"
                  }, [
                    _cache[73] || (_cache[73] = _createElementVNode("i", { class: "fa-solid fa-plus mr-1 lg:mr-2" }, null, -1)),
                    _createElementVNode("span", _hoisted_139, _toDisplayString(_ctx.$t("calendar.addEvent") || "New Appointment"), 1),
                    _createElementVNode("span", _hoisted_140, _toDisplayString(_ctx.$t("calendar.add") || "Add"), 1)
                  ])
                ])
              ]),
              (currentView.value === 'month')
                ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                    _createElementVNode("div", _hoisted_142, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthViewDayHeaders.value, (day, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: day,
                          class: "text-center text-sm font-medium text-gray-700 dark:text-gray-300 p-3"
                        }, [
                          _createElementVNode("span", _hoisted_143, _toDisplayString(day), 1),
                          _createElementVNode("span", _hoisted_144, _toDisplayString(monthViewDayHeadersMobile.value[index]), 1)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_145, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getMonthViewDays.value, (day) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: day.date,
                          class: _normalizeClass(["border border-gray-200 dark:border-gray-600 p-1 lg:p-2 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer calendar-day-min-height", {
                  'bg-gray-50 dark:bg-gray-700': day.isOtherMonth,
                  'bg-blue-50 dark:calendar-today-bg': day.isToday && !isDayOfWeekBlocked(day.date),
                  'bg-gray-100 dark:bg-gray-600': isDayOfWeekBlocked(day.date) && !day.isOtherMonth
                }]),
                          onClick: ($event: any) => (createEventAt(day.date, 9, $event))
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["text-xs lg:text-sm font-medium", {
                    'text-gray-400 dark:text-gray-500': day.isOtherMonth || (isDayOfWeekBlocked(day.date) && !day.isOtherMonth),
                    'text-blue-600 dark:text-blue-400': day.isToday && !isDayOfWeekBlocked(day.date),
                    'text-gray-900 dark:text-white': !day.isOtherMonth && !day.isToday && !isDayOfWeekBlocked(day.date)
                  }])
                          }, _toDisplayString(day.dayNumber), 3),
                          _createElementVNode("div", _hoisted_147, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDayEventsForMonth(day.date), (event) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: event.id,
                                class: _normalizeClass(["text-xs p-1 rounded cursor-pointer truncate", [getEventColorClasses(event), { 'completed-event': event.is_over }]]),
                                onClick: _withModifiers(($event: any) => (openEvent(event)), ["stop"])
                              }, [
                                _createElementVNode("div", _hoisted_149, [
                                  (event.is_over)
                                    ? (_openBlock(), _createElementBlock("i", {
                                        key: 0,
                                        class: "ri-checkbox-circle-fill text-green-500 text-xs",
                                        title: _ctx.$t('calendar.meetingCompleted')
                                      }, null, 8, _hoisted_150))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", {
                                    class: _normalizeClass({ 'line-through opacity-70': event.is_over })
                                  }, _toDisplayString(event.title), 3)
                                ]),
                                (event.timeDisplay)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_151, _toDisplayString(event.timeDisplay), 1))
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_148))
                            }), 128))
                          ])
                        ], 10, _hoisted_146))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_152, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["bg-gray-50 dark:bg-gray-700 rounded-lg overflow-hidden border border-gray-200 dark:border-gray-600", {'overflow-x-auto': currentView.value !== 'day'}])
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["grid", [
              currentView.value === 'day' ? 'grid-cols-2 w-full' : 'grid-cols-8 min-w-[600px]'
            ]])
                      }, [
                        _cache[74] || (_cache[74] = _createElementVNode("div", { class: "bg-white dark:bg-gray-800 p-2 lg:p-4 border-r border-gray-200 dark:border-gray-600 flex items-center justify-center" }, [
                          _createElementVNode("i", { class: "ri-calendar-line text-gray-500 dark:text-gray-400" })
                        ], -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentViewDays.value, (day) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: day.date,
                            class: _normalizeClass(["bg-white dark:bg-gray-800 p-2 lg:p-4 text-center cursor-pointer border-r border-gray-200 dark:border-gray-600 last:border-r-0 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors", {
                  'bg-primary-600 hover:bg-primary-700': day.isToday,
                  'bg-primary-100 dark:bg-primary-900 text-primary-700 dark:text-primary-300': day.isSelected && !day.isToday
                }]),
                            onClick: ($event: any) => (selectDay(day))
                          }, [
                            _createElementVNode("div", _hoisted_154, _toDisplayString(day.dayName), 1),
                            _createElementVNode("div", _hoisted_155, _toDisplayString(day.dayNumber), 1)
                          ], 10, _hoisted_153))
                        }), 128))
                      ], 2)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-600 overflow-hidden", {'overflow-x-auto': currentView.value !== 'day'}]),
                      style: {"min-height":"500px"}
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["grid", [
              currentView.value === 'day' ? 'grid-cols-2 w-full' : 'grid-cols-8 min-w-[600px]'
            ]]),
                        style: _normalizeStyle(currentView.value === 'day' ? 'grid-template-rows: repeat(16, 50px) overflow-y-scroll;' : 'grid-template-rows: repeat(16, 60px) !important; overflow-y-auto;')
                      }, [
                        _createElementVNode("div", _hoisted_156, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hours.value, (hour) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: hour,
                              class: "calendar-hour-height border-b border-gray-100 dark:border-gray-700 flex items-center justify-center text-xs text-gray-500 dark:text-gray-400 font-medium"
                            }, _toDisplayString(formatHour(hour)), 1))
                          }), 128))
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentViewDays.value, (day) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: day.date,
                            class: _normalizeClass(["border-r border-gray-200 dark:border-gray-600 last:border-r-0 relative", { 'bg-blue-50 dark:calendar-today-week-bg': day.isToday }])
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hours.value, (hour) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: hour,
                                class: _normalizeClass(["calendar-hour-height border-b border-gray-100 dark:border-gray-700 relative cursor-pointer hover:bg-gray-50 dark:calendar-hover-gray transition-colors", {
                      'bg-blue-100 dark:calendar-dragover-bg': dragOverSlot.value === `${day.date}-${hour}`,
                      'bg-gray-100 dark:bg-gray-600': isHourOccupied(day.date, hour),
                    }]),
                                onClick: ($event: any) => (createEventAt(day.date, hour, $event)),
                                onDragover: _withModifiers(($event: any) => (handleTimeSlotDragOver($event, day.date, hour)), ["prevent"]),
                                onDragleave: handleDragLeave,
                                onDrop: ($event: any) => (handleTimeSlotDrop($event, day.date, hour))
                              }, _cache[75] || (_cache[75] = [
                                _createElementVNode("div", { class: "absolute inset-0 pointer-events-none" }, [
                                  _createElementVNode("div", {
                                    class: "absolute left-0 right-0 border-t border-gray-50 dark:border-gray-700/50",
                                    style: {"top":"25%"}
                                  }),
                                  _createElementVNode("div", {
                                    class: "absolute left-0 right-0 border-t border-gray-50 dark:border-gray-700/50",
                                    style: {"top":"50%"}
                                  }),
                                  _createElementVNode("div", {
                                    class: "absolute left-0 right-0 border-t border-gray-50 dark:border-gray-700/50",
                                    style: {"top":"75%"}
                                  })
                                ], -1)
                              ]), 42, _hoisted_157))
                            }), 128)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDayEvents(day.date), (event) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: event.id,
                                class: _normalizeClass(["absolute left-1 right-1 rounded-md shadow-sm border cursor-pointer z-10 p-2 text-xs overflow-hidden", [
                    getEventColorClasses(event),
                    { 'opacity-75 scale-95': draggingEvent.value === event.id },
                    { 'completed-event': event.is_over }
                  ]]),
                                style: _normalizeStyle(getAbsoluteEventStyle(event, day.date)),
                                draggable: "true",
                                onDragstart: ($event: any) => (handleEventDragStart($event, event)),
                                onDragend: handleEventDragEnd,
                                onClick: _withModifiers(($event: any) => (openEvent(event)), ["stop"])
                              }, [
                                _createElementVNode("div", _hoisted_159, _toDisplayString(event.timeDisplay), 1),
                                _createElementVNode("div", _hoisted_160, [
                                  (event.is_over)
                                    ? (_openBlock(), _createElementBlock("i", {
                                        key: 0,
                                        class: "ri-checkbox-circle-fill text-green-500 text-xs flex-shrink-0",
                                        title: _ctx.$t('calendar.meetingCompleted')
                                      }, null, 8, _hoisted_161))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["truncate", { 'line-through opacity-70': event.is_over }])
                                  }, _toDisplayString(event.title), 3)
                                ]),
                                (event.location)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                                      _cache[76] || (_cache[76] = _createElementVNode("i", { class: "ri-map-pin-line" }, null, -1)),
                                      _createElementVNode("span", _hoisted_163, _toDisplayString(event.location), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (userPermissions.value.view_all_calendars && selectedUserCalendars.value.length > 1)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: "absolute top-1 right-1 bg-primary-600 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center font-bold",
                                      title: getUserDisplayName(event.userId)
                                    }, _toDisplayString(getUserInitials(event.userId)), 9, _hoisted_164))
                                  : _createCommentVNode("", true),
                                _cache[77] || (_cache[77] = _createElementVNode("div", { class: "absolute top-1 left-1 opacity-0 hover:opacity-100 transition-opacity" }, [
                                  _createElementVNode("i", { class: "ri-drag-move-line text-gray-400" })
                                ], -1))
                              ], 46, _hoisted_158))
                            }), 128))
                          ], 2))
                        }), 128))
                      ], 6)
                    ], 2)
                  ])),
              (selectedEvent.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "modal",
                    onClick: closeEventDetail
                  }, [
                    _createElementVNode("div", {
                      class: "modal-content add-event-modal no-frame",
                      onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("div", _hoisted_165, [
                        _createElementVNode("div", _hoisted_166, [
                          _cache[78] || (_cache[78] = _createElementVNode("div", { class: "header-icon-clean" }, [
                            _createElementVNode("i", { class: "ri-calendar-check-line" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_167, [
                            _createElementVNode("h3", null, _toDisplayString(selectedEvent.value.title), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t("calendar.eventDetails")), 1)
                          ])
                        ]),
                        _createElementVNode("button", {
                          onClick: closeEventDetail,
                          class: "close-btn-clean"
                        }, _cache[79] || (_cache[79] = [
                          _createElementVNode("i", { class: "ri-close-line" }, null, -1)
                        ]))
                      ]),
                      _createElementVNode("div", _hoisted_168, [
                        _createElementVNode("div", _hoisted_169, [
                          _createElementVNode("div", _hoisted_170, [
                            _createElementVNode("div", _hoisted_171, [
                              _cache[80] || (_cache[80] = _createElementVNode("div", { class: "detail-icon" }, [
                                _createElementVNode("i", { class: "ri-calendar-line" })
                              ], -1)),
                              _createElementVNode("div", _hoisted_172, [
                                _createElementVNode("label", _hoisted_173, _toDisplayString(_ctx.$t("calendar.date")), 1),
                                _createElementVNode("span", _hoisted_174, _toDisplayString(selectedEvent.value.dateDisplay), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_175, [
                              _cache[81] || (_cache[81] = _createElementVNode("div", { class: "detail-icon" }, [
                                _createElementVNode("i", { class: "ri-time-line" })
                              ], -1)),
                              _createElementVNode("div", _hoisted_176, [
                                _createElementVNode("label", _hoisted_177, _toDisplayString(_ctx.$t("calendar.time")), 1),
                                _createElementVNode("span", _hoisted_178, _toDisplayString(selectedEvent.value.timeRange), 1)
                              ])
                            ]),
                            (selectedEvent.value.type)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                                  _cache[82] || (_cache[82] = _createElementVNode("div", { class: "detail-icon" }, [
                                    _createElementVNode("i", { class: "ri-bookmark-line" })
                                  ], -1)),
                                  _createElementVNode("div", _hoisted_180, [
                                    _createElementVNode("label", _hoisted_181, _toDisplayString(_ctx.$t("calendar.eventType")), 1),
                                    _createElementVNode("span", _hoisted_182, _toDisplayString(selectedEvent.value.type), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (selectedEvent.value.location)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_183, [
                                  _cache[83] || (_cache[83] = _createElementVNode("div", { class: "detail-icon" }, [
                                    _createElementVNode("i", { class: "ri-map-pin-line" })
                                  ], -1)),
                                  _createElementVNode("div", _hoisted_184, [
                                    _createElementVNode("label", _hoisted_185, _toDisplayString(_ctx.$t("calendar.location")), 1),
                                    _createElementVNode("span", _hoisted_186, _toDisplayString(selectedEvent.value.location), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (selectedEvent.value.description)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                                  _cache[84] || (_cache[84] = _createElementVNode("div", { class: "detail-icon" }, [
                                    _createElementVNode("i", { class: "ri-file-text-line" })
                                  ], -1)),
                                  _createElementVNode("div", _hoisted_188, [
                                    _createElementVNode("label", _hoisted_189, _toDisplayString(_ctx.$t("calendar.description")), 1),
                                    _createElementVNode("span", _hoisted_190, _toDisplayString(selectedEvent.value.description), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (
                    selectedEvent.value.participants && selectedEvent.value.participants.length > 0
                  )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_191, [
                                _createElementVNode("h4", _hoisted_192, _toDisplayString(_ctx.$t("calendar.participants")), 1),
                                _createElementVNode("div", _hoisted_193, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedEvent.value.participants, (participant) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: participant.id,
                                      class: "participant-item-detail"
                                    }, [
                                      _cache[85] || (_cache[85] = _createElementVNode("div", { class: "participant-icon" }, [
                                        _createElementVNode("i", { class: "ri-user-line" })
                                      ], -1)),
                                      _createElementVNode("div", _hoisted_194, [
                                        _createElementVNode("span", _hoisted_195, _toDisplayString(participant.name), 1),
                                        (participant.email)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_196, _toDisplayString(participant.email), 1))
                                          : _createCommentVNode("", true),
                                        (participant.phone)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_197, _toDisplayString(participant.phone), 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_198, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn-clean btn-danger",
                          onClick: deleteEventFromView
                        }, [
                          _cache[86] || (_cache[86] = _createElementVNode("i", { class: "ri-delete-bin-line" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("calendar.delete")), 1)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn-clean btn-secondary",
                          onClick: openEditEventModal
                        }, [
                          _cache[87] || (_cache[87] = _createElementVNode("i", { class: "ri-edit-line" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("calendar.edit")), 1)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(selectedEvent.value.is_over ? 'btn-clean btn-warning' : 'btn-clean btn-success'),
                          style: {"color":"#ffffff !important"},
                          onClick: toggleEventCompletion
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(selectedEvent.value.is_over ? 'ri-refresh-line' : 'ri-checkbox-circle-line')
                          }, null, 2),
                          _createTextVNode(" " + _toDisplayString(selectedEvent.value.is_over ? _ctx.$t("calendar.markAsNotCompleted") : _ctx.$t("calendar.markAsCompleted")), 1)
                        ], 2)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (showAddEventModal.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: "modal",
                    onClick: closeAddEventModal
                  }, [
                    _createElementVNode("div", {
                      class: "modal-content add-event-modal no-frame",
                      onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("div", _hoisted_199, [
                        _createElementVNode("div", _hoisted_200, [
                          _cache[88] || (_cache[88] = _createElementVNode("div", { class: "header-icon-clean" }, [
                            _createElementVNode("i", { class: "ri-calendar-event-line" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_201, [
                            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("calendar.createNewEvent")), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t("calendar.addNewEventToCalendar")), 1)
                          ])
                        ]),
                        _createElementVNode("button", {
                          onClick: closeAddEventModal,
                          class: "close-btn-clean"
                        }, _cache[89] || (_cache[89] = [
                          _createElementVNode("i", { class: "ri-close-line" }, null, -1)
                        ]))
                      ]),
                      _createElementVNode("div", _hoisted_202, [
                        _createElementVNode("form", {
                          onSubmit: _withModifiers(saveNewEvent, ["prevent"]),
                          class: "event-form"
                        }, [
                          _createElementVNode("div", _hoisted_203, [
                            _createElementVNode("div", _hoisted_204, [
                              _createElementVNode("label", _hoisted_205, _toDisplayString(_ctx.$t("calendar.eventTitle")) + " *", 1),
                              _createElementVNode("div", _hoisted_206, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((newEvent.value.title) = $event)),
                                  type: "text",
                                  placeholder: _ctx.$t('calendar.enterEventTitle'),
                                  class: "form-input",
                                  required: ""
                                }, null, 8, _hoisted_207), [
                                  [_vModelText, newEvent.value.title]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_208, [
                              _createElementVNode("label", _hoisted_209, _toDisplayString(_ctx.$t("calendar.eventType")) + " *", 1),
                              _createElementVNode("div", _hoisted_210, [
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((newEvent.value.type) = $event)),
                                  class: "form-input form-select",
                                  required: "",
                                  onChange: updateEventDuration
                                }, [
                                  _createElementVNode("option", _hoisted_211, _toDisplayString(_ctx.$t("calendar.selectType")), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appointmentTypes.value, (type) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: type.id || type.name,
                                      value: type.name
                                    }, _toDisplayString(type.name) + " (" + _toDisplayString(type.duration) + " " + _toDisplayString(_ctx.$t("calendar.minutes")) + ") ", 9, _hoisted_212))
                                  }), 128))
                                ], 544), [
                                  [_vModelSelect, newEvent.value.type]
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_213, [
                            _createElementVNode("div", _hoisted_214, [
                              _createElementVNode("label", _hoisted_215, _toDisplayString(_ctx.$t("calendar.date")) + " *", 1),
                              _createElementVNode("div", _hoisted_216, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((newEvent.value.date) = $event)),
                                  type: "date",
                                  class: "form-input",
                                  required: ""
                                }, null, 512), [
                                  [_vModelText, newEvent.value.date]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_217, [
                              _createElementVNode("label", _hoisted_218, _toDisplayString(_ctx.$t("calendar.startTime")) + " *", 1),
                              _createElementVNode("div", _hoisted_219, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((newEvent.value.startTime) = $event)),
                                  type: "time",
                                  class: "form-input",
                                  required: ""
                                }, null, 512), [
                                  [_vModelText, newEvent.value.startTime]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_220, [
                              _createElementVNode("label", _hoisted_221, _toDisplayString(_ctx.$t("calendar.endTime")) + " *", 1),
                              _createElementVNode("div", _hoisted_222, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((newEvent.value.endTime) = $event)),
                                  type: "time",
                                  class: "form-input",
                                  required: ""
                                }, null, 512), [
                                  [_vModelText, newEvent.value.endTime]
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_223, [
                            _createElementVNode("label", _hoisted_224, _toDisplayString(_ctx.$t("calendar.location")), 1),
                            _createElementVNode("div", _hoisted_225, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((newEvent.value.location) = $event)),
                                type: "text",
                                placeholder: _ctx.$t('calendar.enterLocation'),
                                class: "form-input"
                              }, null, 8, _hoisted_226), [
                                [_vModelText, newEvent.value.location]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_227, [
                            _createElementVNode("label", _hoisted_228, _toDisplayString(_ctx.$t("calendar.description")), 1),
                            _createElementVNode("div", _hoisted_229, [
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((newEvent.value.description) = $event)),
                                placeholder: _ctx.$t('calendar.enterDescription'),
                                class: "form-input form-textarea",
                                rows: "3"
                              }, null, 8, _hoisted_230), [
                                [_vModelText, newEvent.value.description]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_231, [
                            _createElementVNode("div", _hoisted_232, [
                              _createElementVNode("label", _hoisted_233, _toDisplayString(_ctx.$t("calendar.participants")), 1),
                              _createElementVNode("div", _hoisted_234, [
                                _createElementVNode("div", _hoisted_235, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: openLeadsSearch,
                                    class: "search-leads-btn"
                                  }, [
                                    _cache[90] || (_cache[90] = _createElementVNode("i", { class: "ri-user-star-line" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)("calendar.searchLeads")), 1)
                                  ]),
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: openClientsSearch,
                                    class: "search-clients-btn"
                                  }, [
                                    _cache[91] || (_cache[91] = _createElementVNode("i", { class: "ri-user-heart-line" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)("calendar.searchClients")), 1)
                                  ])
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: addParticipant,
                                  class: "add-btn"
                                }, [
                                  _cache[92] || (_cache[92] = _createElementVNode("i", { class: "ri-add-line" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("calendar.add")), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_236, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newEvent.value.participants, (participant, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "participant-card"
                                }, [
                                  _createElementVNode("div", _hoisted_237, [
                                    _createElementVNode("div", _hoisted_238, [
                                      _cache[93] || (_cache[93] = _createElementVNode("i", { class: "ri-user-line input-icon-clean" }, null, -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event: any) => ((participant.name) = $event),
                                        type: "text",
                                        placeholder: _ctx.$t('calendar.name'),
                                        class: "form-input participant-input"
                                      }, null, 8, _hoisted_239), [
                                        [_vModelText, participant.name]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_240, [
                                      _cache[94] || (_cache[94] = _createElementVNode("i", { class: "ri-mail-line input-icon-clean" }, null, -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event: any) => ((participant.email) = $event),
                                        type: "email",
                                        placeholder: _ctx.$t('calendar.email'),
                                        class: "form-input participant-input"
                                      }, null, 8, _hoisted_241), [
                                        [_vModelText, participant.email]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_242, [
                                      _cache[95] || (_cache[95] = _createElementVNode("i", { class: "ri-phone-line input-icon-clean" }, null, -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event: any) => ((participant.phone) = $event),
                                        type: "tel",
                                        placeholder: _ctx.$t('calendar.phone'),
                                        class: "form-input participant-input"
                                      }, null, 8, _hoisted_243), [
                                        [_vModelText, participant.phone]
                                      ])
                                    ])
                                  ]),
                                  (newEvent.value.participants.length > 1)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        onClick: ($event: any) => (removeParticipant(index)),
                                        class: "remove-btn"
                                      }, _cache[96] || (_cache[96] = [
                                        _createElementVNode("i", { class: "ri-delete-bin-line" }, null, -1)
                                      ]), 8, _hoisted_244))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ])
                        ], 32)
                      ]),
                      _createElementVNode("div", _hoisted_245, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn-clean btn-secondary",
                          onClick: closeAddEventModal
                        }, _toDisplayString(_ctx.$t("calendar.cancel")), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn-clean btn-primary",
                          onClick: saveNewEvent
                        }, [
                          _cache[97] || (_cache[97] = _createElementVNode("i", { class: "ri-save-line" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("calendar.createEvent")), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (showEditEventModal.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 4,
                    class: "modal",
                    onClick: closeEditEventModal
                  }, [
                    _createElementVNode("div", {
                      class: "modal-content add-event-modal no-frame",
                      onClick: _cache[29] || (_cache[29] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("div", _hoisted_246, [
                        _createElementVNode("div", _hoisted_247, [
                          _cache[98] || (_cache[98] = _createElementVNode("div", { class: "header-icon-clean" }, [
                            _createElementVNode("i", { class: "ri-edit-line" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_248, [
                            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("calendar.editEvent")), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t("calendar.updateEventDetails")), 1)
                          ])
                        ]),
                        _createElementVNode("button", {
                          onClick: closeEditEventModal,
                          class: "close-btn-clean"
                        }, _cache[99] || (_cache[99] = [
                          _createElementVNode("i", { class: "ri-close-line" }, null, -1)
                        ]))
                      ]),
                      _createElementVNode("div", _hoisted_249, [
                        _createElementVNode("form", {
                          onSubmit: _withModifiers(updateEvent, ["prevent"]),
                          class: "event-form"
                        }, [
                          _createElementVNode("div", _hoisted_250, [
                            _createElementVNode("div", _hoisted_251, [
                              _createElementVNode("label", _hoisted_252, _toDisplayString(_ctx.$t("calendar.eventTitle")) + " *", 1),
                              _createElementVNode("div", _hoisted_253, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((editingEvent.value.title) = $event)),
                                  type: "text",
                                  placeholder: _ctx.$t('calendar.enterEventTitle'),
                                  class: "form-input",
                                  required: ""
                                }, null, 8, _hoisted_254), [
                                  [_vModelText, editingEvent.value.title]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_255, [
                              _createElementVNode("label", _hoisted_256, _toDisplayString(_ctx.$t("calendar.eventType")) + " *", 1),
                              _createElementVNode("div", _hoisted_257, [
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((editingEvent.value.type) = $event)),
                                  class: "form-input form-select",
                                  required: ""
                                }, [
                                  _createElementVNode("option", _hoisted_258, _toDisplayString(_ctx.$t("calendar.selectType")), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appointmentTypes.value, (type) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: type.id || type.name,
                                      value: type.name
                                    }, _toDisplayString(type.name) + " (" + _toDisplayString(type.duration) + " " + _toDisplayString(_ctx.$t("calendar.minutes")) + ") ", 9, _hoisted_259))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, editingEvent.value.type]
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_260, [
                            _createElementVNode("div", _hoisted_261, [
                              _createElementVNode("label", _hoisted_262, _toDisplayString(_ctx.$t("calendar.date")) + " *", 1),
                              _createElementVNode("div", _hoisted_263, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((editingEvent.value.date) = $event)),
                                  type: "date",
                                  class: "form-input",
                                  required: ""
                                }, null, 512), [
                                  [_vModelText, editingEvent.value.date]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_264, [
                              _createElementVNode("label", _hoisted_265, _toDisplayString(_ctx.$t("calendar.startTime")) + " *", 1),
                              _createElementVNode("div", _hoisted_266, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((editingEvent.value.startTime) = $event)),
                                  type: "time",
                                  class: "form-input",
                                  required: ""
                                }, null, 512), [
                                  [_vModelText, editingEvent.value.startTime]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_267, [
                              _createElementVNode("label", _hoisted_268, _toDisplayString(_ctx.$t("calendar.endTime")) + " *", 1),
                              _createElementVNode("div", _hoisted_269, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((editingEvent.value.endTime) = $event)),
                                  type: "time",
                                  class: "form-input",
                                  required: ""
                                }, null, 512), [
                                  [_vModelText, editingEvent.value.endTime]
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_270, [
                            _createElementVNode("label", _hoisted_271, _toDisplayString(_ctx.$t("calendar.location")), 1),
                            _createElementVNode("div", _hoisted_272, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((editingEvent.value.location) = $event)),
                                type: "text",
                                placeholder: _ctx.$t('calendar.enterLocation'),
                                class: "form-input"
                              }, null, 8, _hoisted_273), [
                                [_vModelText, editingEvent.value.location]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_274, [
                            _createElementVNode("label", _hoisted_275, _toDisplayString(_ctx.$t("calendar.description")), 1),
                            _createElementVNode("div", _hoisted_276, [
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((editingEvent.value.description) = $event)),
                                placeholder: _ctx.$t('calendar.enterDescription'),
                                class: "form-input form-textarea",
                                rows: "3"
                              }, null, 8, _hoisted_277), [
                                [_vModelText, editingEvent.value.description]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_278, [
                            _createElementVNode("div", _hoisted_279, [
                              _createElementVNode("label", _hoisted_280, _toDisplayString(_ctx.$t("calendar.participants")), 1),
                              _createElementVNode("div", _hoisted_281, [
                                _createElementVNode("div", _hoisted_282, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: openLeadsSearchForEdit,
                                    class: "search-leads-btn"
                                  }, [
                                    _cache[100] || (_cache[100] = _createElementVNode("i", { class: "ri-user-star-line" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)("calendar.searchLeads")), 1)
                                  ]),
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: openClientsSearchForEdit,
                                    class: "search-clients-btn"
                                  }, [
                                    _cache[101] || (_cache[101] = _createElementVNode("i", { class: "ri-user-heart-line" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)("calendar.searchClients")), 1)
                                  ])
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: addParticipantToEdit,
                                  class: "add-btn"
                                }, [
                                  _cache[102] || (_cache[102] = _createElementVNode("i", { class: "ri-add-line" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("calendar.add")), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_283, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editingEvent.value.participants, (participant, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "participant-card"
                                }, [
                                  _createElementVNode("div", _hoisted_284, [
                                    _createElementVNode("div", _hoisted_285, [
                                      _cache[103] || (_cache[103] = _createElementVNode("i", { class: "ri-user-line input-icon-clean" }, null, -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event: any) => ((participant.name) = $event),
                                        type: "text",
                                        placeholder: _ctx.$t('calendar.name'),
                                        class: "form-input participant-input"
                                      }, null, 8, _hoisted_286), [
                                        [_vModelText, participant.name]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_287, [
                                      _cache[104] || (_cache[104] = _createElementVNode("i", { class: "ri-mail-line input-icon-clean" }, null, -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event: any) => ((participant.email) = $event),
                                        type: "email",
                                        placeholder: _ctx.$t('calendar.email'),
                                        class: "form-input participant-input"
                                      }, null, 8, _hoisted_288), [
                                        [_vModelText, participant.email]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_289, [
                                      _cache[105] || (_cache[105] = _createElementVNode("i", { class: "ri-phone-line input-icon-clean" }, null, -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event: any) => ((participant.phone) = $event),
                                        type: "tel",
                                        placeholder: _ctx.$t('calendar.phone'),
                                        class: "form-input participant-input"
                                      }, null, 8, _hoisted_290), [
                                        [_vModelText, participant.phone]
                                      ])
                                    ])
                                  ]),
                                  (editingEvent.value.participants.length > 1)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        onClick: ($event: any) => (removeParticipantFromEdit(index)),
                                        class: "remove-btn"
                                      }, _cache[106] || (_cache[106] = [
                                        _createElementVNode("i", { class: "ri-delete-bin-line" }, null, -1)
                                      ]), 8, _hoisted_291))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ])
                        ], 32)
                      ]),
                      _createElementVNode("div", _hoisted_292, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn-clean btn-danger",
                          onClick: deleteEvent
                        }, [
                          _cache[107] || (_cache[107] = _createElementVNode("i", { class: "ri-delete-bin-line" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("calendar.deleteEvent")), 1)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn-clean btn-secondary",
                          onClick: closeEditEventModal
                        }, _toDisplayString(_ctx.$t("calendar.cancel")), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn-clean btn-primary",
                          onClick: updateEvent
                        }, [
                          _cache[108] || (_cache[108] = _createElementVNode("i", { class: "ri-save-line" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("calendar.saveChanges")), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (isDragging.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 5,
                    class: _normalizeClass(["drag-ghost", dragGhostClass.value]),
                    style: _normalizeStyle(dragGhostStyle.value)
                  }, [
                    _createElementVNode("div", _hoisted_293, [
                      _createElementVNode("div", _hoisted_294, _toDisplayString(dragGhostContent.value.title), 1),
                      _createElementVNode("div", _hoisted_295, _toDisplayString(dragGhostContent.value.time), 1)
                    ])
                  ], 6))
                : _createCommentVNode("", true),
              (showContactSearch.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 6,
                    class: "event-detail-modal",
                    onClick: closeContactSearch
                  }, [
                    _createElementVNode("div", {
                      class: "modal-content contact-search-modal",
                      onClick: _cache[31] || (_cache[31] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("div", { class: "modal-header-clean" }, [
                        _cache[110] || (_cache[110] = _createElementVNode("div", { class: "header-content" }, [
                          _createElementVNode("div", { class: "header-icon-clean" }, [
                            _createElementVNode("i", { class: "ri-contacts-line" })
                          ]),
                          _createElementVNode("div", { class: "header-text-clean" }, [
                            _createElementVNode("h3", null, "Search Contacts"),
                            _createElementVNode("p", null, "Find and add contacts to your event")
                          ])
                        ], -1)),
                        _createElementVNode("button", {
                          onClick: closeContactSearch,
                          class: "close-btn-clean"
                        }, _cache[109] || (_cache[109] = [
                          _createElementVNode("i", { class: "ri-close-line" }, null, -1)
                        ]))
                      ]),
                      _createElementVNode("div", _hoisted_296, [
                        _createElementVNode("div", _hoisted_297, [
                          _cache[111] || (_cache[111] = _createElementVNode("i", { class: "ri-search-line search-icon" }, null, -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((contactSearchQuery).value = $event)),
                            type: "text",
                            placeholder: "Search by name, email, or phone...",
                            class: "contact-search-input",
                            onInput: searchContacts
                          }, null, 544), [
                            [_vModelText, contactSearchQuery.value]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_298, [
                          (isSearching.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_299, _cache[112] || (_cache[112] = [
                                _createElementVNode("i", { class: "ri-loader-4-line spin" }, null, -1),
                                _createTextVNode(" Searching... ")
                              ])))
                            : (filteredContacts.value.length === 0 && contactSearchQuery.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_300, _cache[113] || (_cache[113] = [
                                  _createElementVNode("i", { class: "ri-user-search-line" }, null, -1),
                                  _createElementVNode("p", null, "No contacts found", -1)
                                ])))
                              : (contactSearchQuery.value === '')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_301, _cache[114] || (_cache[114] = [
                                    _createElementVNode("i", { class: "ri-search-2-line" }, null, -1),
                                    _createElementVNode("p", null, "Start typing to search contacts", -1)
                                  ])))
                                : (_openBlock(), _createElementBlock("div", _hoisted_302, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredContacts.value, (contact) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: contact.id,
                                        class: "contact-item",
                                        onClick: ($event: any) => (selectContact(contact))
                                      }, [
                                        _createElementVNode("div", _hoisted_304, [
                                          (contact.avatar)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: contact.avatar,
                                                alt: contact.name
                                              }, null, 8, _hoisted_305))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_306, _toDisplayString(contact.name.charAt(0).toUpperCase()), 1))
                                        ]),
                                        _createElementVNode("div", _hoisted_307, [
                                          _createElementVNode("h4", _hoisted_308, _toDisplayString(contact.name), 1),
                                          _createElementVNode("p", _hoisted_309, _toDisplayString(contact.email), 1),
                                          (contact.phone)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_310, _toDisplayString(contact.phone), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _cache[115] || (_cache[115] = _createElementVNode("div", { class: "contact-select" }, [
                                          _createElementVNode("i", { class: "ri-add-circle-line" })
                                        ], -1))
                                      ], 8, _hoisted_303))
                                    }), 128))
                                  ]))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (showLeadsSearch.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 7,
                    class: "modal",
                    onClick: closeLeadsSearch
                  }, [
                    _createElementVNode("div", {
                      class: "modal-content contact-search-modal",
                      onClick: _cache[33] || (_cache[33] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("div", _hoisted_311, [
                        _createElementVNode("div", _hoisted_312, [
                          _cache[116] || (_cache[116] = _createElementVNode("div", { class: "header-icon-clean" }, [
                            _createElementVNode("i", { class: "ri-user-star-line" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_313, [
                            _createElementVNode("h3", null, _toDisplayString(_unref(t)("calendar.searchLeadsTitle")), 1),
                            _createElementVNode("p", null, _toDisplayString(_unref(t)("calendar.searchLeadsSubtitle")), 1)
                          ])
                        ]),
                        _createElementVNode("button", {
                          onClick: closeLeadsSearch,
                          class: "close-btn-clean"
                        }, _cache[117] || (_cache[117] = [
                          _createElementVNode("i", { class: "ri-close-line" }, null, -1)
                        ]))
                      ]),
                      _createElementVNode("div", _hoisted_314, [
                        _createElementVNode("div", _hoisted_315, [
                          _cache[118] || (_cache[118] = _createElementVNode("i", { class: "ri-search-line search-icon" }, null, -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((leadsSearchQuery).value = $event)),
                            type: "text",
                            placeholder: _unref(t)('calendar.searchByNameEmailPhone'),
                            class: "contact-search-input",
                            onInput: searchLeads
                          }, null, 40, _hoisted_316), [
                            [_vModelText, leadsSearchQuery.value]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_317, [
                          (loadingLeads.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_318, [
                                _cache[119] || (_cache[119] = _createElementVNode("i", { class: "ri-loader-4-line spin" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_unref(t)("calendar.loadingLeads")), 1)
                              ]))
                            : (isSearchingLeads.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_319, [
                                  _cache[120] || (_cache[120] = _createElementVNode("i", { class: "ri-loader-4-line spin" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_unref(t)("calendar.searching")), 1)
                                ]))
                              : (filteredLeads.value.length === 0 && leadsSearchQuery.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_320, [
                                    _cache[121] || (_cache[121] = _createElementVNode("i", { class: "ri-user-search-line" }, null, -1)),
                                    _createElementVNode("p", null, _toDisplayString(_unref(t)("calendar.noLeadsFound")), 1)
                                  ]))
                                : (leadsSearchQuery.value === '')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_321, [
                                      _cache[122] || (_cache[122] = _createElementVNode("i", { class: "ri-search-2-line" }, null, -1)),
                                      _createElementVNode("p", null, _toDisplayString(_unref(t)("calendar.startTypingToSearchLeads")), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_322, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredLeads.value, (lead) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: lead.id,
                                          class: "contact-item",
                                          onClick: ($event: any) => (isEditMode.value ? selectLeadForEdit(lead) : selectLead(lead))
                                        }, [
                                          _createElementVNode("div", _hoisted_324, [
                                            (lead.profileImageLink)
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  src: lead.profileImageLink,
                                                  alt: lead.name
                                                }, null, 8, _hoisted_325))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_326, _toDisplayString((lead.name || "L").charAt(0).toUpperCase()), 1))
                                          ]),
                                          _createElementVNode("div", _hoisted_327, [
                                            _createElementVNode("h4", _hoisted_328, _toDisplayString(lead.name || _unref(t)("calendar.noName")), 1),
                                            _createElementVNode("p", _hoisted_329, _toDisplayString(lead.email || _unref(t)("calendar.noEmail")), 1),
                                            (lead.phone)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_330, _toDisplayString(lead.phone), 1))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("p", _hoisted_331, _toDisplayString(_unref(t)("calendar.status")) + ": " + _toDisplayString(lead.status || _unref(t)("calendar.unknown")), 1)
                                          ]),
                                          _cache[123] || (_cache[123] = _createElementVNode("div", { class: "contact-select" }, [
                                            _createElementVNode("i", { class: "ri-add-circle-line" })
                                          ], -1))
                                        ], 8, _hoisted_323))
                                      }), 128))
                                    ]))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (showClientsSearch.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 8,
                    class: "modal",
                    onClick: closeClientsSearch
                  }, [
                    _createElementVNode("div", {
                      class: "modal-content contact-search-modal",
                      onClick: _cache[35] || (_cache[35] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("div", _hoisted_332, [
                        _createElementVNode("div", _hoisted_333, [
                          _cache[124] || (_cache[124] = _createElementVNode("div", { class: "header-icon-clean" }, [
                            _createElementVNode("i", { class: "ri-user-heart-line" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_334, [
                            _createElementVNode("h3", null, _toDisplayString(_unref(t)("calendar.searchClientsTitle")), 1),
                            _createElementVNode("p", null, _toDisplayString(_unref(t)("calendar.searchClientsSubtitle")), 1)
                          ])
                        ]),
                        _createElementVNode("button", {
                          onClick: closeClientsSearch,
                          class: "close-btn-clean"
                        }, _cache[125] || (_cache[125] = [
                          _createElementVNode("i", { class: "ri-close-line" }, null, -1)
                        ]))
                      ]),
                      _createElementVNode("div", _hoisted_335, [
                        _createElementVNode("div", _hoisted_336, [
                          _cache[126] || (_cache[126] = _createElementVNode("i", { class: "ri-search-line search-icon" }, null, -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((clientsSearchQuery).value = $event)),
                            type: "text",
                            placeholder: _unref(t)('calendar.searchByNameEmailPhone'),
                            class: "contact-search-input",
                            onInput: searchClients
                          }, null, 40, _hoisted_337), [
                            [_vModelText, clientsSearchQuery.value]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_338, [
                          (loadingClients.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_339, [
                                _cache[127] || (_cache[127] = _createElementVNode("i", { class: "ri-loader-4-line spin" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_unref(t)("calendar.loadingClients")), 1)
                              ]))
                            : (isSearchingClients.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_340, [
                                  _cache[128] || (_cache[128] = _createElementVNode("i", { class: "ri-loader-4-line spin" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_unref(t)("calendar.searching")), 1)
                                ]))
                              : (filteredClients.value.length === 0 && clientsSearchQuery.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_341, [
                                    _cache[129] || (_cache[129] = _createElementVNode("i", { class: "ri-user-search-line" }, null, -1)),
                                    _createElementVNode("p", null, _toDisplayString(_unref(t)("calendar.noClientsFound")), 1)
                                  ]))
                                : (clientsSearchQuery.value === '')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_342, [
                                      _cache[130] || (_cache[130] = _createElementVNode("i", { class: "ri-search-2-line" }, null, -1)),
                                      _createElementVNode("p", null, _toDisplayString(_unref(t)("calendar.startTypingToSearchClients")), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_343, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredClients.value, (client) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: client.id,
                                          class: "contact-item",
                                          onClick: ($event: any) => (
                      isEditMode.value ? selectClientForEdit(client) : selectClient(client)
                    )
                                        }, [
                                          _createElementVNode("div", _hoisted_345, [
                                            _createElementVNode("div", _hoisted_346, _toDisplayString(client.name.charAt(0).toUpperCase()), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_347, [
                                            _createElementVNode("h4", _hoisted_348, _toDisplayString(client.name), 1),
                                            _createElementVNode("p", _hoisted_349, _toDisplayString(client.email || _unref(t)("calendar.noEmail")), 1),
                                            (client.phone)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_350, _toDisplayString(client.phone), 1))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("p", _hoisted_351, _toDisplayString(_unref(t)("calendar.status")) + ": " + _toDisplayString(client.status || _unref(t)("calendar.unknown")), 1)
                                          ]),
                                          _cache[131] || (_cache[131] = _createElementVNode("div", { class: "contact-select" }, [
                                            _createElementVNode("i", { class: "ri-add-circle-line" })
                                          ], -1))
                                        ], 8, _hoisted_344))
                                      }), 128))
                                    ]))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (showSettingsModal.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 9,
                    class: _normalizeClass(["modal", { dark: isDarkMode.value }]),
                    onClick: closeSettingsModal
                  }, [
                    _createElementVNode("div", {
                      class: "modal-content settings-modal apple-style",
                      onClick: _cache[40] || (_cache[40] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("div", _hoisted_352, [
                        _createElementVNode("div", _hoisted_353, [
                          _cache[132] || (_cache[132] = _createElementVNode("div", { class: "header-icon apple-icon" }, [
                            _createElementVNode("i", { class: "ri-settings-3-line" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_354, [
                            _createElementVNode("h3", null, _toDisplayString(_unref(t)("calendar.settings.title")), 1),
                            _createElementVNode("p", null, _toDisplayString(_unref(t)("calendar.settings.subtitle")), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_355, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(settingsTabs.value, (tab) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: tab.id,
                            onClick: ($event: any) => (activeTab.value = tab.id),
                            class: _normalizeClass([{ active: activeTab.value === tab.id }, "nav-tab"])
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(tab.icon)
                            }, null, 2),
                            _createElementVNode("span", null, _toDisplayString(_unref(t)(tab.nameKey)), 1)
                          ], 10, _hoisted_356))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_357, [
                        (activeTab.value === 'hours')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_358, [
                              _createElementVNode("div", _hoisted_359, [
                                _createElementVNode("div", _hoisted_360, [
                                  _createElementVNode("h4", null, _toDisplayString(_unref(t)("calendar.settings.businessHours")), 1),
                                  _createElementVNode("p", null, _toDisplayString(_unref(t)("calendar.settings.businessHoursDescription")), 1)
                                ]),
                                (loadingAvailability.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_361, [
                                      _cache[133] || (_cache[133] = _createElementVNode("i", { class: "ri-loader-5-line animate-spin" }, null, -1)),
                                      _createElementVNode("span", null, _toDisplayString(_unref(t)("calendar.settings.loadingWorkingHours")), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_362, [
                                      _createElementVNode("div", _hoisted_363, [
                                        _createElementVNode("div", _hoisted_364, [
                                          _createElementVNode("label", null, _toDisplayString(_unref(t)("calendar.settings.enableWorkingHours")), 1),
                                          _createElementVNode("span", _hoisted_365, _toDisplayString(_unref(t)("calendar.settings.enableWorkingHoursDescription")), 1)
                                        ]),
                                        _createElementVNode("label", _hoisted_366, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((workingHoursEnabled).value = $event))
                                          }, null, 512), [
                                            [_vModelCheckbox, workingHoursEnabled.value]
                                          ]),
                                          _cache[134] || (_cache[134] = _createElementVNode("span", { class: "switch-slider" }, null, -1))
                                        ])
                                      ]),
                                      (workingHoursEnabled.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_367, [
                                            _createElementVNode("div", _hoisted_368, [
                                              _createElementVNode("span", _hoisted_369, _toDisplayString(_unref(t)("calendar.settings.day")), 1),
                                              _createElementVNode("span", _hoisted_370, _toDisplayString(_unref(t)("calendar.settings.workingHours")), 1),
                                              _createElementVNode("span", _hoisted_371, _toDisplayString(_unref(t)("calendar.settings.status")), 1)
                                            ]),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workingDays.value, (day) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: day.key,
                                                class: _normalizeClass(["day-row", { disabled: !day.enabled }])
                                              }, [
                                                _createElementVNode("div", _hoisted_372, [
                                                  _createElementVNode("label", _hoisted_373, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "checkbox",
                                                      "onUpdate:modelValue": ($event: any) => ((day.enabled) = $event)
                                                    }, null, 8, _hoisted_374), [
                                                      [_vModelCheckbox, day.enabled]
                                                    ]),
                                                    _cache[135] || (_cache[135] = _createElementVNode("span", { class: "checkmark" }, null, -1))
                                                  ]),
                                                  _createElementVNode("div", _hoisted_375, [
                                                    _createElementVNode("span", _hoisted_376, _toDisplayString(_unref(t)(`calendar.days.${day.name.toLowerCase()}`)), 1),
                                                    _createElementVNode("span", _hoisted_377, _toDisplayString(_unref(t)(`calendar.dayAbbreviations.${day.name.toLowerCase()}`)), 1)
                                                  ])
                                                ]),
                                                (day.enabled)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_378, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": ($event: any) => ((day.startTime) = $event),
                                                        type: "time",
                                                        class: "time-input compact"
                                                      }, null, 8, _hoisted_379), [
                                                        [_vModelText, day.startTime]
                                                      ]),
                                                      _cache[136] || (_cache[136] = _createElementVNode("span", { class: "time-separator" }, "–", -1)),
                                                      _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": ($event: any) => ((day.endTime) = $event),
                                                        type: "time",
                                                        class: "time-input compact"
                                                      }, null, 8, _hoisted_380), [
                                                        [_vModelText, day.endTime]
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_381, [
                                                  (day.enabled)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_382, _toDisplayString(_unref(t)("calendar.settings.active")), 1))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_383, _toDisplayString(_unref(t)("calendar.settings.off")), 1))
                                                ])
                                              ], 2))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_384, [
                                        _createElementVNode("button", {
                                          onClick: saveEmployeeAvailability,
                                          class: "btn-primary",
                                          disabled: savingAvailability.value
                                        }, [
                                          (savingAvailability.value)
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_386))
                                            : (_openBlock(), _createElementBlock("i", _hoisted_387)),
                                          _createTextVNode(" " + _toDisplayString(_unref(t)("calendar.settings.saveWorkingHours")), 1)
                                        ], 8, _hoisted_385)
                                      ])
                                    ]))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (activeTab.value === 'breaks')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_388, [
                              _createElementVNode("div", _hoisted_389, [
                                _createElementVNode("div", _hoisted_390, [
                                  _createElementVNode("h4", null, _toDisplayString(_unref(t)("calendar.settings.breakTimes")), 1),
                                  _createElementVNode("p", null, _toDisplayString(_unref(t)("calendar.settings.breakTimesDescription")), 1),
                                  _createElementVNode("button", {
                                    onClick: addBlockedTime,
                                    class: "add-btn compact"
                                  }, [
                                    _cache[137] || (_cache[137] = _createElementVNode("i", { class: "ri-add-line" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)("calendar.settings.addBreak")), 1)
                                  ])
                                ]),
                                (loadingBreaks.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_391, [
                                      _cache[138] || (_cache[138] = _createElementVNode("i", { class: "ri-loader-5-line animate-spin" }, null, -1)),
                                      _createElementVNode("span", null, _toDisplayString(_unref(t)("calendar.settings.loadingBreaks")), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_392, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blockedTimes.value, (block, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: block.id || index,
                                          class: "break-item"
                                        }, [
                                          _createElementVNode("div", _hoisted_393, [
                                            (block.isEditing)
                                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                  key: 0,
                                                  "onUpdate:modelValue": ($event: any) => ((block.name) = $event),
                                                  type: "text",
                                                  class: "break-name editing",
                                                  placeholder: _unref(t)('calendar.settings.breakNamePlaceholder')
                                                }, null, 8, _hoisted_394)), [
                                                  [_vModelText, block.name]
                                                ])
                                              : (_openBlock(), _createElementBlock("span", _hoisted_395, _toDisplayString(block.name), 1)),
                                            _createElementVNode("div", _hoisted_396, [
                                              (!block.isEditing)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    onClick: ($event: any) => (editBreak(index)),
                                                    class: "edit-btn compact",
                                                    title: _unref(t)('common.edit')
                                                  }, _cache[139] || (_cache[139] = [
                                                    _createElementVNode("i", { class: "ri-edit-line" }, null, -1)
                                                  ]), 8, _hoisted_397))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("button", {
                                                onClick: ($event: any) => (removeBlockedTime(index)),
                                                class: "remove-btn compact",
                                                title: _unref(t)('common.delete'),
                                                disabled: savingBreak.value
                                              }, _cache[140] || (_cache[140] = [
                                                _createElementVNode("i", { class: "ri-delete-bin-line" }, null, -1)
                                              ]), 8, _hoisted_398)
                                            ])
                                          ]),
                                          (block.isEditing)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_399, [
                                                _createElementVNode("div", _hoisted_400, [
                                                  _createElementVNode("label", null, _toDisplayString(_unref(t)("calendar.settings.startTime")) + ":", 1),
                                                  _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": ($event: any) => ((block.startTime) = $event),
                                                    type: "time",
                                                    class: "time-input compact"
                                                  }, null, 8, _hoisted_401), [
                                                    [_vModelText, block.startTime]
                                                  ]),
                                                  _cache[141] || (_cache[141] = _createElementVNode("span", { class: "time-separator" }, "–", -1)),
                                                  _createElementVNode("label", null, _toDisplayString(_unref(t)("calendar.settings.endTime")) + ":", 1),
                                                  _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": ($event: any) => ((block.endTime) = $event),
                                                    type: "time",
                                                    class: "time-input compact"
                                                  }, null, 8, _hoisted_402), [
                                                    [_vModelText, block.endTime]
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_403, [
                                                  _createElementVNode("span", _hoisted_404, _toDisplayString(_unref(t)("calendar.settings.activeDays")) + ":", 1),
                                                  _createElementVNode("div", _hoisted_405, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(daysOfWeek.value, (day) => {
                                                      return (_openBlock(), _createElementBlock("label", {
                                                        key: day.value,
                                                        class: _normalizeClass(["day-pill", { active: block.days.includes(day.value) }])
                                                      }, [
                                                        _withDirectives(_createElementVNode("input", {
                                                          type: "checkbox",
                                                          "onUpdate:modelValue": ($event: any) => ((block.days) = $event),
                                                          value: day.value
                                                        }, null, 8, _hoisted_406), [
                                                          [_vModelCheckbox, block.days]
                                                        ]),
                                                        _createElementVNode("span", null, _toDisplayString(day.label), 1)
                                                      ], 2))
                                                    }), 128))
                                                  ])
                                                ]),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["form-actions", { rtl: isRTL.value }])
                                                }, [
                                                  _createElementVNode("button", {
                                                    onClick: ($event: any) => (cancelEditBreak(index)),
                                                    class: "btn-secondary",
                                                    disabled: savingBreak.value
                                                  }, [
                                                    _cache[142] || (_cache[142] = _createElementVNode("i", { class: "ri-close-line" }, null, -1)),
                                                    _createTextVNode(" " + _toDisplayString(_unref(t)("common.cancel")), 1)
                                                  ], 8, _hoisted_407),
                                                  _createElementVNode("button", {
                                                    onClick: ($event: any) => (saveBreak(block, index)),
                                                    class: "btn-primary",
                                                    disabled: savingBreak.value
                                                  }, [
                                                    (savingBreak.value)
                                                      ? (_openBlock(), _createElementBlock("i", _hoisted_409))
                                                      : (_openBlock(), _createElementBlock("i", _hoisted_410)),
                                                    _createTextVNode(" " + _toDisplayString(_unref(t)("common.save")), 1)
                                                  ], 8, _hoisted_408)
                                                ], 2)
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_411, [
                                                _createElementVNode("div", _hoisted_412, [
                                                  _cache[143] || (_cache[143] = _createElementVNode("i", { class: "ri-time-line" }, null, -1)),
                                                  _createElementVNode("span", null, _toDisplayString(block.startTime) + " - " + _toDisplayString(block.endTime), 1)
                                                ]),
                                                (block.days && block.days.length > 0)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_413, [
                                                      _cache[144] || (_cache[144] = _createElementVNode("i", { class: "ri-calendar-line" }, null, -1)),
                                                      _createElementVNode("span", null, _toDisplayString(getTranslatedDays(block.days).join(", ")), 1)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                        ]))
                                      }), 128)),
                                      (!loadingBreaks.value && blockedTimes.value.length === 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_414, [
                                            _cache[145] || (_cache[145] = _createElementVNode("i", { class: "ri-time-line" }, null, -1)),
                                            _createElementVNode("span", null, _toDisplayString(_unref(t)("calendar.settings.noBreaksDefined")), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (activeTab.value === 'types')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_415, [
                              _createElementVNode("div", _hoisted_416, [
                                _createElementVNode("div", _hoisted_417, [
                                  _createElementVNode("h4", null, _toDisplayString(_unref(t)("calendar.settings.appointmentTypes")), 1),
                                  _createElementVNode("p", null, _toDisplayString(_unref(t)("calendar.settings.appointmentTypesDescription")), 1),
                                  _createElementVNode("button", {
                                    onClick: addAppointmentType,
                                    class: "add-btn compact"
                                  }, [
                                    _cache[146] || (_cache[146] = _createElementVNode("i", { class: "ri-add-line" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)("calendar.settings.newType")), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_418, [
                                  (loadingAppointmentTypes.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_419, [
                                        _cache[147] || (_cache[147] = _createElementVNode("i", { class: "ri-loader-5-line animate-spin" }, null, -1)),
                                        _createElementVNode("span", null, _toDisplayString(_unref(t)("calendar.settings.loadingAppointmentTypes")), 1)
                                      ]))
                                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(appointmentTypes.value, (type, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: type.id || index,
                                          class: "type-item",
                                          style: _normalizeStyle({
                        borderLeftColor: type.colorCode || getColorValue(type.color),
                      })
                                        }, [
                                          _createElementVNode("div", _hoisted_420, [
                                            _createElementVNode("div", {
                                              class: "type-icon",
                                              style: _normalizeStyle({
                            backgroundColor: type.colorCode || getColorValue(type.color),
                          })
                                            }, _cache[148] || (_cache[148] = [
                                              _createElementVNode("i", { class: "ri-calendar-event-line" }, null, -1)
                                            ]), 4),
                                            _createElementVNode("div", _hoisted_421, [
                                              (type.isEditing)
                                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                    key: 0,
                                                    "onUpdate:modelValue": ($event: any) => ((type.name) = $event),
                                                    type: "text",
                                                    class: "type-name editing",
                                                    placeholder: 
                              _unref(t)('calendar.settings.appointmentTypeNamePlaceholder')
                            
                                                  }, null, 8, _hoisted_422)), [
                                                    [_vModelText, type.name]
                                                  ])
                                                : (_openBlock(), _createElementBlock("span", _hoisted_423, _toDisplayString(type.name), 1)),
                                              _createElementVNode("div", _hoisted_424, [
                                                _createElementVNode("span", _hoisted_425, _toDisplayString(type.duration) + " " + _toDisplayString(_unref(t)("calendar.settings.minutes")), 1),
                                                (type.tag)
                                                  ? (_openBlock(), _createElementBlock("span", {
                                                      key: 0,
                                                      class: "tag",
                                                      style: _normalizeStyle({ backgroundColor: type.tagColorCode })
                                                    }, _toDisplayString(type.tag), 5))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_426, [
                                              (!type.isEditing)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    onClick: ($event: any) => (editAppointmentType(index)),
                                                    class: "edit-btn compact",
                                                    title: _unref(t)('common.edit')
                                                  }, _cache[149] || (_cache[149] = [
                                                    _createElementVNode("i", { class: "ri-edit-line" }, null, -1)
                                                  ]), 8, _hoisted_427))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("button", {
                                                onClick: ($event: any) => (removeAppointmentType(index)),
                                                class: "remove-btn compact",
                                                title: _unref(t)('common.delete'),
                                                disabled: savingAppointmentType.value
                                              }, _cache[150] || (_cache[150] = [
                                                _createElementVNode("i", { class: "ri-delete-bin-line" }, null, -1)
                                              ]), 8, _hoisted_428)
                                            ])
                                          ]),
                                          (type.isEditing)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_429, [
                                                _createElementVNode("div", _hoisted_430, [
                                                  _createElementVNode("div", _hoisted_431, [
                                                    _createElementVNode("label", _hoisted_432, [
                                                      _createTextVNode(_toDisplayString(_unref(t)("calendar.settings.duration")) + " (", 1),
                                                      _createElementVNode("span", _hoisted_433, _toDisplayString(_unref(t)("calendar.settings.minutes")), 1),
                                                      _cache[151] || (_cache[151] = _createTextVNode(")"))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_434, [
                                                      _createElementVNode("button", {
                                                        onClick: ($event: any) => (adjustDuration(type, -15)),
                                                        class: "duration-btn"
                                                      }, " - ", 8, _hoisted_435),
                                                      _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": ($event: any) => ((type.duration) = $event),
                                                        type: "number",
                                                        min: "15",
                                                        max: "480",
                                                        step: "15",
                                                        onBlur: ($event: any) => (validateDuration(type)),
                                                        class: "duration-number-input"
                                                      }, null, 40, _hoisted_436), [
                                                        [
                                                          _vModelText,
                                                          type.duration,
                                                          void 0,
                                                          { number: true }
                                                        ]
                                                      ]),
                                                      _createElementVNode("button", {
                                                        onClick: ($event: any) => (adjustDuration(type, 15)),
                                                        class: "duration-btn"
                                                      }, " + ", 8, _hoisted_437)
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_438, [
                                                    _createElementVNode("label", null, _toDisplayString(_unref(t)("calendar.settings.backgroundColor")), 1),
                                                    _createElementVNode("div", _hoisted_439, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colorOptions.value, (color) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                          key: color.value,
                                                          class: _normalizeClass(["color-dot", { active: type.color === color.value }]),
                                                          style: _normalizeStyle({ backgroundColor: color.bg }),
                                                          onClick: ($event: any) => {
                                  type.color = color.value;
                                  type.colorCode = color.bg;
                                },
                                                          title: color.value
                                                        }, null, 14, _hoisted_440))
                                                      }), 128))
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_441, [
                                                  _createElementVNode("div", _hoisted_442, [
                                                    _createElementVNode("label", null, _toDisplayString(_unref(t)("calendar.settings.tag")), 1),
                                                    _withDirectives(_createElementVNode("input", {
                                                      "onUpdate:modelValue": ($event: any) => ((type.tag) = $event),
                                                      type: "text",
                                                      class: "form-input tag-input",
                                                      placeholder: _unref(t)('calendar.settings.tagPlaceholder')
                                                    }, null, 8, _hoisted_443), [
                                                      [_vModelText, type.tag]
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_444, [
                                                    _createElementVNode("label", null, _toDisplayString(_unref(t)("calendar.settings.tagColor")), 1),
                                                    _createElementVNode("div", _hoisted_445, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colorOptions.value, (color) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                          key: 'tag-' + color.value,
                                                          class: _normalizeClass(["color-dot", { active: type.tagColorCode === color.bg }]),
                                                          style: _normalizeStyle({ backgroundColor: color.bg }),
                                                          onClick: ($event: any) => (type.tagColorCode = color.bg),
                                                          title: color.value
                                                        }, null, 14, _hoisted_446))
                                                      }), 128))
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_447, [
                                                  _createElementVNode("div", _hoisted_448, [
                                                    _createElementVNode("label", _hoisted_449, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "checkbox",
                                                        "onUpdate:modelValue": ($event: any) => ((type.canAllUsersSee) = $event)
                                                      }, null, 8, _hoisted_450), [
                                                        [_vModelCheckbox, type.canAllUsersSee]
                                                      ]),
                                                      _createTextVNode(" " + _toDisplayString(_unref(t)("calendar.settings.allUsersCanSee")), 1)
                                                    ])
                                                  ])
                                                ]),
                                                (!type.canAllUsersSee)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_451, [
                                                      _createElementVNode("div", _hoisted_452, [
                                                        _createElementVNode("label", null, _toDisplayString(_unref(t)("calendar.settings.selectSpecificUsers")) + ":", 1),
                                                        (!loadingUsers.value)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_453, [
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
                                                                return (_openBlock(), _createElementBlock("label", {
                                                                  key: user.id,
                                                                  class: "user-checkbox"
                                                                }, [
                                                                  _withDirectives(_createElementVNode("input", {
                                                                    type: "checkbox",
                                                                    value: user.id,
                                                                    "onUpdate:modelValue": ($event: any) => ((type.selectedUsers) = $event)
                                                                  }, null, 8, _hoisted_454), [
                                                                    [_vModelCheckbox, type.selectedUsers]
                                                                  ]),
                                                                  _createElementVNode("span", null, _toDisplayString(user.full_name), 1)
                                                                ]))
                                                              }), 128))
                                                            ]))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_455, [
                                                              _cache[152] || (_cache[152] = _createElementVNode("i", { class: "ri-loader-5-line animate-spin" }, null, -1)),
                                                              _createElementVNode("span", null, _toDisplayString(_unref(t)("calendar.settings.loadingUsers")), 1)
                                                            ]))
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_456, [
                                                  _createElementVNode("div", _hoisted_457, [
                                                    _createElementVNode("label", null, _toDisplayString(_unref(t)("calendar.settings.linkToProduct")), 1),
                                                    (!loadingProducts.value)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_458, [
                                                          _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((productSearchQuery).value = $event)),
                                                            type: "text",
                                                            class: "form-input product-search-input",
                                                            placeholder: 
                                  getSelectedProductName(type.productId) ||
                                  _unref(t)('calendar.settings.searchProductPlaceholder')
                                ,
                                                            onFocus: _cache[38] || (_cache[38] = ($event: any) => (showProductDropdown.value = true)),
                                                            onInput: _cache[39] || (_cache[39] = ($event: any) => (showProductDropdown.value = true))
                                                          }, null, 40, _hoisted_459), [
                                                            [_vModelText, productSearchQuery.value]
                                                          ]),
                                                          (type.productId)
                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                key: 0,
                                                                onClick: ($event: any) => (clearProductSelection(type)),
                                                                class: "clear-product-btn",
                                                                type: "button"
                                                              }, _cache[153] || (_cache[153] = [
                                                                _createElementVNode("i", { class: "ri-close-line" }, null, -1)
                                                              ]), 8, _hoisted_460))
                                                            : _createCommentVNode("", true),
                                                          (
                                  showProductDropdown.value &&
                                  (filteredProducts.value.length > 0 ||
                                    productSearchQuery.value.trim())
                                )
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_461, [
                                                                (
                                    filteredProducts.value.length === 0 &&
                                    productSearchQuery.value.trim()
                                  )
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_462, [
                                                                      _cache[154] || (_cache[154] = _createElementVNode("i", { class: "ri-search-line" }, null, -1)),
                                                                      _createElementVNode("span", null, _toDisplayString(_unref(t)("calendar.settings.noProductResults")) + " \"" + _toDisplayString(productSearchQuery.value) + "\"", 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredProducts.value.slice(0, 10), (product) => {
                                                                  return (_openBlock(), _createElementBlock("div", {
                                                                    key: product.id,
                                                                    onClick: ($event: any) => (selectProduct(product, type)),
                                                                    class: _normalizeClass(["product-option", { selected: type.productId === product.id }])
                                                                  }, [
                                                                    _createElementVNode("div", _hoisted_464, [
                                                                      _createElementVNode("div", _hoisted_465, _toDisplayString(product.title), 1),
                                                                      (product.price)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_466, " ₪" + _toDisplayString(product.price), 1))
                                                                        : _createCommentVNode("", true)
                                                                    ]),
                                                                    (type.productId === product.id)
                                                                      ? (_openBlock(), _createElementBlock("i", _hoisted_467))
                                                                      : _createCommentVNode("", true)
                                                                  ], 10, _hoisted_463))
                                                                }), 128))
                                                              ]))
                                                            : _createCommentVNode("", true)
                                                        ]))
                                                      : (loadingProducts.value)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_468, [
                                                            _cache[155] || (_cache[155] = _createElementVNode("i", { class: "ri-loader-5-line animate-spin" }, null, -1)),
                                                            _createElementVNode("span", null, _toDisplayString(_unref(t)("calendar.settings.loadingProducts")), 1)
                                                          ]))
                                                        : (products.value.length === 0)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_469, [
                                                              _cache[156] || (_cache[156] = _createElementVNode("i", { class: "ri-information-line" }, null, -1)),
                                                              _createElementVNode("span", null, _toDisplayString(_unref(t)("calendar.settings.noProductsFound")), 1)
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                  ])
                                                ]),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["form-actions", { rtl: isRTL.value }])
                                                }, [
                                                  _createElementVNode("button", {
                                                    onClick: ($event: any) => (cancelEditAppointmentType(index)),
                                                    class: "btn-secondary",
                                                    disabled: savingAppointmentType.value
                                                  }, [
                                                    _cache[157] || (_cache[157] = _createElementVNode("i", { class: "ri-close-line" }, null, -1)),
                                                    _createTextVNode(" " + _toDisplayString(_unref(t)("common.cancel")), 1)
                                                  ], 8, _hoisted_470),
                                                  _createElementVNode("button", {
                                                    onClick: ($event: any) => (saveAppointmentType(type, index)),
                                                    class: "btn-primary",
                                                    disabled: savingAppointmentType.value
                                                  }, [
                                                    (savingAppointmentType.value)
                                                      ? (_openBlock(), _createElementBlock("i", _hoisted_472))
                                                      : (_openBlock(), _createElementBlock("i", _hoisted_473)),
                                                    _createTextVNode(" " + _toDisplayString(_unref(t)("common.save")), 1)
                                                  ], 8, _hoisted_471)
                                                ], 2)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 4))
                                      }), 128))
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["settings-footer apple-footer", { rtl: isRTL.value }])
                      }, [
                        _createElementVNode("button", {
                          class: "btn-reset",
                          onClick: resetSettings
                        }, [
                          _cache[158] || (_cache[158] = _createElementVNode("i", { class: "ri-refresh-line" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_unref(t)("common.reset")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_474, [
                          _cache[159] || (_cache[159] = _createElementVNode("i", { class: "ri-information-line" }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(_unref(t)("calendar.settings.changesSavedAutomatically")), 1)
                        ]),
                        _createElementVNode("button", {
                          class: "btn-done",
                          onClick: closeSettingsModal
                        }, [
                          _cache[160] || (_cache[160] = _createElementVNode("i", { class: "ri-check-line" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_unref(t)("common.done")), 1)
                        ])
                      ], 2)
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_475, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toasts.value, (toast) => {
              return (_openBlock(), _createElementBlock("div", {
                key: toast.id,
                class: _normalizeClass(["toast", `toast-${toast.type}`]),
                onClick: ($event: any) => (removeToast(toast.id))
              }, [
                _createElementVNode("div", _hoisted_477, [
                  (toast.type === 'success')
                    ? (_openBlock(), _createElementBlock("i", _hoisted_478))
                    : (toast.type === 'error')
                      ? (_openBlock(), _createElementBlock("i", _hoisted_479))
                      : (toast.type === 'warning')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_480))
                        : (_openBlock(), _createElementBlock("i", _hoisted_481))
                ]),
                _createElementVNode("div", _hoisted_482, [
                  _createElementVNode("span", null, _toDisplayString(toast.message), 1)
                ]),
                _createElementVNode("button", {
                  class: "toast-close",
                  onClick: _withModifiers(($event: any) => (removeToast(toast.id)), ["stop"])
                }, _cache[161] || (_cache[161] = [
                  _createElementVNode("i", { class: "ri-close-line" }, null, -1)
                ]), 8, _hoisted_483)
              ], 10, _hoisted_476))
            }), 128))
          ]),
          (showConfirmPopup.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "popup-overlay",
                onClick: closeConfirmPopup
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["popup-content", `popup-${confirmPopup.value.type}`]),
                  onClick: _cache[41] || (_cache[41] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_484, [
                    _createElementVNode("div", _hoisted_485, [
                      (confirmPopup.value.type === 'success')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_486))
                        : (confirmPopup.value.type === 'danger')
                          ? (_openBlock(), _createElementBlock("i", _hoisted_487))
                          : (confirmPopup.value.type === 'warning')
                            ? (_openBlock(), _createElementBlock("i", _hoisted_488))
                            : (_openBlock(), _createElementBlock("i", _hoisted_489))
                    ]),
                    _createElementVNode("h3", null, _toDisplayString(confirmPopup.value.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_490, [
                    _createElementVNode("p", null, _toDisplayString(confirmPopup.value.message), 1)
                  ]),
                  _createElementVNode("div", _hoisted_491, [
                    _createElementVNode("button", {
                      class: "btn-cancel",
                      onClick: closeConfirmPopup
                    }, _toDisplayString(confirmPopup.value.cancelText), 1),
                    _createElementVNode("button", {
                      class: _normalizeClass(["btn-confirm", `btn-${confirmPopup.value.type}`]),
                      onClick: confirmAction
                    }, _toDisplayString(confirmPopup.value.confirmText), 3)
                  ])
                ], 2)
              ]))
            : _createCommentVNode("", true),
          (showSimpleConfirm.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "popup-overlay",
                onClick: closeSimpleConfirm
              }, [
                _createElementVNode("div", {
                  class: "popup-content popup-warning",
                  onClick: _cache[42] || (_cache[42] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_492, [
                    _cache[162] || (_cache[162] = _createElementVNode("div", { class: "popup-icon" }, [
                      _createElementVNode("i", { class: "ri-question-line" })
                    ], -1)),
                    _createElementVNode("h3", null, _toDisplayString(_unref(t)("common.confirm")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_493, [
                    _createElementVNode("p", null, _toDisplayString(simpleConfirmMessage.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_494, [
                    _createElementVNode("button", {
                      class: "btn-cancel",
                      onClick: closeSimpleConfirm
                    }, _toDisplayString(_unref(t)("common.cancel")), 1),
                    _createElementVNode("button", {
                      class: "btn-confirm btn-warning",
                      onClick: confirmSimpleAction
                    }, _toDisplayString(_unref(t)("common.confirm")), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})